import { Fragment, useEffect, useMemo, useRef, useState } from 'react'
import {
  Card,
  Typography,
  Stack,
  ImageList,
  ImageListItem,
  ListSubheader,
  ImageListItemBar,
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  AvatarGroup,
  Tooltip,
  Avatar,
  Snackbar,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  makeStyles,
  Skeleton,
  Paper,
  Badge,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import {
  ThumbUpAltOutlined,
  ThumbDownOffAltOutlined,
  CancelOutlined,
  Link,
  Notes,
  Description,
  PictureAsPdf,
  ArrowRightOutlined,
  ArrowLeftOutlined,
  Info,
  GetAppOutlined,
} from '@material-ui/icons'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import jsPDF from 'jspdf'
import { sentenceCase } from 'change-case'
import moment from 'moment'
import { formatDateOnly } from 'src/utils/dateOnly'
import Scrollbar from 'src/components/Scrollbar'
import {
  ref as imageref,
  uploadBytesResumable,
  getDownloadURL,
} from '@firebase/storage'
import { storage } from 'src/firebase/firebase'
import { REST_API_END_POINT, UNITS, currentFacilityId, FacilityTypes, REST_API } from 'src/constants/Defaultvalues'
import { useSnackbar } from 'notistack'
import axios from 'axios'
import { LoadingButton } from '@material-ui/lab'
import { UserMoreMenu } from '../user/list'
import Label from 'src/components/Label'
import Modal from '../blog/ProjectModel'
import { AccountNotifications } from '../user/account'
import { empty } from 'src/Helpers/Common'
import { PRESERVE_WHITESPACE_SX } from 'src/utils/preserveWhitespace'
import { fUSPrice } from 'src/utils/formatNumber'
import { calcRushFeeAmount, calcTotalWithRushFee } from 'src/utils/rushFee'
import { getSalesOrderDisplayJobNumber } from 'src/utils/salesOrderDisplayNumbers'
import { Icon } from '@iconify/react'
import arrowLeftOutlined from '@iconify/icons-ant-design/arrow-left-outlined';
import arrowRightOutlined from '@iconify/icons-ant-design/arrow-right-outlined';
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { isAdminUser } from '../../../utils/adminUserTypes';
import { DialogAnimate } from 'src/components/animate'
import RequestProgressModal from 'src/components/RequestProgressModal'
import filePdfIcon from '@iconify/icons-mdi/file-pdf';
import emailFillIcon from '@iconify/icons-eva/email-fill';
import SendDesignsEmailModal from 'src/components/_dashboard/official-request/SendDesignsEmailModal';
import PDFEditor from 'src/components/_dashboard/official-request/PDFEditor';
import AttachmentDownloadIconButton from 'src/components/_dashboard/official-request/AttachmentDownloadIconButton';
import AttachmentDownloadAllButton from 'src/components/_dashboard/official-request/AttachmentDownloadAllButton';
import React from 'react'

const sortCustomerProductsByIndex = (products) =>
  [...(products || [])].sort(
    (a, b) => Number(a?.product_index || 0) - Number(b?.product_index || 0),
  )

const sortAdditionalServicesByIndex = (services) =>
  [...(services || [])].sort(
    (a, b) =>
      (Number(a?.product_index ?? a?.newIndexId ?? a?.indexId) || 0) -
      (Number(b?.product_index ?? b?.newIndexId ?? b?.indexId) || 0),
  )
import { supabase } from '../../../supabase/supabaseClient';
import AVALARALOGO from 'src/assets/Avalara_Logo.png';
import EditIcon from '@material-ui/icons/Edit';
import ViewProductFormulaModal from 'src/components/ViewProductFormulaModal'
import { canShowProductFormulaIcon } from 'src/utils/retailPriceEdit'
import {
  downloadFileFromUrl,
  downloadImage,
  openFileInViewer,
  isOfficeFile,
  isPdfFile,
} from 'src/Helpers/FileDownloadUtils'
import { getGroupInstallNotesDisplay, getGroupLosingMoneyFlags } from 'src/pages/dashboard/quotation/quotationGroupingHelpers'
import { buildGroupedDesignOrderDisplayRows } from 'src/utils/designOrderInvoiceUtils'

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}));

const RowResultStyleTax = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    // display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  }
}));

const getInstallationStatusLabel = (status) => {
  const labels = { 1: 'Installs', 2: 'Pickup', 3: 'Shipping' };
  return labels[status] || '';
};

const getRejectFileMeta = (file) => {
  const fileExt = file.url?.split('/').pop()?.split('?')[0]?.split('.').pop()?.toLowerCase();
  const isPdf = file.file_type === 'application/pdf' || fileExt === 'pdf';
  const isImage =
    file.file_type?.startsWith('image/') ||
    ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(fileExt);
  return { ...file, fileExt, isPdf, isImage, isDocument: isPdf || !isImage };
};

const openRejectAttachmentViewer = (fileUrl, fileType) => {
  const fileName = fileUrl?.split('/').pop()?.split('?')[0] || 'File';
  const fileExt = fileName.split('.').pop()?.toLowerCase();
  const isOfficeFile = ['xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx', 'csv'].includes(fileExt);
  const isPdf = fileType === 'application/pdf' || fileExt === 'pdf';
  const newWindow = window.open('', '_blank');

  if (isPdf) {
    newWindow.document.write(`
      <html>
        <head>
          <title>PDF Viewer</title>
          <style>
            body { margin: 0; padding: 0; overflow: hidden; }
            iframe { width: 100vw; height: 100vh; border: none; }
          </style>
        </head>
        <body>
          <iframe src="${fileUrl}#toolbar=0&navpanes=0&scrollbar=0" title="PDF Viewer"></iframe>
        </body>
      </html>
    `);
  } else if (isOfficeFile) {
    const officeViewerSrc = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;
    newWindow.document.write(`
      <html>
        <head>
          <title>${fileName}</title>
          <style>
            body { margin: 0; padding: 0; overflow: hidden; }
            iframe { width: 100vw; height: 100vh; border: none; }
          </style>
        </head>
        <body>
          <iframe src="${officeViewerSrc}" title="${fileName}"></iframe>
        </body>
      </html>
    `);
  } else if (fileType?.startsWith('image/')) {
    newWindow.document.write(`
      <html>
        <head>
          <title>Image Viewer</title>
          <style>
            body { margin: 0; padding: 0; overflow: hidden; display: flex; align-items: center; justify-content: center; background: #111; }
            img { max-width: 100%; max-height: 100vh; }
          </style>
        </head>
        <body>
          <img src="${fileUrl}" alt="Image"/>
        </body>
      </html>
    `);
  } else {
    const googleViewerSrc = `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
    newWindow.document.write(`
      <html>
        <head>
          <title>${fileName}</title>
          <style>
            body { margin: 0; padding: 0; overflow: hidden; }
            iframe { width: 100vw; height: 100vh; border: none; }
          </style>
        </head>
        <body>
          <iframe src="${googleViewerSrc}" title="${fileName}" sandbox="allow-scripts allow-same-origin"></iframe>
        </body>
      </html>
    `);
  }
  newWindow.document.close();
};

function RejectAttachmentsPreview({ files }) {
  const sm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [openAllModal, setOpenAllModal] = useState(false);
  const fileItems = files.map(getRejectFileMeta);
  const imageFiles = fileItems.filter((file) => file.isImage);
  const documentFiles = fileItems.filter((file) => file.isDocument);

  if (!fileItems.length) return null;

  const stackLayers = imageFiles.slice(0, 3);
  const stackOffset = 10;
  const thumbSize = 120;
  const stackWidth = thumbSize + (stackLayers.length > 1 ? (stackLayers.length - 1) * stackOffset : 0);
  const stackHeight = thumbSize + (stackLayers.length > 1 ? (stackLayers.length - 1) * stackOffset : 0);
  const showViewAll = fileItems.length > 1 || imageFiles.length > 0;

  return (
    <>
      {imageFiles.length > 0 && (
        <Box
          sx={{
            position: 'relative',
            width: stackWidth,
            height: stackHeight,
            mb: 1.5,
            cursor: 'pointer',
          }}
          onClick={() => setOpenAllModal(true)}
        >
          {stackLayers.map((file, index) => (
            <Box
              key={`${file.url}-stack-${index}`}
              component="img"
              src={file.url}
              alt="Reject attachment"
              sx={{
                position: 'absolute',
                top: index * stackOffset,
                left: index * stackOffset,
                width: thumbSize,
                height: thumbSize,
                borderRadius: 1,
                border: '2px solid #fff',
                objectFit: 'cover',
                boxShadow: 3,
                zIndex: 10 - index,
                bgcolor: '#1a1a1a',
              }}
            />
          ))}
          {imageFiles.length > 3 && (
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                right: 0,
                minWidth: 28,
                height: 28,
                px: 0.75,
                bgcolor: 'primary.main',
                color: '#fff',
                borderRadius: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 700,
                zIndex: 20,
                border: '2px solid #fff',
              }}
            >
              +{imageFiles.length - 3}
            </Box>
          )}
        </Box>
      )}

      {fileItems.length === 1 && documentFiles.length === 1 && imageFiles.length === 0 ? (
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          onClick={() => openRejectAttachmentViewer(documentFiles[0].url, documentFiles[0].file_type)}
        >
          View Attached File{documentFiles[0].isPdf ? ' (PDF)' : ''}
        </Button>
      ) : showViewAll ? (
        <Button variant="outlined" color="primary" fullWidth onClick={() => setOpenAllModal(true)}>
          View All ({fileItems.length})
        </Button>
      ) : null}

      <Modal
        width={900}
        open={openAllModal}
        handleClose={() => setOpenAllModal(false)}
        modalTitle="Reject Attachments"
      >
        <Stack spacing={2}>
          {imageFiles.length > 0 && (
            <ImageList cols={sm ? 2 : 3} gap={12} sx={{ width: '100%', m: 0 }}>
              {imageFiles.map((file, index) => (
                <ImageListItem
                  key={`${file.url}-modal-img-${index}`}
                  sx={{ cursor: 'pointer' }}
                  onClick={() => openRejectAttachmentViewer(file.url, file.file_type)}
                >
                  <img
                    src={file.url}
                    alt={`Attachment ${index + 1}`}
                    style={{
                      width: '100%',
                      height: 160,
                      objectFit: 'cover',
                      borderRadius: 8,
                      border: '1px solid #ccc',
                    }}
                  />
                </ImageListItem>
              ))}
            </ImageList>
          )}
          {documentFiles.map((file, index) => (
            <Button
              key={`${file.url}-modal-doc-${index}`}
              variant="outlined"
              color="primary"
              fullWidth
              onClick={() => openRejectAttachmentViewer(file.url, file.file_type)}
            >
              View Attached File{file.isPdf ? ' (PDF)' : ''} {documentFiles.length > 1 ? index + 1 : ''}
            </Button>
          ))}
        </Stack>
      </Modal>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  attachmentBox: {
      cursor: 'pointer',
      display: 'flex',
      borderRadius: '6px',
      backgroundColor: '#172e34',
      padding: theme.spacing(1),
      margin: theme.spacing(1, 0),
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative', 
      height: '100px', 
      overflow: 'hidden'
  },
  attachmentIcon: {
      marginRight: theme.spacing(1),
  },
  delete:{
      m:2,
      display:'flex',
      justifyContent:'flex-end' 
    },
  checkbox: {
      position: 'absolute',
      top: theme.spacing(1), 
      right: theme.spacing(1), 
  },
  checkboxContainer: {
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(1),
  },
  dialogContent: {
      padding: theme.spacing(3),
      maxWidth: 768,
      margin: 'auto',
      display: 'flex',
      flexDirection:'column',
      justifyContent: 'center',
      alignItems: 'center',
  },
  gridContainer: {
      height: 'auto',
  },
}));

export default function viewRequest({
designs=[],
  fromProposal,
  products,
  productsWithLocation,
  user,
  setDesigns,
  fromQtuotation,
  details,
  fetchRequestDetails,
  // fetchRequestDetailsNew,
  isRequest,
  requestId,
  signAgreements,
  customTemplate,
  questionnaireTemplate,
  allDataEmpty,
  portfolio,
  project,
  clientDetails,
  teamMembers,
  invoice,
  setInvoice,
  quotation,
  proposalView,
  setRenderCards,
  renderCards,
  rfpServicesEdit,
  requestServices,
  labourInstallService,
  explodedPermissions,
  isEstimate,
  designersList,
  incomingSplitMarkup = 0,
  isMirrored,
  unlinkedLocations = [],
  splitIntiator,
  allTeamMembers=[],
  onlineUsers=[],
  collaborators: collaboratorsProp=[],
  collaboratorsTeamMembers=[],
  hasViewCostPermission=true,
  // isSalesOrderss=false,
  fromSalesOrder,
  taxRateData,
  totalTaxRate,
  taxAmount,
  depositAndProgressBilling,
  rushFeePercentage = 0,
  rushFeeEnabled,
}) {
  const fileInputRef = useRef(null)
  const theme = useTheme()
  const { enqueueSnackbar } = useSnackbar()
  const isGroupedInvoiceCombined = Number(details?.is_grouped_invoice_combined || 0) === 1;
  const isGroupedParentRequest = Number(details?.is_grouped_request || 0) === 1;
  const groupedInvoiceMembers = Array.isArray(details?.grouped_invoice_members)
    ? details.grouped_invoice_members
    : [];
  const hasGroupedMemberDetails = groupedInvoiceMembers.length > 0
    && (isGroupedInvoiceCombined || isGroupedParentRequest);
  const hasNonTmGroupedMember = hasGroupedMemberDetails
    && groupedInvoiceMembers.some(
      (m) => Number(m?.requestDetails?.project_category) !== 12,
    );
  const treatInvoiceAsTimeMaterial = Number(invoice?.project_category) === 12 && !hasNonTmGroupedMember;
  const useTmProductLayout = details?.job_category_name == 'Time & Material' && !hasNonTmGroupedMember;
  const {
    id,
    doc_number,
    est_doc_number,
    po_number,
    installation_acceptance,
    community_name,
    added_by_name,
    name,
    notes,
    description,
    services,
    submission_deadline,
    participation_ends,
    installation_start_date,
    installation_end_date,
    status,
    reason,
    edit_reason,
    reject_file,
    reject_file_type,
    manager_reject_reason,
    manager_reject_file,
    manager_reject_file_type,
    manager_approval_required,
    send_to_client,
    quotation_status,
    reasonWithQb,
    estimate_id,
    invoice_qb_id,
    added_by,
    awarded,
    rfpQbId,
    collaborators,
    isFromDesignOrder,
    design_order_id,
    job_category_name,
    avalara_code,
    ship_to,
    bill_to,
    syncWithQuickbooks
  } = details
  console.log('designsdesignsdesignsdesigns', labourInstallService)
  console.log('detailsdetailsdetailsdetails', details)
  // console.log("taxratesdlsdls'lfs'fls'f'sfsfs",taxRateData);
  
  const formattedDescription = Array.isArray(details?.description_lines) && details.description_lines.length
    ? details.description_lines.join('\n')
    : description || '';
  const formattedNotes = Array.isArray(details?.notes_lines) && details.notes_lines.length
    ? details.notes_lines.join('\n')
    : notes || '';

  const taxRateItems = Array.isArray(taxRateData)
    ? taxRateData
    : (Array.isArray(taxRateData?.items) ? taxRateData.items : []);

  const getTaxPercent = (matchingItem) => {
    if (matchingItem && matchingItem.tax_percent !== null && matchingItem.tax_percent !== undefined) {
      return matchingItem.tax_percent;
    }
    const totalPercent = taxRateData?.total_tax_percent ?? taxRateData?.total_tax_rate;
    if (totalPercent !== null && totalPercent !== undefined) {
      return totalPercent;
    }
    const found = taxRateItems.find(item => item && item.tax_percent !== null && item.tax_percent !== undefined);
    if (found) return found.tax_percent;
    return '';
  };

  const submissionDate = formatDateOnly(submission_deadline)
  const endDate = installation_start_date && installation_end_date 
    ? `${formatDateOnly(installation_start_date)} - ${formatDateOnly(installation_end_date)}`
    : formatDateOnly(participation_ends)

  const orderDetailSections = useMemo(() => {
    const buildSection = (sd, sClient, sTeam, sDesigners) => {
      const sDescription = Array.isArray(sd?.description_lines) && sd.description_lines.length
        ? sd.description_lines.join('\n')
        : sd?.description || '';
      const sNotes = Array.isArray(sd?.notes_lines) && sd.notes_lines.length
        ? sd.notes_lines.join('\n')
        : sd?.notes || '';
      const sSubmissionDate = sd?.submission_deadline
        ? formatDateOnly(sd.submission_deadline)
        : '';
      const sEndDate = sd?.installation_start_date && sd?.installation_end_date
        ? `${formatDateOnly(sd.installation_start_date)} - ${formatDateOnly(sd.installation_end_date)}`
        : sd?.participation_ends
          ? formatDateOnly(sd.participation_ends)
          : '';
      return {
        sd,
        sClient,
        sTeam,
        sDesigners,
        formattedDescription: sDescription,
        formattedNotes: sNotes,
        submissionDate: sSubmissionDate,
        endDate: sEndDate,
      };
    };

    if (
      isGroupedInvoiceCombined
      && groupedInvoiceMembers.length > 0
    ) {
      return groupedInvoiceMembers.map((member) => buildSection(
        member.requestDetails,
        member.clientDetails,
        member.teamMembers || [],
        member.designersList || [],
      ));
    }

    return [buildSection(details, clientDetails, teamMembers, designersList)];
  }, [isGroupedInvoiceCombined, groupedInvoiceMembers, details, clientDetails, teamMembers, designersList]);

  const groupedMemberDetailSections = useMemo(() => {
    const buildSection = (sd, sClient, sTeam, sDesigners) => {
      const sDescription = Array.isArray(sd?.description_lines) && sd.description_lines.length
        ? sd.description_lines.join('\n')
        : sd?.description || '';
      const sNotes = Array.isArray(sd?.notes_lines) && sd.notes_lines.length
        ? sd.notes_lines.join('\n')
        : sd?.notes || '';
      const sSubmissionDate = sd?.submission_deadline
        ? formatDateOnly(sd.submission_deadline)
        : '';
      const sEndDate = sd?.installation_start_date && sd?.installation_end_date
        ? `${formatDateOnly(sd.installation_start_date)} - ${formatDateOnly(sd.installation_end_date)}`
        : sd?.participation_ends
          ? formatDateOnly(sd.participation_ends)
          : '';
      return {
        sd,
        sClient,
        sTeam,
        sDesigners,
        formattedDescription: sDescription,
        formattedNotes: sNotes,
        submissionDate: sSubmissionDate,
        endDate: sEndDate,
      };
    };

    if (!isGroupedParentRequest || isGroupedInvoiceCombined || groupedInvoiceMembers.length === 0) {
      return [];
    }

    return groupedInvoiceMembers.map((member) => buildSection(
      member.requestDetails,
      member.clientDetails,
      member.teamMembers || [],
      member.designersList || [],
    ));
  }, [isGroupedParentRequest, isGroupedInvoiceCombined, groupedInvoiceMembers]);

  const detailSectionsForRender = useMemo(() => {
    const items = orderDetailSections.map((section) => ({
      section,
      useAccordion: isGroupedInvoiceCombined,
      showGroupedHeading: false,
    }));

    groupedMemberDetailSections.forEach((section, index) => {
      items.push({
        section,
        useAccordion: true,
        showGroupedHeading: index === 0,
      });
    });

    return items;
  }, [orderDetailSections, groupedMemberDetailSections, isGroupedInvoiceCombined]);


  const [calculatedPaidAmount, setCalculatedPaidAmount] = useState(details?.totalPaidAmount || 0);
  const [calculatedDueAmount, setCalculatedDueAmount] = useState(details?.dueAmount || 0);

  useEffect(() => {
    const fetchPaymentsAndCalculate = async () => {
      try {
        const res = await axios.post(`${REST_API_END_POINT}request/fetch-all-payments`, { request_id: details?.id });
        if (res?.data?.payments) {
          const payments = res.data.payments;
          const hasPartialAmount = payments.some((payment) => payment.partialAmount != null);
          
          let paidPayments = [];
          if (hasPartialAmount) {
            paidPayments = payments.filter((payment) => payment.partialAmount != null);
          } else {
            paidPayments = payments.filter((payment) => [1, 2].includes(Number(payment.markAsPaid ?? 1)));
          }

          const totalPaid = paidPayments.reduce((accumulator, currentValue) => {
            return accumulator + parseFloat(currentValue.partialAmount || currentValue.amount || 0);
          }, 0);

          setCalculatedPaidAmount(totalPaid);
          
          const totalOriginal = parseFloat(details?.dueAmount || 0) + parseFloat(details?.totalPaidAmount || 0);
          setCalculatedDueAmount(totalOriginal - totalPaid);
        } else {
          setCalculatedPaidAmount(details?.totalPaidAmount || 0);
          setCalculatedDueAmount(details?.dueAmount || 0);
        }
      } catch (err) {
        setCalculatedPaidAmount(details?.totalPaidAmount || 0);
        setCalculatedDueAmount(details?.dueAmount || 0);
      }
    };

    if (details?.id) {
      fetchPaymentsAndCalculate();
    }
  }, [details?.id, details?.totalPaidAmount, details?.dueAmount]);
  const xs = useMediaQuery(theme.breakpoints.down('xs'))
  const sm = useMediaQuery(theme.breakpoints.down('sm'))
  const mdd = useMediaQuery(theme.breakpoints.down('md'))
  const xld = useMediaQuery(theme.breakpoints.up('xl'))
  const [progress, setProgress] = useState(false)
  const [modalClose, setModalClose] = useState(false)
  const [openProductModel, setOpenProductModel] = useState(false)
  const [openReasonModal, setOpenReasonModal] = useState(false)
  const [itemId, setItemId] = useState(null)
  const [reasonText, setReasonText] = useState('')
  const [openImageModal,setOpenImageModal] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(null);

  // 🚀 PROGRESS TRACKING: Socket progress modal state
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [progressRequestData, setProgressRequestData] = useState(null);
  const [socketReady, setSocketReady] = useState(false);
  const [progressHeading, setProgressHeading] = useState('');

  const [additionalSelectedServices, setAdditionalSelectedServices] = useState([]);
  const [invoiceSelectedServices, setInvoiceSelectedServices] = useState([]);
  const [cartService, setCartService] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [customerOrderProductGroups, setCustomerOrderProductGroups] = useState([]);

  const classes = useStyles();
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(true);
  const [useOfficeViewer, setUseOfficeViewer] = useState(true);

  const [selectedSecondPDF, setSelectedSecondPDF] = useState(null);
  const [openPDFSecondModal, setOpenPDFSecondModal] = useState(false);
  const [pdfSecondLoading, setPdfSecondLoading] = useState(true);
  const [useOfficeViewerSecond, setUseOfficeViewerSecond] = useState(true);
  // Universal file viewer (WebViewer-based) for EPS / AI / PSD and all formats
  const [openFileViewer, setOpenFileViewer] = useState(false);
  const [fileViewerUrl, setFileViewerUrl] = useState(null);
  const [fileViewerItem, setFileViewerItem] = useState(null);
  const [selectedDesignsInModal, setSelectedDesignsInModal] = useState([]);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [emailModalDesigns, setEmailModalDesigns] = useState([]);
  const [selectedPDFItem, setSelectedPDFItem] = useState(null);
  const [isUnlinkMode, setIsUnlinkMode] = useState(false);
  const [linkTargetType, setLinkTargetType] = useState('product'); // 'product' | 'service' - used for Link/Unlink picker
  const [showAllCollaborators, setShowAllCollaborators] = useState(false);

  const [openPDFEditor, setOpenPDFEditor] = useState(false);
  const [selectedPDFForEdit, setSelectedPDFForEdit] = useState(null);
     const [openProductFormulaModal, setOpenProductFormulaModal] = useState(false);
  const [selectedProductFormulaId, setSelectedProductFormulaId] = useState(null);

  const isClient = user?.isClient;
  let userType = isClient ? 3 : user.user_type
  const canDownloadFiles = !isClient && userType !== 3
  let userId = user.user_id
  if(user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType = 3 //user.parent_user_type
  }
  
  let subTotal = treatInvoiceAsTimeMaterial ? invoice?.jobcostTotal + 0 : 0 //invoice?.sub_total 
  console.log('#Invoice##########', invoice)
  console.log('productsWithLocation', productsWithLocation)

  useEffect(() => {
    let active = true
    const fetchRequestGroups = async () => {
      if (!id) return
      try {
        const response = await axios.post(`${REST_API}webservice/view-request-groups`, {
          request_id: id,
        })
        if (!active) return
        setCustomerOrderProductGroups(response?.data?.customerOrderProductGroups || [])
      } catch (error) {
        if (!active) return
        setCustomerOrderProductGroups([])
        console.log('Error fetching request groups', error)
      }
    }
    fetchRequestGroups()
    return () => {
      active = false
    }
  }, [id])

  const getProductGroupId = (product) =>
    product?.group_id ??
    product?.customer_order_product_group_id ??
    product?.groupId ??
    null

  const getProductLineTotalExcludingInstall = (product) => {
    const quantity = Number(product?.quantity) || 1
    const locationQuantity = Number(product?.locationQuantity) || 1
    const installCost = Number(product?.install_cost) || 0
    let spma = Number(product?.product_retail_price || 0)
    if (Number(product?.material) === 1) {
      const adjustment = Number(product?.adjustment || 0)
      spma += Number(product?.adj_value_type) === 1 ? adjustment : -adjustment
    }
    if (installCost) {
      return (Number(product?.actual_retail_price) || 0) * (locationQuantity * quantity)
    }
    if (Number(product?.material) === 1) {
      return spma * locationQuantity
    }
    return spma * (locationQuantity * quantity)
  }

  const getProductDisplayTotal = (product) => {
    const quantity = Number(product?.quantity) || 1
    const locationQuantity = Number(product?.locationQuantity) || 1
    const installQty = Number(product?.install_qty ?? product?.install_quantity ?? 1) || 1
    const installCost = Number(product?.install_cost) || 0
    let spma = Number(product?.product_retail_price || 0)
    if (Number(product?.material) === 1) {
      const adjustment = Number(product?.adjustment || 0)
      spma += Number(product?.adj_value_type) === 1 ? adjustment : -adjustment
    }
    const productTotal = installCost
      ? (Number(product?.actual_retail_price) || 0) * (locationQuantity * quantity)
      : Number(product?.material) === 1
      ? spma * locationQuantity
      : spma * (locationQuantity * quantity)
    const installTotal = installCost * installQty
    return Number(productTotal || 0) + Number(installTotal || 0)
  }

  const groupedInvoiceDisplayRows = React.useMemo(
    () =>
      buildGroupedDesignOrderDisplayRows({
        designOrderProducts: invoice?.cust_product || [],
        customerOrderProductGroups,
        markupType: Number(details?.markup_type) || 2,
      }),
    [invoice?.cust_product, customerOrderProductGroups, details?.markup_type],
  )

  const productGroupMetaById = React.useMemo(
    () =>
      new Map((customerOrderProductGroups || []).map((g) => [String(g?.id), g])),
    [customerOrderProductGroups],
  )

  const copIdToGroupId = React.useMemo(() => {
    const map = new Map()
    ;(invoice?.cust_product || []).forEach((p) => {
      const gid = getProductGroupId(p)
      if (gid != null && gid !== '' && p?.id != null) {
        map.set(String(p.id), String(gid))
      }
    })
    return map
  }, [invoice?.cust_product])

  const getDesignDisplayMeta = React.useCallback(
    (productNames) => {
      if (!Array.isArray(productNames) || productNames.length === 0) {
        return { displayProductNames: productNames || [], _groupAttachment: false }
      }
      const groupIds = [
        ...new Set(
          productNames
            .map((p) => copIdToGroupId.get(String(p?.product_id)))
            .filter((gid) => gid != null && gid !== ''),
        ),
      ]
      const isSameGroup =
        groupIds.length === 1 &&
        productNames.length > 0 &&
        productNames.every(
          (p) => copIdToGroupId.get(String(p?.product_id)) === groupIds[0],
        )
      if (isSameGroup && productNames.length > 1) {
        const groupId = groupIds[0]
        const groupMeta = productGroupMetaById.get(groupId) || {}
        const groupName =
          groupMeta?.name || groupMeta?.group_name || groupMeta?.groupName || 'Group'
        return {
          displayProductNames: [{ product_id: groupId, product_name: groupName }],
          _groupAttachment: true,
        }
      }
      const unique = [...new Map(productNames.map((p) => [p.product_id, p])).values()]
      return { displayProductNames: unique, _groupAttachment: false }
    },
    [copIdToGroupId, productGroupMetaById],
  )

  const designsForDisplay = React.useMemo(() => {
    if (!designs?.length) return []
    const byUrl = new Map()
    designs.forEach((item) => {
      const fileKey = item.url || item.name || String(item.id)
      if (!byUrl.has(fileKey)) {
        byUrl.set(fileKey, {
          ...item,
          productNames: [...(item.productNames || [])],
        })
      } else {
        const existing = byUrl.get(fileKey)
        const mergedNames = [
          ...(existing.productNames || []),
          ...(item.productNames || []),
        ]
        existing.productNames = [
          ...new Map(mergedNames.map((p) => [p.product_id, p])).values(),
        ]
        const mergedLocIds = [
          ...(existing.location_ids || '').toString().split(','),
          ...(item.location_ids || '').toString().split(','),
        ]
          .map((id) => id.trim())
          .filter(Boolean)
        existing.location_ids = [...new Set(mergedLocIds)].join(',')
      }
    })
    return [...byUrl.values()].map((item) => {
      const meta = getDesignDisplayMeta(item.productNames)
      return { ...item, ...meta }
    })
  }, [designs, getDesignDisplayMeta])

  const groupedLinkableProducts = React.useMemo(() => {
    const items = (productsWithLocation || []).filter(
      (p) => p?.material === 0 && p?.rfp === 0,
    )
    const copById = new Map(
      (invoice?.cust_product || []).map((p) => [String(p.id), p]),
    )
    const seenGroups = new Set()
    const grouped = []
    const ungrouped = []

    items.forEach((locRow) => {
      const cop = copById.get(String(locRow.id))
      const gid = cop ? getProductGroupId(cop) : getProductGroupId(locRow)
      if (gid == null || gid === '') {
        ungrouped.push(locRow)
        return
      }
      const gidStr = String(gid)
      if (seenGroups.has(gidStr)) return
      seenGroups.add(gidStr)
      const members = items.filter((row) => {
        const memberCop = copById.get(String(row.id))
        const rowGid = memberCop
          ? getProductGroupId(memberCop)
          : getProductGroupId(row)
        return String(rowGid || '') === gidStr
      })
      if (members.length <= 1) {
        ungrouped.push(...members)
        return
      }
      const groupMeta = productGroupMetaById.get(gidStr) || {}
      grouped.push({
        ...members[0],
        product_name:
          groupMeta?.name || groupMeta?.group_name || groupMeta?.groupName || 'Group',
        product_notes: null,
        _isGroupPickerRow: true,
        _groupId: gidStr,
        _memberLocationIds: members.map((m) => m.request_location_id),
      })
    })
    return [...grouped, ...ungrouped]
  }, [productsWithLocation, invoice?.cust_product, productGroupMetaById])

  const getRequestInvoiceNonGroupProductTotal = React.useCallback((val) => {
    const {
      markAdjType,
      material = 0,
      adjustment = 0,
      adj_value_type,
      actual_retail_price,
      product_retail_price,
      locationQuantity = 1,
      quantity = 1,
    } = val
    const basePrice =
      actual_retail_price !== 0 && actual_retail_price != null
        ? actual_retail_price
        : product_retail_price
    let SPMA = markAdjType === 2 || markAdjType === 3 ? basePrice : basePrice
    if (material === 1) {
      SPMA = Number(SPMA) + (Number(adj_value_type) === 1 ? Number(adjustment) : -Number(adjustment))
    }
    if (markAdjType === 1 && material === 0) {
      return SPMA * (locationQuantity * quantity)
    }
    return material === 1 ? SPMA * locationQuantity : SPMA * (locationQuantity * quantity)
  }, [])

  const requestInvoiceProductTotalFromRows = React.useMemo(
    () =>
      (groupedInvoiceDisplayRows || []).reduce((sum, row) => {
        if (row?.__type === 'group') {
          const groupHasInstall = Boolean(row?.groupHasInstall)
          return (
            sum +
            (groupHasInstall ? Number(row?.groupProductOnlyTotal ?? 0) : Number(row?.totalValue ?? 0))
          )
        }
        return sum + getRequestInvoiceNonGroupProductTotal(row)
      }, 0),
    [groupedInvoiceDisplayRows, getRequestInvoiceNonGroupProductTotal],
  )

  const requestInvoiceInstallTotalFromRows = React.useMemo(
    () =>
      (groupedInvoiceDisplayRows || []).reduce((sum, row) => {
        if (row?.__type === 'group') {
          return sum + Number(row?.groupInstallSubtotal ?? 0)
        }
        const installCost = parseFloat(row?.install_cost || 0)
        const qty = parseFloat(row?.install_qty ?? row?.install_quantity ?? 1)
        if (installCost) return sum + installCost * qty
        return sum
      }, 0),
    [groupedInvoiceDisplayRows],
  )

  const requestInvoiceCustProductSubtotalForServices = React.useMemo(
    () => requestInvoiceProductTotalFromRows + requestInvoiceInstallTotalFromRows,
    [requestInvoiceProductTotalFromRows, requestInvoiceInstallTotalFromRows],
  )

  const groupedCombinedDisplayTotal = React.useMemo(() => {
    if (!hasNonTmGroupedMember) {
      return Number(invoice?.total || 0);
    }
    const productAndInstall = treatInvoiceAsTimeMaterial
      ? Number(subTotal || 0)
      : Number(requestInvoiceCustProductSubtotalForServices || 0);
    const servicesTotal =
      (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
      (cartService?.reduce((s, x) => {
        const sp = x.sellingPrice || x.unit_cost || 0;
        const markup = x.originalMarkup || x.product_markup || 0;
        const final = sp + (sp * markup / 100);
        return s + ((x.qty || 0) * final);
      }, 0) || 0);
    return (
      productAndInstall +
      servicesTotal -
      Number(invoice?.extra_discount || 0) +
      Number(invoice?.tax_amount || 0)
    );
  }, [
    hasNonTmGroupedMember,
    treatInvoiceAsTimeMaterial,
    subTotal,
    requestInvoiceCustProductSubtotalForServices,
    additionalSelectedServices,
    cartService,
    invoice?.extra_discount,
    invoice?.tax_amount,
    invoice?.total,
  ]);

  const invoiceDisplayTotal = hasNonTmGroupedMember
    ? groupedCombinedDisplayTotal
    : (invoice?.total || 0);

  // Parent passes rushFeeEnabled from sales-order view/edit; if omitted, use saved flag only
  const showRushFee =
    rushFeeEnabled === undefined || rushFeeEnabled === null
      ? Number(details?.rush_fee) === 1 || Number(details?.rush) === 1
      : !!(rushFeeEnabled === true || rushFeeEnabled === 1 || Number(rushFeeEnabled) === 1);

  const getStatusColorAndLabel = (
    status,
    installationStatus,
    allInstallationCompleted,
    accepted,
    min_payment_status,
    job_category_name,
    billing_type,
    installationCompleteStatus = null,
    noServiceNoTask,
    proj_status,
    partial_install,
    received_status,
    split_mirror_status = null,
    fromMirror = false
  ) => {
console.log('installationStatus----', installationStatus,installationCompleteStatus)
    console.log('installationCompleteStatus',details?.installationCompleteStatus,installationCompleteStatus)

    console.log('billing_type', billing_type)
    console.log('min_payment_statusmin_payment_status', min_payment_status)

    console.log('details?.project_category', details?.project_category)

    if(split_mirror_status == 7 && status == 3 && details?.hold == 0){
      return { color: 'warning', label: 'Status: Awaiting Approval' }
    }

    let CommunityJob = false
      let CompletedStatus =
    (installationCompleteStatus == 1 || (split_mirror_status !== null ? split_mirror_status : details?.installationCompleteStatus) == 1)
    ? min_payment_status == 0 ? 'Payment Due for Installation'  : 'Installation'
    : (installationCompleteStatus == 2 || (split_mirror_status !== null ? split_mirror_status : details?.installationCompleteStatus) == 2)
    ? received_status == 1 ? 'Picked Up' : min_payment_status == 0 ? 'Payment Due for Pick up' : 'Pick up'
    :  (installationCompleteStatus == 3 || (split_mirror_status !== null ? split_mirror_status : details?.installationCompleteStatus) == 3) ? received_status == 1 ? 'Shipped' :min_payment_status == 0 ? 'Payment Due for Shipping' : 'Shipping' :''
      switch (status) {
        case 1:
          // return { color: 'warning', label: 'Status: Draft' }
          return { color: 'warning', label: details?.hold === 1 ? 'Status: Hold' : 'Status: Draft' }
        case 2:
          // return { color: 'info', label: 'Status: Open' }
           return { color: details?.hold === 1 ?'warning' : 'warning', label: details?.hold === 1 ? 'Status: Hold' : 'Status: Awaiting Approval' }
        case 3:
          return {
            color: `${
              details?.hold === 1 ?'warning' :
              details?.project_category == 13
                ? 'primary'
                : min_payment_status == 0
                ? 'warning'
                : 'primary'
            }`,
            label: `Status: ${
              details?.hold === 1 ? 'Hold' :
              details?.project_category == 13 || billing_type == 0 || fromMirror
                ? 'Approved'
                : min_payment_status == 1
                ? 'Approved and Paid'
                : 'Approved and Payment Due'
            }`,
          }
        // return { color: `${min_payment_status==0? 'warning' :'primary'}`, label: `Status: ${min_payment_status==1? 'Approved and Paid' :'Approved & Awaiting for Payment'}` }
        case 4:
          // return { color: 'success', label: !empty(allInstallationCompleted) ? 'Completed' : (!empty(installationStatus) ? 'Status: Installation' : 'Status: In Production') }
          return {
            color: details?.hold==1 ? 'warning' :
              min_payment_status == 0 ? 'warning' :
              (noServiceNoTask == 1 && proj_status == 3 && details?.project_category !== 12) ? 'success' :
              split_mirror_status == 8 ? 'success' :
              (split_mirror_status == 1 || split_mirror_status == 2 || split_mirror_status == 3) ? 'success' :
              empty(accepted) && (!empty(allInstallationCompleted && split_mirror_status !==1  && split_mirror_status !==2 && split_mirror_status !==3 && split_mirror_status !==5 && received_status !== 1) || split_mirror_status == 4)
                ? 'warning'
                : 'success',
            label: details?.hold==1 ? 'Hold' : (noServiceNoTask == 1 && proj_status == 3 && details?.project_category !== 12) ? 'No Service No Task' :
             details?.isReview ==2 && (!empty(allInstallationCompleted)) ? "Awaiting Review" :
              split_mirror_status == 8 ? 'Production' :
              split_mirror_status == 1 ? min_payment_status == 0 ? 'Payment Due for Installation' : 'Installation' :
              split_mirror_status == 2 ? (received_status == 1 ? 'Picked Up' : min_payment_status == 0 ? 'Payment Due for Pick up' : 'Pick up') :
              split_mirror_status == 3 ? (received_status == 1 ? 'Shipped' : min_payment_status == 0 ? 'Payment Due for Shipping' : 'Shipping') :
              empty(accepted) && ((!empty(allInstallationCompleted && split_mirror_status !==1  && split_mirror_status !==2 && split_mirror_status !==3 && split_mirror_status !==5 && received_status !== 1) || split_mirror_status == 4))
                ? allInstallationCompleted ? `${CompletedStatus} completed & Awaiting approval` : received_status == 1 ? `${CompletedStatus}` : `Completed & Awaiting approval`
                : (job_category_name === 'Build Order' && status === 4 && accepted === 1) ? 'Completed'
                : ((!empty(accepted) && (!empty(allInstallationCompleted))) || split_mirror_status == 5)
                ? allInstallationCompleted ? `${CompletedStatus} completed & Approved` : `Completed & Approved`
                : !empty(installationStatus)
                ? partial_install == 1 ? 'Status: Partial Install' :proj_status !=3 ? `Status: Production` : min_payment_status == 0 ? `Status: Payment Due for ${CompletedStatus}` : `Status: ${CompletedStatus}`
                : CommunityJob ? `${CompletedStatus} completed & Approved` : `Status: Production`,
          } // return { color: 'primary', label: 'Status: Converted to Job' };
        case 5:
          return { color: 'warning', label: 'Status: Closed' }
        case 6:
          return { color: 'error', label: 'Status: Rejected' }
           case 10:
        return { color: 'error', label: 'Void' }
        default:
          return { color: 'default', label: 'Status: Open' }
      }
    }

    // The below useEffect is used for fetching the invoice details only
    useEffect(() => {
      console.log('requestServices--', requestServices);
  
      const rfqServicesData = invoice?.cust_product?.flatMap(product => {
        console.log('product--', product)
        return product.services.map(service => ({
          ...service,
          productIndex: product.product_index,
          product_id: product.product_id,
          qtyData: product.quantity,
          locationQuantity: product.locationQuantity || 1
  
        }));
      });
      console.log("##################rfqInvoiceServiceData", rfqServicesData);
      const newrfqServicesData = rfqServicesData?.filter(item => {
        const newQty = parseFloat((item.prQty * item.qtyData * item.locationQuantity)?.toFixed(2));
        console.log('rfqInvoiceServiceDatanewQty-----------', newQty);
        console.log('rfqInvoiceServiceDataitem.qty-----------', item.qty);
        return newQty !== item.qty;
      }).map(item => {
        const newQty = item.prQty * item.qtyData * item.locationQuantity;
        let quantityDifference = 0;
        if(details?.job_category_name === 'Time & Material'){
          quantityDifference = 0;
        }else{
          quantityDifference = item.qty - newQty;
        }
        return {
          ...item,
          quantity: quantityDifference,
          quantityDifference: quantityDifference,
          total_cost: item.unit_cost * quantityDifference
        };
      });
  
      console.log('newrfqServicesData-------', newrfqServicesData);
  
      setInvoiceSelectedServices(newrfqServicesData || [])
  
      const additionalServices = requestServices?.filter(item => item?.recipe_id === null);
      const additionalServicesData = sortAdditionalServicesByIndex(additionalServices || []);
      const updatedServicesData = additionalServicesData?.map((serviceItem)=>{
        return{
          ...serviceItem,
          productId : serviceItem.labour_cost_service_id,
          addresses: [
            {
              address: serviceItem.address,
              city: serviceItem.city,
              state: serviceItem.state,
              zip: serviceItem.zip,
            }
          ]
        }
      })
      console.log('updatedServicesData----',updatedServicesData);
      setAdditionalSelectedServices(updatedServicesData);
      const rfpServices = rfpServicesEdit?.filter(item => item?.recipe_id === null && item?.rfp === 1);
     
      setCartService(rfpServices)
    }, [requestServices, invoice, rfpServicesEdit]);

    // Build a service-location list for linking designs/documents to services.
    // `location_ids` on attachments must store `request_service_locations.id` only (`req_loc_id` from API).
    // Merge requestServices with invoice.jobcost_service (same getRequestServices shape on backend) so
    // estimates still get link targets after order/invoice load — initial requestServices can miss req_loc_id.
    const mergedServiceRowsForLinking = (() => {
      const seen = new Set()
      const out = []
      for (const arr of [requestServices || [], invoice?.jobcost_service || []]) {
        for (const s of arr) {
          if (!s) continue
          const k = `${s.id}-${s.req_loc_id ?? ''}`
          if (seen.has(k)) continue
          seen.add(k)
          out.push(s)
        }
      }
      return out
    })()

    const servicesWithLocation = (mergedServiceRowsForLinking || [])
      .filter((s) => s?.recipe_id === null || s?.recipe_id === undefined)
      .filter((s) => s?.req_loc_id != null && s?.req_loc_id !== '')
      .map((s) => ({
        request_location_id: s.req_loc_id,
        product_name: s?.service_name || s?.name || 'Service',
        product_notes: s?.service_notes || null,
        material: 0,
        rfp: 0,
      }));

    const productLocationIdSet = new Set((productsWithLocation || []).map(p => String(p.request_location_id)));
    const serviceLocationIdSet = new Set((servicesWithLocation || []).map(s => String(s.request_location_id)));

    const getAttachmentLinkType = (att) => {
      const ids = (att?.location_ids || '')
        .toString()
        .split(',')
        .map((x) => x.trim())
        .filter(Boolean);
      if (ids.some((id) => serviceLocationIdSet.has(String(id)))) return 'service';
      if (ids.some((id) => productLocationIdSet.has(String(id)))) return 'product';
      return null;
    };

    const linkableItemsForPicker =
      linkTargetType === 'service' ? servicesWithLocation : groupedLinkableProducts;

    const getPickerRowLocationIds = (row) =>
      row?._isGroupPickerRow
        ? (row._memberLocationIds || []).map((id) => Number(id))
        : [Number(row.request_location_id)]

    const isPickerRowFullySelected = (row) => {
      const ids = getPickerRowLocationIds(row)
      return (
        ids.length > 0 &&
        ids.every((locId) =>
          selectedProducts.some((p) => Number(p.product_id) === locId),
        )
      )
    }

    const mapPickerRowToSelectedEntries = (row, designItem) => {
      const ids = getPickerRowLocationIds(row)
      return ids.map((locId) => ({
        id: designItem.id,
        product_id: locId,
        product_name: row.product_name,
        product_notes: row.product_notes,
        reason: null,
        num: 5,
      }))
    }

    const filterLinkableProductsForDesign = (designItem, forUnlink, activeDesignId) => {
      if (linkTargetType === 'service' || activeDesignId !== designItem.id) {
        return []
      }
      const validPickerIds = new Set(
        [...(productsWithLocation || []), ...(servicesWithLocation || [])].map((row) =>
          Number(row.request_location_id),
        ),
      )
      return (groupedLinkableProducts || []).filter((row) => {
        const memberIds = getPickerRowLocationIds(row)
        if (row?.material !== 0 || row?.rfp !== 0) return false
        if (forUnlink) {
          const linkedLocationIds = designItem?.location_ids
            ? designItem.location_ids
                .split(',')
                .map((id) => parseInt(id.trim(), 10))
                .filter((n) => !isNaN(n))
            : []
          return memberIds.some((id) => linkedLocationIds.includes(id))
        }
        const fromLocationIds = designItem?.location_ids
          ? designItem.location_ids
              .split(',')
              .map((id) => parseInt(id.trim(), 10))
              .filter((n) => !isNaN(n))
          : []
        const fromLinkedField = designItem?.linkedLocationIds
          ? designItem.linkedLocationIds
              .split(',')
              .map((id) => parseInt(id.trim(), 10))
              .filter((n) => !isNaN(n))
          : []
        const alreadyLinked = new Set(
          [...fromLocationIds, ...fromLinkedField].filter((id) => validPickerIds.has(id)),
        )
        return memberIds.some((id) => !alreadyLinked.has(id))
      })
    }

    const countSelectedPickerRows = (rows, designItem) =>
      rows.reduce(
        (count, row) =>
          count + (isPickerRowFullySelected(row) ? 1 : 0),
        0,
      )

    const flatMapPickerRowsToSelectedEntries = (rows, designItem) =>
      rows.flatMap((row) => mapPickerRowToSelectedEntries(row, designItem))

    const initializeSelectedProducts = (item) => {
      console.log("done 1",item)
      const preSelected = item.location_ids
        ? item.location_ids.split(',').map(id => ({
            id: item.id,
            product_id: parseInt(id.trim(), 10),
            product_name: linkableItemsForPicker?.find(
              (p) => Number(p.request_location_id) === parseInt(id.trim(), 10)
            )?.product_name || '',
            reason: null,
          }))
        : [];
    
      setSelectedProducts(preSelected);
    };
    

    // const handleCheckboxChange = (product, isChecked,item) => {
    //   console.log('productproduct',product)
    //   setSelectedProducts((prevSelected) => {
    //     if (isChecked) {
    //       // Add product to state if checked
    //       return [...prevSelected, { 
    //         id: item.id, 
    //         // product_id: product.product_id, 
    //         product_id: product.id, 
    //         product_name: product.product_name, 
    //         reason: null, 
    //       }];
    //     } else {
    //       // Remove product from state if unchecked
    //       return prevSelected.filter(
    //         (selected) => selected.product_id !== product.id
    //       );
    //     }
    //   });
    // };
    

    // ✅ Updated `handleCheckboxChange` to handle pre-selected products
const handleCheckboxChange = (product, isChecked, item) => {
  const locationIdsToToggle = product?._isGroupPickerRow
    ? (product._memberLocationIds || []).map((id) => Number(id))
    : [Number(product.request_location_id)]

  setSelectedProducts((prevSelected) => {
    if (isChecked) {
      const additions = locationIdsToToggle
        .filter(
          (locId) => !prevSelected.some((p) => Number(p.product_id) === locId),
        )
        .map((locId) => ({
          id: item.id,
          product_id: locId,
          product_name: product.product_name,
          reason: null,
        }))
      return additions.length ? [...prevSelected, ...additions] : prevSelected
    }
    return prevSelected.filter(
      (selected) => !locationIdsToToggle.includes(Number(selected.product_id)),
    )
  })
};


    const handleSubmit = async (attacmentId) => {
      console.log('Selected Products:', selectedProducts);
      let requestId = details.id
      let userId = user.user_id
      let designId =attacmentId

      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      const requestData = {
        requestId,
        userId,
        data: selectedProducts,
        designId,
        approved: true,
        socketId: null // Will be set by the progress modal
      };

      setProgressHeading("Updating Design");
      setProgressRequestData(requestData);
      setShowProgressModal(true);

      // Wait for socket connection to establish and stabilize
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Additional wait if socket is not ready yet
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 1000));
      }

      try {
        const response = await axios.post(`${REST_API_END_POINT}request/update-multi-designs`, requestData)
        if(response.data.status==1){
          await fetchRequestDetails()
          enqueueSnackbar( `Design has been linked Successfully`,{ variant: 'success' },)
          // Only execute finally logic after designs are fetched and displayed
          setModalClose(false)
          setOpenProductModel(false)
          setTimeout(() => {
            setShowProgressModal(false)
          }, 1000);
        }else{
          enqueueSnackbar(response.data.message, { variant: 'error' })
          setModalClose(false)
          setOpenProductModel(false)
          setTimeout(() => {
            setShowProgressModal(false)
          }, 100);
        }
      } catch (error) {
        console.error('Submit error:', error);
        enqueueSnackbar('Failed to update design', { variant: 'error' });
        setModalClose(false)
        setOpenProductModel(false)
        setTimeout(() => {
          setShowProgressModal(false)
        }, 100);
      }
  };

  const handleUnlinkSubmit = async (attachmentId, item) => {
    console.log('Unlinking Products:', selectedProducts);
    let requestId = details.id
    let userId = user.user_id
    let designId = attachmentId

    // 🚀 PROGRESS TRACKING: Show progress modal and make API call
    const requestData = {
      requestId,
      userId,
      data: selectedProducts,
      designId,
      socketId: null // Will be set by the progress modal
    };

    setProgressHeading("Unlinking Design");
    setProgressRequestData(requestData);
    setShowProgressModal(true);

    // Wait for socket connection to establish and stabilize
    await new Promise(resolve => setTimeout(resolve, 2000));

    // Additional wait if socket is not ready yet
    if (!socketReady) {
        console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
        await new Promise(resolve => setTimeout(resolve, 1000));
    }

    try {
      const response = await axios.post(`${REST_API_END_POINT}request/unlink-multi-designs`, requestData)
      if(response.data.status==1){
        await fetchRequestDetails()
        enqueueSnackbar( `Design has been unlinked Successfully`,{ variant: 'success' },)
        // Only execute finally logic after designs are fetched and displayed
        setModalClose(false)
        setOpenProductModel(false)
        setSelectedProducts([])
        setTimeout(() => {
          setShowProgressModal(false)
        }, 100);
      }else{
        enqueueSnackbar(response.data.message, { variant: 'error' })
        setModalClose(false)
        setOpenProductModel(false)
        setSelectedProducts([])
        setTimeout(() => {
          setShowProgressModal(false)
        }, 100);
      }
    } catch (error) {
      console.error('Unlink error:', error);
      enqueueSnackbar('Failed to unlink design', { variant: 'error' });
      setModalClose(false)
      setOpenProductModel(false)
      setSelectedProducts([])
      setTimeout(() => {
        setShowProgressModal(false)
      }, 100);
    }
  };

  const handleUpdateDesign = async (data) => {
    console.log("numberrrrrrrrrrr",data?.num)
    
    setModalClose(true)
    data.requestId = details.id
    data.userId = user.user_id
    if (data.approved) data.approved_by = user.user_id
    if (data.approved === 0 && reasonText === '') {
      enqueueSnackbar('Please add Reason', { variant: 'error' })
      return
    }
    let productName = ''
    if (data?.hasOwnProperty('product_name')) {
      productName = data?.product_name
      delete data?.product_name
    }

    // 🚀 PROGRESS TRACKING: Show progress modal and make API call
    const requestData = {
      ...data,
      socketId: null // Will be set by the progress modal
    };

    // Set appropriate progress heading based on operation type
    let progressHeading = "Updating Design";
    if (data?.status === 0) {
      progressHeading = "Deleting Design";
    } else if (data.approved === 0 && !data.product_id) {
      progressHeading = "Rejecting Design";
    } else if (data.approved === 1) {
      progressHeading = "Approving Design";
    } else if (data.product_id) {
      progressHeading = "Linking Design";
    }
    
    setProgressHeading(progressHeading);
    setProgressRequestData(requestData);
    setShowProgressModal(true);

    // Wait for socket connection to establish and stabilize
    await new Promise(resolve => setTimeout(resolve, 2000));

    // Additional wait if socket is not ready yet
    if (!socketReady) {
        console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
        await new Promise(resolve => setTimeout(resolve, 1000));
    }

    try {
      const res = await axios.post(`${REST_API_END_POINT}request/update-designs`, requestData);
      
      if (res.data.status === 1) {
        // fetchRequestDetailsNew()
        await fetchRequestDetails()
        enqueueSnackbar(
          data.approved === 1
            ? 'Design has been Approved'
            : data.product_id
            ? `Design has been linked with ${productName}`
            : data?.status == 0
            ? 'Design has been Deleted'
            : 'Design has been Rejected',
          { variant: 'success' },
        )
        // Only execute finally logic after designs are fetched and displayed
        setItemId(null)
        setModalClose(false)
        setOpenProductModel(false)
        setOpenReasonModal(false)
        setReasonText('')
        setTimeout(() => {
          setShowProgressModal(false)
        }, 100);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' })
        setItemId(null)
        setModalClose(false)
        setOpenProductModel(false)
        setOpenReasonModal(false)
        setReasonText('')
        setTimeout(() => {
          setShowProgressModal(false)
        }, 100);
      }
    } catch (error) {
      console.error('Design update error:', error);
      enqueueSnackbar('Failed to update design', { variant: 'error' });
      setItemId(null)
      setModalClose(false)
      setOpenProductModel(false)
      setOpenReasonModal(false)
      setReasonText('')
      setTimeout(() => {
        setShowProgressModal(false)
      }, 100);
    }
  }
  // const handleFileChange = async (event) => {
  //   const file = event.target.files[0]
  //   const fileExtension = file?.name?.split('.')?.pop()?.toLowerCase()
  //   const Filename = new Date().getTime() + file?.name

  //   // const isImage = file?.type?.startsWith('image/')
  //   // const isPdf = file?.type === 'application/pdf'
  //   const isImage =
  //   file?.type?.startsWith('image/') ||
  //   file?.type === 'img' ||
  //   file?.type === 'image'
  // const isPdf = file?.type === 'pdf' || file?.type === 'application/pdf' || file?.type === "other"

  //   if (!isImage && !isPdf) {
  //     enqueueSnackbar(
  //       'Please select a valid file. Only Images and PDF are allowed',
  //       { variant: 'error' },
  //     )
  //     return
  //   }
  //   const StorageRef = imageref(storage, Filename)
  //   const uploadTask = uploadBytesResumable(StorageRef, file)

  //   uploadTask.on(
  //     'state_changed',
  //     (snapshot) => {
  //       const pro = Math.round(
  //         (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
  //       )
  //       setProgress(true)
  //     },
  //     (error) => {
  //       console.error(error.message)
  //       setProgress(false)
  //       enqueueSnackbar('Please upload Image or PDF less than 1 GB', {
  //         variant: 'error',
  //       })
  //     },
  //     () => {
  //       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //         const uploaded = [downloadURL]
  //         const requestId = details.id
  //         const data = {
  //           requestId,
  //           userId: user.user_id,
  //           uploaded,
  //           type: file.type,
  //           size: file.size,
  //           extension: fileExtension,
  //         }
  //         // axios
  //         //   .post(`${REST_API_END_POINT}request/upload-designs`, data)
  //         //   .then((res) => {
  //         //     if (res.data.status === 1) {
  //         //       setDesigns((pv) => [
  //         //         ...pv,
  //         //         ...res.data.data.map((d) => ({
  //         //           ...d,
  //         //           updated_by: user.person_name,
  //         //         })),
  //         //       ])
  //         axios.post(`${REST_API_END_POINT}request/upload-designs`, data)
  //         .then((res) => {
  //           if (res.data.status === 1) {
  //             // setDesigns((prev) => [
  //             //   ...(Array.isArray(prev) ? prev : []), // Ensure prev is an array
  //             //   ...((Array.isArray(res?.data?.data) ? res?.data?.data : [])).map((d) => ({
  //             //     ...d,
  //             //     updated_by: user.person_name,
  //             //   })),
  //             // ]);
  //             if(!fromProposal){
  //             setRenderCards(!renderCards)
  //             }
  //               enqueueSnackbar(res.data.message, { variant: 'success' })
  //             } else {
  //               enqueueSnackbar(res.data.message, { variant: 'error' })
  //             }
  //           })
  //         setProgress(false)
  //         // fetchRequestDetailsNew()
  //         fetchRequestDetails()
  //       })
  //     },
  //   )
  // }
  const blockedExtensions = [
    'js', 'jsx', 'ts', 'tsx',
    'html', 'css', 'php', 'py', 'java',
    'c', 'cpp', 'cs', 'sh', 'bat',
    'json', 'xml', 'sql', 'db', 'sqlite',
    'jmx', 'env', 'ini', 'config', 'yml', 'yaml'
  ];
  
  const validateFile = (file) => {
    const ext = file.name.split('.').pop()?.toLowerCase();
  
    if (blockedExtensions.includes(ext)) {
      return {
        code: 'file-type-not-allowed',
        message: `.${ext} files are not allowed`
      };
    }
  
    return null;
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    // 🔴 BLOCKED FILE CHECK
    const ext = file.name.split('.').pop()?.toLowerCase();

    if (blockedExtensions.includes(ext)) {
      enqueueSnackbar(`.${ext} files are not allowed`, {
        variant: 'error',
      });
      event.target.value = '';
      return;
    }

    const fileExtension = file?.name?.split('.')?.pop()?.toLowerCase();
    const isImage =
      file?.type?.startsWith('image/') ||
      file?.type === 'img' ||
      file?.type === 'image';
    const isPdf =
      file?.type === 'pdf' ||
      file?.type === 'application/pdf' ||
      file?.type === 'other';

    // if (!isImage && !isPdf) {
    //   enqueueSnackbar('Please select a valid file. Only Images and PDF are allowed', {
    //     variant: 'error',
    //   });
    //   return;
    // }

    const maxSizeBytes = 1024 * 1024 * 1024; // 1 GB
    if (file.size > maxSizeBytes) {
      enqueueSnackbar('Please upload Image or PDF less than 1 GB', {
        variant: 'error',
      });
      return;
    }

    // This removes all #, %, &, + and other dangerous URL characters
const sanitizedName = file.name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9.\-_]/g, '');;
    const filename = `${Date.now()}_${sanitizedName}`;
    const filePath = `esitmate-sales-order detail/attachments/${filename}`;

    try {
      setProgress(true);

      const { error: uploadError } = await supabase.storage
        .from('signwise-attachments')
        .upload(filePath, file);

      if (uploadError) throw uploadError;

      const { data: publicUrlData, error: urlError } = supabase.storage
        .from('signwise-attachments')
        .getPublicUrl(filePath);

      if (urlError || !publicUrlData?.publicUrl) {
        throw new Error('Failed to get public URL');
      }

      const downloadURL = publicUrlData.publicUrl;
      const uploaded = [downloadURL];
      const requestId = details.id;

      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      const dataPayload = {
        requestId,
        userId: user.user_id,
        uploaded,
        type: file.type,
        size: file.size,
        extension: fileExtension,
        socketId: null // Will be set by the progress modal
      };

      setProgressHeading("Uploading Design");
      setProgressRequestData(dataPayload);
      setShowProgressModal(true);

      // Wait for socket connection to establish and stabilize
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Additional wait if socket is not ready yet
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 1000));
      }

      const res = await axios.post(`${REST_API_END_POINT}request/upload-designs`, dataPayload);

      if (res.data.status === 1) {
        if (!fromProposal) {
          setRenderCards(!renderCards);
        }
        setProgress(false);
        await fetchRequestDetails();
        enqueueSnackbar(res.data.message, { variant: 'success' });
        // Only execute finally logic after designs are fetched and displayed
        setTimeout(() => {
          setShowProgressModal(false)
        }, 100);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
        setProgress(false);
        setTimeout(() => {
          setShowProgressModal(false)
        }, 100);
        event.target.value = '';
      }
    } catch (error) {
      console.error('Upload failed:', error.message);
      setProgress(false);
      enqueueSnackbar(error.response?.data?.message || 'Upload failed. Please try again.', {
        variant: 'error',
      });
      setTimeout(() => {
        setShowProgressModal(false)
      }, 100);
    }
  };

  const approvedCount = designs?.filter((item) => item.approved === 1)?.length
  const linkedCount = designs?.filter((item) => item.approved === 0 )?.length
  const rejectedCount = designs?.filter((item) => item.reason !== null)?.length

  let borderColor

  if (rejectedCount > 0) {
    borderColor = theme.palette.error.main
  } else {
    borderColor = theme.palette.success.main
  }
  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setOpenImageModal(true);
  };

  const handlePrevious = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex < imageDesigns.length - 1 ? prevIndex + 1 : prevIndex));
  };

  const handleSendSelectedDesignsToEmailModal = () => {
    if (selectedDesignsInModal.length === 0) {
      enqueueSnackbar('Please select at least one design', { variant: 'warning' })
      return
    }
    const selectedDesignFiles = designs?.filter((item) => selectedDesignsInModal.includes(item.id))
    setEmailModalDesigns(selectedDesignFiles)
    setOpenEmailModal(true)
  }

  const handleSendCurrentItemToEmailModal = (item) => {
    if (!item || !item.id) {
      enqueueSnackbar('No item to send', { variant: 'warning' })
      return
    }
    setEmailModalDesigns([item])
    setOpenEmailModal(true)
  }

  const handleDownloadImage = (imageUrl) => {
    if (!imageUrl) {
      enqueueSnackbar('No image to download', { variant: 'warning' })
      return
    }
    downloadImage(
      imageUrl,
      null,
      currentImageIndex,
      () => {
        enqueueSnackbar('Image downloaded successfully', { variant: 'success' })
      },
      () => {
        enqueueSnackbar('Failed to download image', { variant: 'error' })
      }
    )
  }

  const handleDownloadFile = (fileUrl) => {
    if (!fileUrl) {
      enqueueSnackbar('No file to download', { variant: 'warning' })
      return
    }
    downloadFileFromUrl(
      fileUrl,
      null,
      () => {
        enqueueSnackbar('File downloaded successfully', { variant: 'success' })
      },
      () => {
        enqueueSnackbar('Failed to download file', { variant: 'error' })
      }
    )
  }

  const handleEmailSent = () => {
    setSelectedDesignsInModal([])
  }

  const handleDownloadEditedPdf = async (attachmentId) => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}request/get-attachment-images`,
        { attachmentId }
      );
  
      const images = res.data?.images;
  
      if (!images || !images.length) {
        enqueueSnackbar('No edited pages available to download', { variant: 'error' });
        return;
      }
  
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: 'a4',
      });
  
      const pdfPageWidth = pdf.internal.pageSize.getWidth();
      const pdfPageHeight = pdf.internal.pageSize.getHeight();
  
      for (let i = 0; i < images.length; i++) {
        const image = images[i];
  
        const baseUrl = REST_API.endsWith('/')
          ? REST_API
          : `${REST_API}/`;
  
        const imagePath = (image.image_url || '').startsWith('/')
          ? image.image_url.slice(1)
          : image.image_url;
  
        const imageUrl = `${baseUrl}uploads/${imagePath}`;
  
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = imageUrl;
  
        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = () =>
            reject(new Error(`Failed to load image: ${imageUrl}`));
        });
  
        // 🔥 HIGH QUALITY SCALE (same as your second function)
        const scale = 4;
  
        const aspectRatio = img.height / img.width;
        const renderWidth = pdfPageWidth;
        const renderHeight = renderWidth * aspectRatio;
  
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
  
        canvas.width = renderWidth * scale;
        canvas.height = renderHeight * scale;
  
        ctx.scale(scale, scale);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
  
        ctx.drawImage(img, 0, 0, renderWidth, renderHeight);
  
        const imgData = canvas.toDataURL('image/png', 1.0);
  
        if (i !== 0) pdf.addPage();
  
        // Maintain aspect ratio inside PDF
        const calculatedHeight = pdfPageWidth * aspectRatio;
        const finalHeight =
          calculatedHeight > pdfPageHeight
            ? pdfPageHeight
            : calculatedHeight;
  
        const finalWidth = finalHeight / aspectRatio;
  
        pdf.addImage(
          imgData,
          'PNG',
          0,
          0,
          finalWidth,
          finalHeight,
          undefined,
          'FAST'
        );
      }
  
      pdf.save('edited_document.pdf');
      enqueueSnackbar('PDF downloaded successfully', {
        variant: 'success',
      });
    } catch (error) {
      console.error('Failed to download edited PDF', error);
      enqueueSnackbar(
        error?.message || 'Unable to download edited PDF',
        { variant: 'error' }
      );
    }
  };
  
  // Non-browser-renderable "image/*" subtypes must be excluded from the native <img> lightbox
  const NON_RENDERABLE_IMAGE_SUBTYPES = ['eps', 'ai', 'ps', 'psd', 'x-eps', 'x-ai', 'postscript'];
  const imageDesigns = designs?.filter((item) => {
    const ft = item.file_type || '';
    if (ft === 'img' || ft === 'image') return true;
    if (!ft.startsWith('image/')) return false;
    const subtype = ft.replace('image/', '').toLowerCase();
    if (NON_RENDERABLE_IMAGE_SUBTYPES.includes(subtype)) return false;
    const ext = (item.name || '').split('.').pop()?.split('?')[0]?.toLowerCase();
    if (['eps', 'ai', 'ps', 'psd'].includes(ext)) return false;
    return true;
  });

  // const isReviewAwaiting = details?.isReview == 2 && !empty(details?.allInstallationCompleted);
  const isReviewAwaiting = !hasNonTmGroupedMember && details?.project_category == 12;

  const manualSubtotal =
    (treatInvoiceAsTimeMaterial ? (subTotal || 0) : (requestInvoiceCustProductSubtotalForServices || 0)) +
    (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
    (cartService?.reduce((s, x) => {
      const sp = x.sellingPrice || x.unit_cost || 0;
      const markup = x.originalMarkup || x.product_markup || 0;
      const final = sp + (sp * markup / 100);
      return s + ((x.qty || 0) * final);
    }, 0) || 0);

  // Same formula as edit form: Subtotal × rush fee %
  const rushFeePct = Number(rushFeePercentage) || 0;
  const rushFeeAmount = calcRushFeeAmount({
    enabled: showRushFee,
    subtotal: manualSubtotal,
    percentage: rushFeePct,
    storedAmount: details?.rush_fee_amount,
    preferStored: true,
  });

  const expectedTotalWithoutRush = Number(
    (
      manualSubtotal -
      (invoice?.extra_discount || 0) +
      Number(invoice?.tax_amount || 0)
    ).toFixed(2),
  );

  const computedTotal = isReviewAwaiting
    ? (expectedTotalWithoutRush + rushFeeAmount)
    : invoiceDisplayTotal;

  const total = computedTotal > 0 ? computedTotal : 0;

  // Always include calculated rush in displayed total when rush is on
  const displayInvoiceTotalRaw = hasNonTmGroupedMember
    ? invoiceDisplayTotal
    : Number(
        calcTotalWithRushFee({
          subtotal: manualSubtotal,
          discount: invoice?.extra_discount,
          tax: invoice?.tax_amount,
          rushFee: showRushFee ? rushFeeAmount : 0,
        }).toFixed(2),
      );
  // Match ViewOfficialRequest negativeCheck: No Charge totals display as negative
  const isNoChargeJob =
    Number(details?.project_category) === 13 ||
    Number(invoice?.project_category) === 13 ||
    details?.job_category_name === 'No Charge';
  const displayInvoiceTotal =
    isNoChargeJob && displayInvoiceTotalRaw > 0
      ? -displayInvoiceTotalRaw
      : displayInvoiceTotalRaw;

  const desiredTotal = Number((showRushFee ? displayInvoiceTotal : (displayInvoiceTotal || total)).toFixed(2));

  // Summary rows should span all table columns (varies on split-order columns)
  const summaryColSpan =
    details?.is_split_order && details?.project_category != 15 ? 6 : 4;

  useEffect(() => {
    if (!isReviewAwaiting || !details?.id || !hasViewCostPermission) return;
    // if (!details?.id && details?.job_category_name !== 'Time & Material') return;

    // prevent redundant updates (and loops due to rounding)
    const currentPersisted = Number((invoice?.total ?? 0).toFixed(2));
    if (currentPersisted === desiredTotal) return;

    let aborted = false;

    (async () => {
      try {
        await axios.post(
          `${REST_API_END_POINT}sales-order/update-review-invoice-total`,
          {
            requestId: invoice.request_id,
            orderId: invoice.id,
            total: desiredTotal,
            userId,
            isGroupedInvoiceCombined: hasGroupedMemberDetails,
            groupedMemberRequestIds: hasGroupedMemberDetails
              ? groupedInvoiceMembers
                .map((member) => Number(member?.requestDetails?.id))
                .filter((id) => Number.isInteger(id) && id > 0)
              : [],
          }
        );
        if (!aborted) {
          setInvoice(prev => ({
            ...prev,
            total: desiredTotal,
            grandTotal: desiredTotal
          }));
        }
      } catch (e) {
        console.error('Failed to persist review total', e);
      }
    })();

    return () => { aborted = true; };
  }, [desiredTotal, isReviewAwaiting, invoice, hasViewCostPermission]);

  const canViewCosts = !!hasViewCostPermission;

  /** Columns hidden when pricing is not visible: unit+total, and optionally wholesale+split. */
  const hiddenPriceColumnCount = !canViewCosts
    ? 2 +
      (details?.is_split_order &&
      details?.origin_facility_id == currentFacilityId &&
      !details?.real_for_parent_facility &&
      userType != 3
        ? 2
        : 0)
    : 0;

let customerProductTotal = 0;

								    const handleOpenProductFormula = async (id) => {
    console.log("product formula ", selectedProducts);
    console.log("id........", id);
    setSelectedProductFormulaId(id);
    setOpenProductFormulaModal(true);
    console.log("skjfljfdlfjdlfld",invoice);
    
  }
  return (
    <Card>
      <Stack sx={{ m: 3 }} spacing={3}>
        <Stack
          direction={{ xs: 'row', sm: 'row' }}
          sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}
        >
          <Box>
            <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
              {name}
              {/* {sentenceCase(name)} */}
            </Typography>
            {isGroupedInvoiceCombined && details?.installation_acceptance && details?.doc_number ? (
              <Typography variant="body2" sx={{ display: 'block', color: theme.palette.mode === 'light' ? '#000000' : '#ffffff', mt: 0.25, fontSize: '0.95rem' }}>
                <strong>Invoice Number :</strong> {`#${details?.doc_number}`}
              </Typography>
            ) : null}
          </Box>
          {/* {reason && (
            <Typography variant="subtitle2"color={'error'}>
              Reason :{reason}
            </Typography>
          )} */}
          {details?.hold === 1 && details?.hold_reason ? (
            <Typography variant="subtitle2" sx={{ color: theme.palette.mode === 'light' ? '#ff9c00' : theme.palette.warning.main }}>
              Hold Reason : {details?.hold_reason}
            </Typography>
          ):''}
        </Stack>
        {userType != 3 && !isGroupedInvoiceCombined && (
          <Typography
            variant="subtitle2"
            sx={{
              color: `${
                (proposalView ? !rfpQbId :  !estimate_id || !doc_number || !syncWithQuickbooks )
                  ? 'red'
                  : 'green'
              }`,
            }}
          >
            {/* {reasonWithQb? reasonWithQb : 'Successfully Synced With QuickBooks'} */}
            {proposalView && awarded == null
              ? ''
              : proposalView
              ? reasonWithQb
                ? reasonWithQb.split('\n').map((line, index) => (
                    <span key={index} style={{ display: 'block' }}>
                      {line}
                    </span>
                  ))
                : 'Not Synced With QuickBooks. A Network Issue has Occurred. Please try again...'
              : (estimate_id && invoice_qb_id)
              ? 'Successfully Synced With QuickBooks'
              : reasonWithQb
              ? reasonWithQb.split('\n').map((line, index) => (
                  <span key={index} style={{ display: 'block' }}>
                    {line}
                  </span>
                ))
              : 'Not Synced With QuickBooks. A Network Issue has Occurred. Please try again...'}
          </Typography>
        )}
        <Stack direction="column" spacing={(isGroupedInvoiceCombined || groupedMemberDetailSections.length > 0) ? 0 : 4}>
        {detailSectionsForRender.map(({ section, useAccordion, showGroupedHeading }, sectionIndex) => {
          const {
            sd: details,
            sClient: clientDetails,
            sTeam: teamMembers,
            sDesigners: designersList,
            formattedDescription,
            formattedNotes,
            submissionDate,
            endDate,
          } = section;
          const invoice = section.sClient;
          const {
            doc_number,
            est_doc_number,
            po_number,
            installation_acceptance,
            community_name,
            added_by_name,
            notes,
            reason,
            edit_reason,
            reject_file,
            reject_file_type,
            manager_reject_reason,
            manager_reject_file,
            manager_reject_file_type,
            design_order_id,
            job_category_name,
            avalara_code,
            ship_to,
            bill_to,
            reasonWithQb,
            estimate_id,
            invoice_qb_id,
          } = details || {};
          const memberDocNumber = getSalesOrderDisplayJobNumber(details) || '';
          const invoiceSequenceSuffix = isGroupedInvoiceCombined ? ` - ${sectionIndex + 1}` : '';
          const salesOrderAccordionTitle = details?.name || community_name || clientDetails?.customer_name || 'Sales Order';
          const sectionKey = details?.id || sectionIndex;

          const sectionBody = (
        <Stack spacing={3}>
        {userType != 3 && useAccordion && (
          <Typography
            variant="subtitle2"
            sx={{
              color: `${!estimate_id || !doc_number ? 'red' : 'green'}`,
            }}
          >
            {(estimate_id && invoice_qb_id)
              ? 'Successfully Synced With QuickBooks'
              : reasonWithQb
              ? reasonWithQb.split('\n').map((line, index) => (
                  <span key={index} style={{ display: 'block' }}>
                    {line}
                  </span>
                ))
              : 'Not Synced With QuickBooks. A Network Issue has Occurred. Please try again...'}
          </Typography>
        )}
        <Stack
          direction={{ xs: 'column', sm: 'row', md: 'row' }}
          sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}
        >
          {
            proposalView?(
              <Typography variant="overline" sx={{ color: '#fd6400' }}>
                {avalara_code ?<strong>Avalara Id : {avalara_code}</strong>  :""}
              </Typography>
            )
            :
            ""
          }
          {!proposalView && (
            <Box display='flex' flexDirection='column'>
              {/* <Typography variant="overline" sx={{ color: '#ffffff' }}>
                <strong>Order Id :</strong> {doc_number ? `#${doc_number}` : ''}
              </Typography> */}
                {
                 ((depositAndProgressBilling || installation_acceptance) && est_doc_number) && (doc_number && doc_number !== est_doc_number)?
                 <>
                   <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                 <strong>Job Number :</strong> {est_doc_number ? `#${est_doc_number}` : ''}
               </Typography>
                     <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                 <strong>Invoice Number :</strong> {doc_number ? `#${doc_number}${invoiceSequenceSuffix}` : ''}
               </Typography>
               </>
                 :
                 <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                 <strong>Order Id :</strong> {memberDocNumber ? `#${memberDocNumber}` : ''}
               </Typography>
               }
              {po_number ? (
                <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                  <strong>PO Number :</strong> #{po_number}
                </Typography>
              ) : null}
              <Typography variant="overline" sx={{ color: '#fd6400' }}>
                {avalara_code ?<strong>Avalara Id : {avalara_code}</strong>  :""}
              </Typography>
              {design_order_id ? 
              <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                <strong>Design Order Id :</strong> #{design_order_id}
              </Typography> : ''}
              <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                <strong>Created by : </strong>
                 {
                  details?.is_split_order && (details?.for_parent_facility == 1)
                    ? FacilityTypes?.find(facility => facility.id === details?.origin_facility_id)?.label || added_by_name || ''
                    : added_by_name || ''
                }
                 {/* {added_by_name} */}
              </Typography>
              <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                <strong>Created on :</strong> {details?.created_at ? moment.unix(details.created_at).format('MM-DD-YYYY hh:mm:ss A') : 'N/A'}
              </Typography>
              <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                <strong>Client Name :</strong> {
                  details?.is_split_order && details?.for_parent_facility == 1 
                    ? FacilityTypes?.find(facility => facility.id === details?.origin_facility_id)?.label || clientDetails?.customer_name || ''
                    : clientDetails?.customer_name || ''
                }
              </Typography>
              {details?.is_split_order && details?.for_parent_facility == 1 ? '' :
              <>
              <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff', whiteSpace: 'pre-line' }}>
                            <strong>Client Address :</strong> {[
                              invoice?.customer_address || '',
                              [
                                invoice?.customer_city || details?.customer_city || '',
                                invoice?.customer_state || details?.customer_state || '',
                                invoice?.customer_zipcode || details?.customer_zipcode || '',
                              ].filter(Boolean).join(', ')
                            ].filter(Boolean).join('\n')}
                          </Typography>
              <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                <strong>Client Phone :</strong> {clientDetails?.customer_phone}
              </Typography>
              </>}
              <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                <strong>Project Name :</strong> {community_name}
              </Typography>
              <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                <strong>Sales Rep :</strong> {details?.sales_rep_names || ''}
              </Typography>
              {job_category_name?
              <Typography variant="body2" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                <strong>Job Type :</strong> {job_category_name} 
              </Typography>
              :""}
               {design_order_id && (<>
                <Typography alignItems={'center'} variant="subtitle1" sx={{ mt: 2 }}>
                  Designers List
                </Typography>
                <Scrollbar sx={{ width: '100%', height: 100, mt: 1.5 }}>
                  <Stack>
                    {designersList?.map((row, index) => (
                      <Stack
                        key={index}
                        direction='row'
                        mb={1}
                        spacing={1.5} 
                        alignItems='center'
                      >
                        <Avatar src={row?.profile_pic} alt={row?.name} />
                        <Typography variant="subtitle2">
                          {row?.name}
                        </Typography>
                      </Stack>
                    ))}
                  </Stack>
                </Scrollbar>
              </>)}
              {(bill_to || ship_to) && (
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    // flexDirection: 'column',
                    mt:1,
                    gap: 1,
                  }}
                >
                  {bill_to && (
                    <Box sx={{ flex: 1, width: 250 }}>
                      <Typography
                        variant="body2"
                        sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff', whiteSpace: 'pre-line',wordBreak: 'break-word', }}
                      >
                        <strong>Bill To :</strong> {bill_to}
                      </Typography>
                    </Box>
                  )}
                  {ship_to && (
                    <Box sx={{ flex: 1, minWidth: 250 }}>
                      <Typography
                        variant="body2"
                        sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff', whiteSpace: 'pre-line' }}
                      >
                        <strong>Ship To :</strong> {ship_to}
                      </Typography>
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          )}
          <Box sx={{ minWidth: 200, borderColor: 'GrayText' }}>
            <Box sx={{ width: '100%' }}>
              {(() => {
                const isVoidOrder = Number(details?.status) === 10 || Number(status) === 10;
                const isVoidEstimate = Number(details?.quotation) === 1 && Number(details?.quotation_status) === 12;
                const isVoid = isVoidOrder || isVoidEstimate;
                const jobCompleted = Number(details?.estimate_job_status) === 3;
                const isRejectedStatus = Number(quotation_status) === 6 || Number(quotation_status) === 11;
                // Prefer manager-specific reject info when present, otherwise fall back to regular reject info.
                const hasManagerReject = !isVoid && (!!manager_reject_reason || !!manager_reject_file);
                const displayReason = isVoid
                  ? (reason || '')
                  : hasManagerReject
                  ? (manager_reject_reason || reason || '')
                  : (reason || '');
                const displayRejectFile = isVoid
                  ? null
                  : hasManagerReject
                  ? (manager_reject_file || reject_file || null)
                  : (reject_file || null);
                const displayRejectFileType = isVoid
                  ? null
                  : hasManagerReject
                  ? (manager_reject_file_type || reject_file_type || null)
                  : (reject_file_type || null);
                const parseRejectAttachments = (fileValue, typeValue) => {
                  if (!fileValue) return [];
                  if (typeof fileValue === 'string' && fileValue.trim().startsWith('[')) {
                    try {
                      const parsed = JSON.parse(fileValue);
                      if (Array.isArray(parsed)) {
                        return parsed
                          .filter((item) => item && (item.url || typeof item === 'string'))
                          .map((item) =>
                            typeof item === 'string'
                              ? { url: item, file_type: null }
                              : { url: item.url, file_type: item.file_type || null },
                          );
                      }
                    } catch (error) {
                      return [];
                    }
                  }
                  return [{ url: fileValue, file_type: typeValue || null }];
                };
                const displayRejectFiles = parseRejectAttachments(displayRejectFile, displayRejectFileType);

                const showRejectInfo =
                  isRejectedStatus || (!jobCompleted && (displayReason || displayRejectFiles.length > 0));
                return showRejectInfo ? (
                  <Stack display={'flex'} direction={'column'} gap={1}>
                    <Box
                      sx={{
                        backgroundColor: '#122227',
                        border: '1px solid #2a3b40',
                        borderRadius: 1,
                        p: 2,
                        mb: 2,
                        maxWidth: '100%'
                      }}
                    >
                      <Stack display={'flex'} direction={'row'} gap={1}>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            color: theme.palette.error.main,
                            fontWeight: 'bold',
                            mb: 1
                          }}
                        >
                          {isVoidEstimate ? 'Void Reason' : isVoidOrder ? 'VOID REASON' : 'Reject Reason'}
                        </Typography>
                        {displayReason && (
                          <Typography
                            variant="body2"
                            sx={{
                              color: '#fff',
                              whiteSpace: 'pre-line',
                              mb: displayRejectFiles.length > 0 ? 2 : 0
                            }}
                          >
                            {displayReason}
                          </Typography>
                        )}
                      </Stack>
                      {/* {displayRejectFile && (
                        displayRejectFileType === 'application/pdf' ? (
                          <Button
                            variant="outlined"
                            color="primary"
                            fullWidth
                            onClick={() => {
                            const fileName = displayRejectFile?.split('/').pop()?.split('?')[0] || 'File';
                            const fileExt = fileName.split('.').pop()?.toLowerCase();
                            const isOfficeFile = ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExt);
                            const isPdf = displayRejectFileType === 'application/pdf' || fileExt === 'pdf';
                            const newWindow = window.open('', '_blank');
                            
                            if (isPdf) {
                              newWindow.document.write(`
                                <html>
                                  <head>
                                    <title>PDF Viewer</title>
                                    <style>
                                      body { margin: 0; padding: 0; overflow: hidden; }
                                      iframe { width: 100vw; height: 100vh; border: none; }
                                    </style>
                                  </head>
                                  <body>
                                    <iframe src="${displayRejectFile}#toolbar=0&navpanes=0&scrollbar=0" title="PDF Viewer"></iframe>
                                  </body>
                                </html>
                              `);
                            } else if (isOfficeFile) {
                              const officeViewerSrc = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(displayRejectFile)}`;
                              newWindow.document.write(`
                                <html>
                                  <head>
                                    <title>${fileName}</title>
                                    <style>
                                      body { margin: 0; padding: 0; overflow: hidden; }
                                      iframe { width: 100vw; height: 100vh; border: none; }
                                    </style>
                                  </head>
                                  <body>
                                    <iframe src="${officeViewerSrc}" title="${fileName}"></iframe>
                                  </body>
                                </html>
                              `);
                            } else {
                              const googleViewerSrc = `https://docs.google.com/gview?url=${encodeURIComponent(displayRejectFile)}&embedded=true`;
                              newWindow.document.write(`
                                <html>
                                  <head>
                                    <title>${fileName}</title>
                                    <style>
                                      body { margin: 0; padding: 0; overflow: hidden; }
                                      iframe { width: 100vw; height: 100vh; border: none; }
                                    </style>
                                  </head>
                                  <body>
                                    <iframe src="${googleViewerSrc}" title="${fileName}" sandbox="allow-scripts allow-same-origin"></iframe>
                                  </body>
                                </html>
                              `);
                            }
                            newWindow.document.close();
                          }}
                        >
                            View Attached File (PDF)
                          </Button>
                        ) : (
                          <Box
                            component="img"
                            src={displayRejectFile}
                            onClick={() => {
                            const newWindow = window.open('', '_blank');
                            newWindow.document.write(`
                              <html>
                                <head>
                                  <title>Image Viewer</title>
                                  <style>
                                    body { margin: 0; padding: 0; overflow: hidden; }
                                    img { max-width: 100%; max-height: 100%; }
                                  </style>
                                </head>
                                <body>
                                  <img src="${displayRejectFile}" alt="Image"/>
                                </body>
                              </html>
                            `);
                            newWindow.document.close();
                          }}
                            sx={{
                              width: 120,
                              height: 120,
                              borderRadius: 1,
                              border: '1px solid #ccc',
                              cursor: 'pointer',
                              objectFit: 'cover'
                            }}
                          />
                        )
                      )} */}
                      <RejectAttachmentsPreview files={displayRejectFiles} />
                    </Box>
                  </Stack>
                ) : '';
              })()}
               {(edit_reason) ? 
                <Stack display={'flex'} direction={'column'} gap={1}>
                  <Box
                    sx={{
                      backgroundColor: '#122227',
                      border: '1px solid #2a3b40',
                      borderRadius: 1,
                      p: 2,
                      mb: 2,
                      maxWidth: '100%'
                    }}
                  >
                    <Stack display={'flex'} direction={'row'} gap={1}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: theme.palette.error.main,
                          fontWeight: 'bold',
                          mb: 1
                        }}
                      >
                        Edit Reason
                      </Typography>
                      {edit_reason && (
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#fff',
                            whiteSpace: 'pre-line',
                            mb: (reject_file || manager_reject_file) ? 2 : 0
                          }}
                        >
                          {edit_reason}
                        </Typography>
                      )}
                    </Stack>
                  </Box>
                </Stack>
              :''}
            </Box>
              <Stack spacing={2} sx={{display:'flex',flexDirection:'row',justifyContent:'space-between',gap:25,alignItems:''}}>
                <Box>
              {((details?.collaborators && details?.collaborators?.length > 0) || (collaboratorsProp && (Array.isArray(collaboratorsProp) ? collaboratorsProp.length > 0 : String(collaboratorsProp || '').trim().length > 0))) && (
                <>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Collaborators
                  </Typography>

                  {(() => {
                    const rawCollaborators = details?.collaborators ?? collaboratorsProp;
                    const collaboratorIds = Array.isArray(rawCollaborators)
                      ? rawCollaborators.map((c) => (typeof c === 'object' && c != null ? String(c?.id ?? c?.user_id ?? c) : String(c))).filter(Boolean)
                      : String(rawCollaborators || '')
                        .split(',')
                        .map((id) => id.trim())
                        .filter(Boolean);

                    const teamList = allTeamMembers || collaboratorsTeamMembers || [];
                    let filteredMembers = teamList.filter((member) =>
                      collaboratorIds.includes(String(member?.id)) || collaboratorIds.includes(String(member?.user_id))
                    ) || [];
                    if (Array.isArray(collaboratorsProp) && collaboratorsProp.length > 0 && filteredMembers.length === 0 && typeof collaboratorsProp[0] === 'object' && collaboratorsProp[0] != null && (collaboratorsProp[0].first_name != null || collaboratorsProp[0].name != null)) {
                      filteredMembers = collaboratorsProp.map((c) => ({
                        id: c?.id ?? c?.user_id,
                        user_id: c?.user_id ?? c?.id,
                        first_name: c?.first_name ?? c?.name?.split?.(' ')?.[0] ?? '',
                        last_name: c?.last_name ?? c?.name?.split?.(' ').slice?.(1).join?.(' ') ?? '',
                        profile_pic: c?.profile_pic,
                      }));
                    }
                    
                    const currentUserId = String(user?.user_id || user?.id || '')
                    if (currentUserId && collaboratorIds.includes(currentUserId) && !filteredMembers.some((m) => String(m?.id) === currentUserId || String(m?.user_id) === currentUserId)) {
                      filteredMembers = [{ id: user?.user_id || user?.id, user_id: user?.user_id || user?.id, first_name: user?.first_name || user?.name?.split?.(' ')?.[0] || '', last_name: user?.last_name || (user?.name?.split?.(' ').slice?.(1).join?.(' ') || ''), profile_pic: user?.profile_pic }, ...filteredMembers]
                    }

                    const maxVisible = 4
                    const visibleMembers = filteredMembers?.slice(0, maxVisible)
                    const remainingCount =
                      filteredMembers?.length > maxVisible
                        ? filteredMembers.length - maxVisible
                        : 0
                        const membersToRender = showAllCollaborators ? filteredMembers : visibleMembers

                    return (
                      <Stack direction="row" alignItems="center">
                        {membersToRender?.map((row, index) => {
                          const isOnline = onlineUsers?.includes(String(row?.user_id || row?.id));
                          return (
                          <Box
                            key={row?.id ?? row?.user_id ?? index}
                            sx={{
                              ml: index === 0 ? 0 : -1.5,
                              zIndex: 100 - index,
                              position: 'relative',
                            }}
                          >
                            <Tooltip
                              title={`${row?.first_name || ''} ${row?.last_name || ''}`.trim() || row?.name}
                              arrow
                            >
                              <Badge
                                overlap="circular"
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                variant="dot"
                                sx={{
                                  '& .MuiBadge-badge': {
                                    backgroundColor: isOnline ? '#44b700' : '#bdbdbd',
                                    boxShadow: '0 0 0 2px white',
                                    height: 10,
                                    minWidth: 10,
                                    borderRadius: '50%',
                                    zIndex: 200,
                                  },
                                }}
                              >
                              <Avatar
                                src={row?.profile_pic}
                                alt={`${row?.first_name} ${row?.last_name}`}
                                sx={{
                                  width: 42,
                                  height: 42,
                                  fontSize: 14,
                                  border: '2px solid #fff',
                                  cursor: 'pointer',
                                  bgcolor: 'primary.main',
                                  transition: 'all 0.2s ease',
                                  '&:hover': {
                                    transform: 'scale(1.1)',
                                    zIndex: 200,
                                    boxShadow: 3,
                                  },
                                }}
                              >
                                {(row?.first_name || row?.name?.split?.(' ')?.[0] || '').charAt(0)}
                              </Avatar>
                              </Badge>
                            </Tooltip>
                          </Box>
                        );
                        })}

                        {remainingCount > 0 && (
                          <Box sx={{ ml: -1.5 }}>
                            <Tooltip
                              title={showAllCollaborators ? 'Show less' : `${remainingCount} more collaborators`}
                              arrow
                            >
                              <Avatar
                                onClick={() => setShowAllCollaborators((prev) => !prev)}
                                sx={{
                                  width: 42,
                                  height: 42,
                                  fontSize: 14,
                                  border: '2px solid #fff',
                                  bgcolor: 'grey.400',
                                  cursor: 'pointer',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                {showAllCollaborators ? '−' : `+${remainingCount}`}
                              </Avatar>
                            </Tooltip>
                          </Box>
                        )}
                      </Stack>
                    )
                  })()}
                </>
              )}
               </Box>
               <Box>
            {/* empty(quotation)&& details?.job_category_name!='Service only' && details?.job_category_name!='Time & Material' && */}
            {invoice && (!canViewCosts || invoice?.total != 0) && userType != 3 && (
              <>
                <Typography alignItems={'center'} variant="subtitle1">
                  Staff Members
                </Typography>
                <Scrollbar sx={{ width: '100%', height: 100 }}>
                  <Stack>
                    {teamMembers?.map((row) => (
                      <Stack
                        direction={{ xs: 'column', sm: 'row', md: 'row' }}
                        mb={1}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        <Avatar
                          src={row?.profile_pic}
                          alt={row?.first_name + ' ' + row?.last_name}
                        />
                        <Typography variant="caption">
                          {row?.first_name + ' ' + row?.last_name}
                        </Typography>
                      </Stack>
                    ))}
                  </Stack>
                </Scrollbar>
              </>
            )}
            </Box>
            </Stack>
          </Box>
        </Stack>
        <Stack
          direction={{ xs: 'row', sm: 'row' }}
          sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}
        >
          <Box sx={{ width: '60%' }}>
            <Stack sx={{ flexDirection: 'row' }}>
              <Tooltip title="Description">
                <Description />
              </Tooltip>
              <Typography
                variant="body2"
                sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff', flexWrap: 'wrap', ml: 2, whiteSpace: 'pre-line' }}
              >
                {formattedDescription}
              </Typography>
            </Stack>
          </Box>
          {/* {invoice?<Typography variant="caption" sx={{ color: '#ffffff' }}>
            {invoice[0].name}
          </Typography>:""} */}
          <Box sx={{ width: '35%' }}>
            {!user.isVendor && empty(quotation) && (
              <Stack>
                <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                  Requested Start Date: {submissionDate}
                </Typography>
                <Typography variant="overline" sx={{ color: theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>
                  Requested Installation Date:{endDate}
                </Typography>
              </Stack>
            )}
          </Box>
        </Stack>
        <Stack
          direction="column"
          spacing={{ xs: 1, sm: 1 }}
        >
          {notes ? (
            <Stack direction="row" spacing={{ xs: 1, sm: 1 }} alignItems="center">
              <Tooltip title="Notes">
                <Notes sx={{color: 'error.main'}}/>
              </Tooltip>
              <Typography variant="caption" sx={{ flexWrap: 'wrap', color: 'error.main', whiteSpace: 'pre-line' }}>
                {formattedNotes}
              </Typography>
            </Stack>
          ) : (
            ''
          )}
          {details?.no_charge_reason && (
            <Stack direction="row" spacing={{ xs: 1, sm: 1 }} alignItems="center">
              <Typography variant="caption" sx={{ color: 'yellow' }}>
                No Charge Reason:
              </Typography>
              <Typography variant="caption" sx={{ flexWrap: 'wrap', color: 'yellow', whiteSpace: 'pre-line' }}>
                {details?.no_charge_reason}
              </Typography>
            </Stack>
          )}
          {Number(details?.change_order) === 1 && details?.change_order_reason && (
            <Stack direction="row" spacing={{ xs: 1, sm: 1 }} alignItems="center">
              <Typography variant="caption" sx={{ color: 'yellow' }}>
                Change Order Reason:
              </Typography>
              <Tooltip
                title={details.change_order_reason.length > 30 ? details.change_order_reason : ''}
                disableHoverListener={details.change_order_reason.length <= 30}
              >
                <Typography
                  component="span"
                  variant="caption"
                  sx={{ flexWrap: 'wrap', color: 'yellow', whiteSpace: 'pre-line'}}
                >
                  {details.change_order_reason.length > 30
                    ? `${details.change_order_reason.slice(0, 30)}...`
                    : details.change_order_reason}
                </Typography>
              </Tooltip>
            </Stack>
          )}
        </Stack>
        </Stack>
          );

          if (useAccordion) {
            const accordionBorderColor = theme.palette.mode === 'light'
              ? theme.palette.divider
              : alpha(theme.palette.common.white, 0.14);
            const accordionBg = theme.palette.mode === 'light'
              ? theme.palette.background.paper
              : alpha(theme.palette.common.white, 0.04);

            return (
              <Fragment key={sectionKey}>
                {showGroupedHeading ? (
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mt: 2,
                      mb: 0.5,
                      fontWeight: 700,
                      color: theme.palette.mode === 'light' ? '#000000' : '#ffffff',
                    }}
                  >
                    {`Grouped Sales Orders (${groupedMemberDetailSections.length})`}
                  </Typography>
                ) : null}
              <Accordion
                key={sectionKey}
                elevation={0}
                sx={{
                  border: `1px solid ${accordionBorderColor}`,
                  borderRadius: 2,
                  bgcolor: accordionBg,
                  color: theme.palette.mode === 'light' ? '#000000' : '#ffffff',
                  overflow: 'hidden',
                  boxShadow: theme.palette.mode === 'light'
                    ? '0 1px 4px rgba(0, 0, 0, 0.08)'
                    : '0 4px 12px rgba(0, 0, 0, 0.35)',
                  '&:before': { display: 'none' },
                  mb: 1.5,
                  '&.Mui-expanded': {
                    mb: 1.5,
                  },
                  '&:last-of-type': {
                    mb: 0,
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon
                      sx={{
                        fontSize: 22,
                        color: theme.palette.mode === 'light' ? '#000000' : '#ffffff',
                      }}
                    />
                  }
                  sx={{
                    px: 2.5,
                    py: 1,
                    minHeight: 48,
                    '& .MuiAccordionSummary-content': {
                      my: 0.25,
                    },
                    '&.Mui-expanded': {
                      minHeight: 48,
                      borderBottom: `1px solid ${accordionBorderColor}`,
                    },
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 600,
                      fontSize: '0.95rem',
                      lineHeight: 1.4,
                      color: theme.palette.mode === 'light' ? 'primary.main' : 'primary.light',
                      ...PRESERVE_WHITESPACE_SX,
                    }}
                  >
                    {salesOrderAccordionTitle}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    px: 2.5,
                    py: 2.5,
                    pt: 2,
                  }}
                >
                  {sectionBody}
                </AccordionDetails>
              </Accordion>
              </Fragment>
            );
          }

          return (
            <Stack
              key={sectionKey}
              spacing={3}
              sx={sectionIndex > 0 ? { pt: 2, borderTop: `1px solid ${theme.palette.divider}` } : undefined}
            >
              {sectionBody}
            </Stack>
          );
        })}
        </Stack>
        {/* <Grid container spacing={2}> */}
          {/* <Scrollbar> */}
          {(() => {
            const quotationStatus = Number(
              invoice?.quotation_status ?? details?.quotation_status,
            )
            const isDraftEstimate =
              quotationStatus === 1 ||
              Number(invoice?.is_draft ?? details?.is_draft) === 1
            // BACKUP: hid all request estimates with quotation_status < 3 — draft (status 1) lost product list
            const hideRequestEstimateProducts =
              !empty(quotation) &&
              Number(invoice?.is_request_estimate ?? details?.is_request_estimate) ===
                1 &&
              quotationStatus < 3 &&
              !isDraftEstimate
            return project || fromProposal || hideRequestEstimateProducts ? null : (
            <Stack>
              <Box
              sx={{
                border: '1px solid',
                borderColor: theme.palette.divider,
                padding: 2,
                overflow: 'auto'
              }}
            >
                {/* {((details?.job_category_name == 'Time & Material') && (details?.allInstallationCompleted == 1)) ?  */}
                {useTmProductLayout ? 
                  <>
                    {(invoice?.cust_product?.filter(item=>item.material != 1)?.length > 0) ? <>
                      <Typography variant='h6'>{'Products' }</Typography>
                      <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>{'PRODUCT & NOTE' }</TableCell>
                              {/* {invoice?.cust_product?.filter(item=>item.material != 1)?.some(item => item.product_notes) && <TableCell>SKU</TableCell>} */}
                              {canViewCosts && <TableCell>UNIT PRICE EACH</TableCell>}
                              <TableCell align="center">SKU</TableCell>
                              <TableCell>QTY</TableCell>
                              {/* <TableCell>MARKETING ADJUSTMENT (%)</TableCell> */}
                              {canViewCosts && <TableCell>SUB TOTAL</TableCell>}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {sortCustomerProductsByIndex(invoice?.cust_product?.filter(item=>item.material != 1))?.map((val,i) => {
                              const { vid, product_name, product_notes,vpt_number, product_price, product_retail_price, adjustment, 
                                quantity, locationQuantity, product_total, discount, unit, unit_qty, material,rfp,markAdjType,
                                services = [],
                              } = val
                              console.log('val--------------',val);
                              const labourService = services?.find(service => service.labour_cost_service_id === 10);
                              const minusAmountLabourInstall = (labourService?.service_original_cost * labourService?.prQty) || 0;

                              let unitName = UNITS?.filter((item) => item?.id == unit)
                              unitName = unitName[0]?.name
                              let shortUnitName = ''
                              if (unitName == 'Square feet') {
                                shortUnitName = 'Sq ft'
                              } else if (unitName == 'Lineal feet') {
                                shortUnitName = 'Lin ft'
                              } else if (unitName == 'Square Inches') {
                                shortUnitName = 'Sq Inches'
                              } else {
                                shortUnitName = 'Unit'
                              }
                              //  subTotal += product_total    
                              let SPMA = 0
                              if(markAdjType==2 || markAdjType==3){
                                SPMA = (product_retail_price || 0) +  (adjustment ? Number(adjustment) : 0)
                
                              }else{

                                SPMA = (product_retail_price || 0) + (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)
                              }
                              SPMA = parseFloat(SPMA)?.toFixed(2)           
                              // let rowTotal = 0
                              // if (markAdjType == 1){
                              //   rowTotal = product_total ? ( product_total - minusAmountLabourInstall)?.toFixed(2) : 0.00
                              // }else{
                              //   rowTotal = ((SPMA * (locationQuantity * quantity))-minusAmountLabourInstall).toFixed(2)
                              // }
                              // customerProductTotal = rowTotal ? rowTotal?.toFixed(2) : 0.00
                              let rowTotal = 0;

                              if (markAdjType == 1) {
                                  rowTotal = product_total || 0.00;
                              } else {
                                  rowTotal = (SPMA * (locationQuantity * quantity) - minusAmountLabourInstall);
                              }

                              // Ensure rowTotal is a number before calling toFixed
                              if (typeof rowTotal === 'number') {
                                  customerProductTotal = rowTotal.toFixed(2);
                              } else {
                                  customerProductTotal = "0.00"; // Handle the case where rowTotal isn't a valid number
                              }
                              console.log('customerProductTotal', customerProductTotal , invoice?.jobcostTotal)
                              return (

                                <TableRow key={vid} sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                }}>
                                  <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                    {/* <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_name}</Typography> */}
                                    {product_notes ? 
                                      <Typography variant='subtitle2' sx={{fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-line' }}>{product_notes}</Typography> 
                                    : 
                                    <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_name}</Typography>
                                    }
                                   {(material === 1 && rfp === 0 && details?.job_category_name != 'Time & Material') && (
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                      (Addl. Material{val?.stock_type === 1 
                                        ? ' - Finished' 
                                        : val?.stock_type === 2 
                                          ? ` - Partial (${UNITS?.find(u => u.id === val?.convertion_unit)?.short_name || 'Unit'})` 
                                          : ''})
                                    </Typography>
                                  )}
                                  {(material === 1 && rfp === 1 && details?.job_category_name != 'Time & Material') && (
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                      (Material)
                                    </Typography>
                                  )}

                                  </TableCell>
                                  {/* {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>{product_notes ? vpt_number : ''}</TableCell> : ''} */}
                                  {canViewCosts && (
                                  <TableCell>{SPMA ? SPMA : 0.00}  {minusAmountLabourInstall && minusAmountLabourInstall > 0? "(Included Labor Install)" :""}</TableCell>
                                  )}
                                  {/* <TableCell align="center">{material === 1 ? '1' : quantity} ({shortUnitName})</TableCell> */}
                                  <TableCell align="center">{vpt_number ? vpt_number : '-'}</TableCell>
                                  <TableCell>{locationQuantity}</TableCell>
                                  {/* <TableCell>{discount ? discount?.toFixed(2) : 0.00}</TableCell> */}
                                  {/* <TableCell>{(material === 1 || rfp === 1) ? 0.00 : adjustment ? Number(adjustment)?.toFixed(2) : 0.00}</TableCell> */}
                                  
                                  {canViewCosts && (markAdjType==1?
                                <TableCell>{product_total ?(product_total)?.toFixed(2) : 0.00}</TableCell>
                                // <TableCell>{product_total ?( product_total)?.toFixed(2) : 0.00}</TableCell>
                              :
                              <TableCell>{(SPMA * (locationQuantity * quantity))?.toFixed(2)}</TableCell>

                              )}
                                  {/* <TableCell>{product_total ? product_total?.toFixed(2) : 0.00}</TableCell> */}
                                </TableRow>
                              )
                            }
                            )}

                          </TableBody>
                        </Table>
                      </TableContainer>
                    </> : null}
                    <Typography variant='h6' sx={{ mt: 2 }}>{(labourInstallService?.length > 0 ) ? ((details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "Services(Labor Install)" : 'Services(Labor Install)') : ""}</Typography>
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      {(labourInstallService?.length > 0 ) &&
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={2}>NAME</TableCell>
                            {canViewCosts && <TableCell>COST (HOURLY)</TableCell>}
                            <TableCell>HOURS</TableCell>
                            {canViewCosts && <TableCell>TOTAL COST</TableCell>}
                          </TableRow>
                        </TableHead>}
                      <TableBody>
                      {labourInstallService?.map((ser) => {
                          console.log('invoiceSelectedServices--@@ 1', ser);
                          return (
                            <TableRow sx={{
                              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            }}>
                              <TableCell colSpan={2}>{ser?.name}-({ser.productName})</TableCell>
                              {canViewCosts && <TableCell>{ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>}
                              <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                              {canViewCosts && <TableCell>{ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>}
                            </TableRow>
                          )
                        })}
                        </TableBody>
                        </Table>
                    </TableContainer>
                    {(!empty(invoice?.jobcost_product)) ? 
                    <>
                    <Typography variant='h6' sx={{ mt: 2 }}>Materials</Typography> 
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={2}>NAME</TableCell>
                            {canViewCosts && <TableCell>UNIT COST</TableCell>}
                            <TableCell>QUANTITY</TableCell>
                            {canViewCosts && <TableCell>TOTAL COST</TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {invoice?.jobcost_product?.map((val,index) => {
                            const { id, product_name, material_notes, unit_price, quantity,actual_total,actual_quantity, total, unit,partial_unit, unit_qty } = val
                            let unitToUse = partial_unit ? partial_unit : unit
                            let unitName = UNITS?.filter((item) => item?.id == unitToUse)
                            let shortUnitName = unitName[0]?.short_name || 'Unit'
                            unitName = unitName[0]?.name
                            return (
                              <TableRow sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                              }}>
                                <TableCell colSpan={2}>
                                  {material_notes ? 
                                    <Typography variant='subtitle2' sx={{fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-line', color: 'error.main' }}>{material_notes}</Typography> 
                                  : 
                                    <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_name}</Typography>
                                  }
                                </TableCell>
                                {canViewCosts && <TableCell> {unit_price}</TableCell>}
                                <TableCell>{quantity}({shortUnitName})</TableCell>
                                {canViewCosts && <TableCell> {total}</TableCell>}
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    </>
                    : ''}
                    {/* {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.length > 0 ? <Typography variant='h6' sx={{ mt: 2 }}>Additional Services</Typography> : ''} */}
                    <TableContainer>
                        <Table>
                        {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.length > 0 ? 
                        <>
                          <TableHead>
                            <TableRow>
                              <TableCell>Sl No.</TableCell>
                              <TableCell>ADDITIONAL SERVICES</TableCell>
                              <TableCell >DESCRIPTION</TableCell>
                              {
                              details?.is_split_order && details?.project_category != 15 && canViewCosts ?
                              <TableCell>WHOLESALE COST</TableCell>
                              : null
                              }
                              {
                                details?.is_split_order && details?.project_category != 15 && canViewCosts ?
                                <TableCell>SPLIT MARKUP</TableCell>
                                : null
                              }
                              {canViewCosts && <TableCell>HOURLY COST</TableCell>}
                              <TableCell>HOURS</TableCell>
                              {canViewCosts && <TableCell>TOTAL COST</TableCell>}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.map((ser,index) => {
                              const facility = FacilityTypes.find(
                                f => Number(f.id) === Number(ser?.facility_id)
                              );
                            const facilityColor = theme.palette[facility?.color]?.main || 'inherit';
                              return (
                                <TableRow sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                }}>
                                  <TableCell>{index + 1}</TableCell>
                                   <TableCell > 
                                        <Box>
                                          <Typography sx={{ color: facilityColor }}>
                                            {(ser?.service_name || ser?.name )}{(ser?.installation_status && details?.mixed_installation) ? <> {' '}<Label variant="filled" color="warning">{getInstallationStatusLabel(ser.installation_status)}</Label></> : ''}
                                          </Typography>
                                          
                                          {ser?.service_notes && (
                                            <Stack direction="column">
                                              <Typography
                                                variant="body2"
                                                sx={{
                                                  wordBreak: 'break-word',
                                                  overflowWrap: 'break-word',
                                                  color: 'error.main',
                                                  whiteSpace: 'pre-line'
                                                }}
                                              >
                                                Note :{ser.service_notes}
                                              </Typography>
                                            </Stack>
                                          )}
                                        </Box>
                                      </TableCell>
                                    <TableCell>
                                      {ser?.service_desc ? (
                                        <Tooltip title={ser.service_desc || ser.description} arrow>
                                          <Typography
                                            variant='body2'
                                            sx={{
                                              wordBreak: 'break-word',
                                              overflowWrap: 'break-word',
                                              color: facilityColor,
                                              whiteSpace: 'nowrap',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              width: '150px', // Limit the width to 120px
                                              cursor: 'pointer',
                                            }}
                                          >
                                            {ser.service_desc || ser.description}
                                          </Typography>
                                        </Tooltip>
                                      ) : (
                                        '-'
                                      )}
                                    </TableCell>
                                      {
                                    details?.is_split_order && details?.project_category != 15 && canViewCosts ?
                                      <TableCell>{
                                        ser?.facility_id != currentFacilityId ? ser?.costWithOutgoing || 0 : '-'}</TableCell>
                                      : null
                                  } 
                                  {
                                    details?.is_split_order && details?.project_category != 15 && canViewCosts ?
                                      <TableCell>{
                                        ser?.facility_id != currentFacilityId ? `${ser?.incoming_split_percentage ?? 0}%` : '-'}</TableCell>
                                      : null
                                  }
                                  {canViewCosts && (
                                  <Tooltip 
                                  title={
                                    (details?.is_split_order && details?.project_category != 15 && 
                                      ser.facility_id != currentFacilityId) 
                                      ? `wholesale cost + (wholesale cost * incoming split markup (${ser?.incoming_split_percentage || incomingSplitMarkup || 0}) / 100)`
                                      : ""
                                  }
                                >
                                  <TableCell>{ser ? parseFloat(ser?.service_original_cost)?.toFixed(2) : 0}</TableCell>
                                  </Tooltip> 
                                  )}
                                  {/* <TableCell>{ser ? parseFloat(ser?.jobcost_quantity)?.toFixed(2) : 0}</TableCell> */}
                                  <TableCell>{ser ? parseFloat(ser?.quantity)?.toFixed(2) : 0}</TableCell>
                                  {canViewCosts && <TableCell>{ser ? ser?.total_service_cost : 0}</TableCell>}
                                </TableRow>
                              )
                            })}
                          </TableBody>
                        </> : ''}
                        {canViewCosts && (invoice?.jobcostTotal && invoice?.jobcostTotal > 0) ? (
                          <RowResultStyle>
                              <TableCell colSpan={summaryColSpan} />
                              <TableCell align="right">
                              <Typography variant="overline">Material Total</Typography>
                            </TableCell>
                            <TableCell align="left" width={10}>
                              <Typography variant="overline">${invoice ? invoice?.jobcostTotal?.toFixed(2) : 0.00}</Typography>
                            </TableCell>
                          </RowResultStyle>
                        ) : ''}
                        {/* {(invoice?.project_category == 12 && details?.allInstallationCompleted == 1) ? '' : */}
                        {(treatInvoiceAsTimeMaterial || !canViewCosts) ? '' :
                        <RowResultStyle>
                          <TableCell colSpan={summaryColSpan} />
                          <TableCell align="right">
                            <Typography variant="overline">Product Total</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            {/* <Typography variant="overline">
                              ${invoice?.cust_product?.reduce((sum, val) => {
                                const {
                                  product_retail_price = 0, adjustment = 0, markAdjType,
                                  product_total = 0, locationQuantity = 1, quantity = 1,
                                  services = []
                                } = val;

                                const labourService = services?.find(s => s.labour_cost_service_id === 10);
                                const labourTotal = (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * locationQuantity;

                                let SPMA = (markAdjType === 2 || markAdjType === 3)
                                  ? product_retail_price + Number(adjustment)
                                  : product_retail_price + ((product_retail_price * Number(adjustment)) / 100);

                                const effectiveTotal = markAdjType === 1
                                  ? product_total - labourTotal
                                  : (SPMA * (locationQuantity * quantity)) - labourTotal;

                                return sum + effectiveTotal;
                              }, 0)?.toFixed(2)}
                            </Typography> */}
                            <Typography variant="overline">
                            {/* ${invoice?.cust_product?.reduce((sum, val) => {
                                const {
                                  product_retail_price = 0, adjustment = 0, markAdjType,adj_value_type,
                                  product_total = 0,actual_retail_price,install_cost, locationQuantity = 1, quantity = 1,
                                  services = []
                                } = val;

                                const labourService = services?.find(s => s.labour_cost_service_id === 10);
                                const labourTotal = (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * locationQuantity;
                                console.log('labourTotal', labourTotal)
                                const basePrice = actual_retail_price !== 0 && actual_retail_price != null
                                ? actual_retail_price
                                : product_retail_price;
                                // let SPMA = (markAdjType === 2 || markAdjType === 3)
                                //   ? product_retail_price + Number(adjustment)
                                //   : product_retail_price + ((product_retail_price * Number(adjustment)) / 100);

                                // const effectiveTotal = markAdjType === 1
                                //   ? product_total
                                //   : (SPMA * (locationQuantity * quantity));
                                let SPMA = (markAdjType === 2 || markAdjType === 3)
                                  ? basePrice //+ Number(adjustment)
                                  : basePrice //+ ((basePrice * Number(adjustment)) / 100);

                                const effectiveTotal = markAdjType === 1
                                // ? product_total
                                ? (SPMA * (locationQuantity * quantity))
                                : (SPMA * (locationQuantity * quantity));
                                console.log('effectiveTotal', effectiveTotal)
                                
                                return sum + effectiveTotal;
                              }, 0)?.toFixed(2)} */}
                              ${requestInvoiceProductTotalFromRows.toFixed(2)}
                            </Typography>
                          </TableCell>
                        </RowResultStyle>
                        }
                        {canViewCosts && (
                        <RowResultStyle>
                          <TableCell colSpan={summaryColSpan} />
                          <TableCell align="right">
                            <Typography variant="overline">Install Total</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            {/* <Typography variant="overline">
                                ${invoice?.cust_product?.reduce((sum, val) => {
                                  const labourService = val?.services?.find(s => s.labour_cost_service_id === 10);
                                  return sum + (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * (val?.locationQuantity || 1);
                                }, 0)?.toFixed(2)}
                            </Typography> */}
                            <Typography variant="overline">
                              ${(
                                //   (invoice?.cust_product?.reduce((sum, val) => {
                                //     const labourService = val?.services?.find(
                                //       s => s.labour_cost_service_id === 10
                                //     );
                                //     return (
                                //       sum +
                                //       (labourService?.service_original_cost || 0) *
                                //         (labourService?.prQty || 0) *
                                //         (val?.locationQuantity || 1)
                                //     );
                                //   }, 0) || 0) +
                                //   (additionalSelectedServices?.reduce(
                                //     (s, x) =>
                                //       x.labour_cost_service_id === 10 ? s + (x.total_cost || 0) : s,
                                //     0
                                //   ) || 0)
                                // ).toFixed(2)

                                // (invoice?.cust_product?.reduce((sum, val) => {
                                //   const installCost = parseFloat(val?.install_cost || 0);
                                //   const installQty = parseFloat(
                                //     val?.install_qty ?? val?.install_quantity ?? 1,
                                //   );

                                //   if (installCost) {
                                //     return sum + installCost * installQty;
                                //   }
                                //   return sum;
                                // }, 0) || 0) +
                                (requestInvoiceInstallTotalFromRows || 0) +
                                  (additionalSelectedServices?.reduce(
                                    (s, x) =>
                                      x.labour_cost_service_id === 10 ? s + (x.total_cost || 0) : s,
                                    0
                                  ) || 0)
                                ).toFixed(2)}
                            </Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}

                         {canViewCosts && (
                         <RowResultStyle>
                          <TableCell colSpan={summaryColSpan} />
                          <TableCell align="right">
                            {/* <Typography variant="overline">{details?.job_category_name != 'Service only' ? 'Additional Labor Cost' : 'Labor Cost'}</Typography> */}
                            {/* <Typography variant="overline">{(details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? 'Additional Services' : 'Services'}</Typography> */}
                            <Typography variant="overline">{(details?.job_category_name != 'Service only') ? 'Additional Services Total' : 'Services Total'}</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            {/* <Typography variant="overline">${details ? details?.labour_cost?.toFixed(2) : 0.00}</Typography> */}
                            <Typography variant="overline">
                              ${(
                                (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                // (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                (additionalSelectedServices?.reduce(
                                    (s, x) =>
                                      x.labour_cost_service_id === 10 
                                        ? s
                                        : s + (x.total_cost || 0),
                                    0
                                ) || 0) +
                                (cartService?.reduce((s, x) => {
                                  const sp = x.sellingPrice || x.unit_cost || 0;
                                  const markup = x.originalMarkup || x.product_markup || 0;
                                  const final = sp + (sp * markup / 100);
                                  return s + ((x.qty || 0) * final);
                                }, 0) || 0)
                              )?.toFixed(2)}
                            </Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}

                        {canViewCosts && (details?.job_category_name != 'Service only' || subTotal > 0 || (!treatInvoiceAsTimeMaterial && (requestInvoiceCustProductSubtotalForServices || 0) > 0)) && (
                        <RowResultStyle>
                          <TableCell colSpan={summaryColSpan} />
                          <TableCell align="right">
                            <Typography variant="overline">Subtotal</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">
                              ${fUSPrice(
                                (treatInvoiceAsTimeMaterial ? (subTotal || 0) : (requestInvoiceCustProductSubtotalForServices || 0)) +
                                // (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                (cartService?.reduce((s, x) => {
                                  const sp = x.sellingPrice || x.unit_cost || 0;
                                  const markup = x.originalMarkup || x.product_markup || 0;
                                  const final = sp + (sp * markup / 100);
                                  return s + ((x.qty || 0) * final);
                                }, 0) || 0)
                              )}
                            </Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}

                        {canViewCosts && invoice?.extra_discount > 0 && (
                        <RowResultStyle>
                          <TableCell colSpan={summaryColSpan} />
                          <TableCell align="right">
                            <Typography variant="overline">Discount</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">${invoice ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}

                        {/* {invoice?.tax_amount > 0 && ( */}
                        {canViewCosts && (
                        <RowResultStyle>
                          <TableCell colSpan={summaryColSpan} />
                          <TableCell align="right">
                            <Typography variant="overline">Tax</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">${invoice ? invoice?.tax_amount?.toFixed(2) : 0.00}</Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}
                        {/* )} */}

                        {canViewCosts && showRushFee && (
                        <RowResultStyle>
                          <TableCell colSpan={summaryColSpan} />
                          <TableCell align="right">
                            <Typography variant="overline">Rush Fee</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">${Number(rushFeeAmount || 0).toFixed(2)}</Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}

                        {canViewCosts && (
                        <RowResultStyle>
                          <TableCell colSpan={summaryColSpan} />
                          <TableCell align="right">
                            <Typography variant="subtitle1"  sx={{ color: displayInvoiceTotal < 0 ? 'red' : 'inherit' }}>Total</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="subtitle1"  sx={{ color: displayInvoiceTotal < 0 ? 'red' : 'inherit' }}>${fUSPrice(displayInvoiceTotal ?? 0)}</Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}

                        {canViewCosts && invoice?.project_category != 13 ? 
                          <>
                            {(userType !=3 && details?.job_category_name != 'Time & Material' && details?.job_category_name != 'No Charge') ?
                            (details?.billing_type ? (
                            <RowResultStyle>
                              <TableCell colSpan={summaryColSpan} />
                              <TableCell align="right" sx={{display:"flex", alignItems: "center",gap: 1}}>
                                <Typography fontSize={"small"} variant="caption"  sx={{ color:  'inherit' }}> (only viewable for admin)</Typography>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>Billing Type</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>{details?.billing_type ? `${details?.billing_type} %` :"Nil"}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            ) : '') :""}
                          {(invoice?.total && details?.billing_type) ?
                            <RowResultStyle>
                              <TableCell colSpan={summaryColSpan} />
                              <TableCell align="right">
                                <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>Minimum Payable Amount</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>${(displayInvoiceTotal && details?.billing_type)? parseFloat((displayInvoiceTotal *details?.billing_type) / 100).toFixed(2) :0.00}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            :""
                            }
                            {calculatedPaidAmount > 0 && (
                            <RowResultStyle>
                                <TableCell colSpan={summaryColSpan} />
                                <TableCell align="right">
                                <Typography variant="subtitle1"  sx={{ color: calculatedPaidAmount < 0 ? 'red' : 'green' }}>Amount Paid</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color: calculatedPaidAmount < 0 ? 'red' : 'green' }}>${calculatedPaidAmount ? parseFloat(calculatedPaidAmount)?.toFixed(2) : 0.00}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            )}
                            {calculatedPaidAmount > 0 && (
                            <RowResultStyle>
                                <TableCell colSpan={summaryColSpan} />
                                <TableCell align="right">
                                <Typography variant="subtitle1"  sx={{ color: calculatedDueAmount <= 0 ? 'inherit' : 'red' }}>Balance Due</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color: calculatedDueAmount <= 0 ? 'inherit' : 'red' }}>${calculatedDueAmount ? parseFloat(calculatedDueAmount <= 0 ? 0.00 : calculatedDueAmount)?.toFixed(2) : 0.00}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            )}
                          </>
                        : ''}
                      </Table>
                    </TableContainer>
                    {(details?.allInstallationCompleted == 1 && !empty(invoice?.note_data)) ? (
                      <>
                        <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>Installation Notes</Typography>
                        <Stack spacing={2}>
                          {invoice?.note_data?.map((val, index) => {
                            const { id, authorized_by, note, timestamp } = val;
                            return (
                              <Paper
                                key={id}
                                elevation={3}
                                sx={{ padding: 2, borderRadius: 2, backgroundColor: 'rgba(145, 158, 171, 0.16)', color: '#ffffff' }}
                              >
                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={8}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', whiteSpace: 'pre-wrap' }}>
                                      {note}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                                    {/* <Typography variant="body2" sx={{ color: 'primary.light' }}> */}
                                    <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                      Added By: {authorized_by}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                      {moment.unix(timestamp).format('MM-DD-YYYY hh:mm:ss A')}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Paper>
                            );
                          })}
                        </Stack>
                      </>
                    ) : ''}
                  </> :
                  <>
                  {(invoice?.cust_product?.length > 0) ? <>
                  <Typography variant='h6'>{details?.job_category_name != 'Time & Material' ? 'Products' : 'Products'}</Typography>
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Sl No.</TableCell>
                          {/* <TableCell align="center"></TableCell> */}
                          {(details?.is_split_order && details?.project_category != 15) ? <TableCell align="center">STATUS</TableCell> : null}
                          <TableCell>PRODUCT & NOTE</TableCell>
                          <TableCell>Product Formula</TableCell>
                          <TableCell>DESCRIPTION</TableCell>
                          {/* {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>SKU</TableCell> : ''} */}
                          <TableCell align="center">SKU</TableCell>
                          <TableCell align="center">QTY</TableCell>
                          {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && !details?.real_for_parent_facility && userType != 3 && canViewCosts) ? <TableCell align="center">WHOLESALE PRICE</TableCell> : ''}
                          {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && !details?.real_for_parent_facility && userType != 3 && canViewCosts) ? <TableCell align="center">SPLIT MARKUP</TableCell> : ''}
                          {canViewCosts && <TableCell align="center">UNIT PRICE EACH</TableCell>}
                          {/* <TableCell align="center">Marketing Adjustment</TableCell> */}
                          {/* <Tooltip title={"(Unit Price Each * Qty) +/- Marketing Adjustment"}> */}
                          {canViewCosts && <TableCell>TOTAL</TableCell>}
                          {/* </Tooltip> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {sortCustomerProductsByIndex(groupedInvoiceDisplayRows)?.map((row,i) => {
                          const displaySlNo = i + 1
                          if (row?.__type === 'group') {
                            const representative = row?.representative || {}
                            const facility = FacilityTypes?.find(
                              (f) => f.id == representative?.facility_id,
                            )
                            const facilityColor =
                              theme.palette[facility?.color]?.main || 'inherit'
                            const groupName =
                              row?.groupMeta?.group_name ||
                              representative?.group_name ||
                              `Group ${row?.groupId}`
                            const groupDescription =
                              row?.groupMeta?.group_description ||
                              representative?.group_description ||
                              '-'
                            const memberNames = (row?.members || [])
                              .map((item) => item?.product_name)
                              .filter(Boolean)
                              .join(', ')

                            const members = row?.members || []
                            const groupProductDisplayQty = Number(row?.groupProductDisplayQty ?? 1) || 1
                            const groupInstallDisplayQty = Number(row?.groupInstallDisplayQty ?? 1) || 1
                            const groupInstallSubtotal = Number(row?.groupInstallSubtotal ?? 0)
                            const groupHasInstall = Boolean(row?.groupHasInstall)
                            const displayGroupTotal = groupHasInstall
                              ? Number(row?.groupProductOnlyTotal ?? 0)
                              : Number(row?.totalValue || 0)
                            const unitEach = Number(row?.adjustedGroupRetailEach ?? 0)
                            const groupInstallUnitEach = Number(
                              row?.adjustedGroupInstallRetailEach ?? 0,
                            )
                            const groupInstallNotes = getGroupInstallNotesDisplay(members)
                            const groupDisplayNote =
                              members.find(
                                (m) =>
                                  m?.product_notes != null &&
                                  String(m.product_notes).trim() !== '',
                              )?.product_notes || ''
                            const { isGroupProductLosingMoney, isGroupInstallLosingMoney } =
                              getGroupLosingMoneyFlags({
                                id: row?.groupId,
                                groupAdjValueType:
                                  row?.groupAdjValueType ??
                                  row?.groupMeta?.product_marketing_adj_value_type ??
                                  row?.groupMeta?.productMarketingAdjValueType,
                                groupInstallAdjValueType:
                                  row?.groupInstallAdjValueType ??
                                  row?.groupMeta?.install_marketing_adj_value_type ??
                                  row?.groupMeta?.installMarketingAdjValueType,
                                baseProductFormulaEach:
                                  row?.groupMeta?.product_total_formula_each ??
                                  row?.groupMeta?.productTotalFormulaEach,
                                baseInstallFormulaEach:
                                  row?.groupMeta?.install_total_formula_each ??
                                  row?.groupMeta?.installTotalFormulaEach,
                                adjustedGroupRetailEach: row?.adjustedGroupRetailEach,
                                adjustedGroupInstallRetailEach:
                                  row?.adjustedGroupInstallRetailEach,
                                totalProductFormulaEach:
                                  row?.groupMeta?.product_total_formula_each ??
                                  row?.groupMeta?.productTotalFormulaEach,
                                totalInstallFormulaEach:
                                  row?.groupMeta?.install_total_formula_each ??
                                  row?.groupMeta?.installTotalFormulaEach,
                              })
                            const getViewRequestLosingMoneyRowSx = (isLosingMoneyItem) =>
                              isLosingMoneyItem
                                ? {
                                    '& .MuiTableCell-root, & .MuiTableCell-root .MuiInputBase-input, & .MuiTableCell-root .MuiFormLabel-root':
                                      {
                                        color: `${theme.palette.error.main} !important`,
                                      },
                                  }
                                : undefined
                            const productGroupRowSx = getViewRequestLosingMoneyRowSx(
                              isGroupProductLosingMoney,
                            )
                            const installGroupRowSx = getViewRequestLosingMoneyRowSx(
                              isGroupInstallLosingMoney,
                            )
                            const groupProductTextColor = isGroupProductLosingMoney
                              ? `${theme.palette.error.main} !important`
                              : `${facilityColor} !important`

                            return (
                              <React.Fragment key={`group-${row?.groupId}`}>
                                <TableRow sx={productGroupRowSx || installGroupRowSx}>
                                  <TableCell sx={{ color: facilityColor }}>{displaySlNo}</TableCell>
                                  {(details?.is_split_order && details?.project_category != 15) ? (
                                    <TableCell align="center" sx={{ width: '90px', minWidth: '90px' }}>
                                      -
                                    </TableCell>
                                  ) : null}
                                  <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                    <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', color: groupProductTextColor }}>
                                      {groupName}
                                    </Typography>
                                    {groupDisplayNote ? (
                                      <Typography
                                        variant='body2'
                                        sx={{
                                          color: 'error.main',
                                          whiteSpace: 'pre-wrap',
                                          wordBreak: 'break-word',
                                          overflowWrap: 'break-word',
                                        }}
                                      >
                                        Note: {groupDisplayNote}
                                      </Typography>
                                    ) : null}
                                    {/* <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', color: facilityColor }}>
                                      ({row?.members?.length || 0} grouped products)
                                    </Typography> */}
                                    {/* {memberNames ? (
                                      <Typography variant='body2' sx={{ mt: 0.5, whiteSpace: 'pre-wrap', color: 'error.main' }}>
                                        Includes: {memberNames}
                                      </Typography>
                                    ) : null} */}
                                  </TableCell>
                                    {/* {invoice.quotation_status==4 || (invoice.quotation === 0 && invoice.quotation_status === 4 && invoice.hold === 0) ?'':(<TableCell align="center" sx={{ color: facilityColor }}>-</TableCell>)} */}
                                    <TableCell sx={{ color: facilityColor }}>-</TableCell>
                                  <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                    <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', color: groupProductTextColor }}>
                                      {groupDescription}
                                    </Typography>
                                  </TableCell>
                                  {/* {!fromQtuotation &&<TableCell align="center" sx={{ color: facilityColor }}>-</TableCell>} */}
                                  <TableCell align="center" sx={{ color: facilityColor }}>-</TableCell>
                                  <TableCell align="center" sx={{ color: facilityColor }}>
                                    {groupProductDisplayQty}
                                  </TableCell>
                                  {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && !details?.real_for_parent_facility && userType != 3 && canViewCosts) ?
                                    <TableCell align="center" sx={{ color: facilityColor }}>-</TableCell>
                                    : ''
                                  }
                                  {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && !details?.real_for_parent_facility && userType != 3 && canViewCosts) ?
                                    <TableCell align="center" sx={{ color: facilityColor }}>-</TableCell>
                                    : ''
                                  }
                                  {canViewCosts && (
                                    <TableCell align="center" sx={{ color: facilityColor }}>
                                      ${Number(unitEach || 0).toFixed(2)}
                                    </TableCell>
                                  )}
                                  {canViewCosts && (
                                    <TableCell sx={{ color: facilityColor }}>
                                      ${Number(displayGroupTotal || 0).toFixed(2)}
                                    </TableCell>
                                  )}
                                </TableRow>
                                {groupHasInstall ? (
                                  <TableRow sx={installGroupRowSx || productGroupRowSx}>
                                    <TableCell sx={{ color: facilityColor }} />
                                    {(details?.is_split_order && details?.project_category != 15) ? (
                                      <TableCell align="center" sx={{ color: facilityColor }} />
                                    ) : null}
                                    
                                    <TableCell sx={{ pl: 4, color: facilityColor }}>
                                      <Typography
                                        sx={
                                          isGroupInstallLosingMoney
                                            ? { color: `${theme.palette.error.main} !important` }
                                            : undefined
                                        }
                                      >
                                        {canViewCosts ? 'Install Price' : 'Installation'}
                                      </Typography>
                                      {groupInstallNotes ? (
                                        <Typography
                                          sx={{
                                            color: groupInstallNotes ? 'error.main' : 'inherit',
                                            whiteSpace: 'pre-wrap',
                                          }}
                                        >
                                          {' '}
                                          Note : {groupInstallNotes}
                                        </Typography>
                                      ) : (
                                        ''
                                      )}
                                    </TableCell>
                                    <TableCell sx={{ color: facilityColor }}>-</TableCell>
                                    <TableCell align="center" sx={{ color: facilityColor }}>-</TableCell>
                                    {/* {!fromQtuotation &&<TableCell align="center" sx={{ color: facilityColor }}>-</TableCell>} */}
                                    <TableCell align="center" sx={{ color: facilityColor }}>-</TableCell>
                                    <TableCell align="center" sx={{ color: facilityColor }}>
                                      {groupInstallDisplayQty}
                                    </TableCell>
                                    {(details?.is_split_order &&
                                      details?.origin_facility_id == currentFacilityId &&
                                      !details?.real_for_parent_facility &&
                                      userType != 3 &&
                                      canViewCosts) ? (
                                      <TableCell align="center" sx={{ color: facilityColor }}>
                                        {details?.is_split_order && representative?.facility_id != currentFacilityId
                                          ? '-'
                                          : '-'}
                                      </TableCell>
                                    ) : (
                                      ''
                                    )}
                                    {(details?.is_split_order &&
                                      details?.origin_facility_id == currentFacilityId &&
                                      !details?.real_for_parent_facility &&
                                      userType != 3 &&
                                      canViewCosts) ? (
                                      <TableCell align="center" sx={{ color: facilityColor }}>
                                        {details?.is_split_order && representative?.facility_id != currentFacilityId
                                          ? '-'
                                          : '-'}
                                      </TableCell>
                                    ) : (
                                      ''
                                    )}
                                    {canViewCosts && (
                                      <>
                                        <TableCell align="center" sx={{ color: facilityColor }}>
                                          ${Number(groupInstallUnitEach || 0).toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ color: facilityColor }}>
                                          ${Number(groupInstallSubtotal || 0).toFixed(2)}
                                        </TableCell>
                                      </>
                                    )}
                                  </TableRow>
                                ) : null}
                                <TableRow>
                                  <TableCell colSpan={
                                    (invoice?.cust_product?.some(item => item.product_notes) ? 8 : 7) +
                                   (details?.is_split_order && details?.origin_facility_id == currentFacilityId && !details?.real_for_parent_facility && userType != 3 ? 2 : 0) +
                                   (details?.is_split_order && details?.project_category != 15 ? 1 : 0)
                                   - hiddenPriceColumnCount
                                  }>
                                    <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                                  </TableCell>
                                </TableRow>
                              </React.Fragment>
                            )
                          }
                          const val = row
                          const { vid,split_percentage,wholesale_price, product_name,facility_id,expected_cost,incoming_split_percentage, product_notes,material_notes,vpt_number, product_price, product_retail_price, adjustment, product_index,
                            quantity, locationQuantity,actual_retail_price,install_cost, product_total, discount, unit, unit_qty, material,rfp,markAdjType,adj_value_type,install_qty,install_notes,split_status,split_mirror_status,received_status,installation_acceptance,allInstallation_completed,installation_status,installation_complete_status,minPaymentStatus,project_status,
                            services = [],description,product_desc,recipe_id, quickbookId
                          } = val
                          console.log('val--------------',val);
                          const facility = FacilityTypes?.find(f => f.id == val?.facility_id);
                          const facilityColor = theme.palette[facility?.color]?.main || 'inherit';
                          // Get labor install
                          const labourService = services?.find(service => service.labour_cost_service_id === 10);
                          const minusAmountLabourInstall = (labourService?.service_original_cost * labourService?.prQty) || 0;
                          const labourQty = (labourService?.prQty || 0) * locationQuantity;
                          console.log('labourQtylabourQty', labourQty)
                          const labourRate = labourService?.service_original_cost || 0;
                          const labourTotal = labourQty * labourRate;
                          const labourInitial = (labourService?.prQty || 0) * labourRate;
                          
                          // Unit name logic
                          let unitData = UNITS?.filter((item) => item?.id == unit)
                          let shortUnitName = unitData[0]?.short_name || 'Unit'
                          let unitName = unitData[0]?.name
                          
                          //  subTotal += product_total    
                          let SPMA = 0

                          if(markAdjType==2 || markAdjType==3){
                            SPMA = (product_retail_price || 0) //+  (adjustment ? Number(adjustment) : 0)
                          }else{
                            SPMA = (product_retail_price || 0) //+ (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)
                          }
                          if(material==1){
                            let newSPMA = Number(SPMA) + (adj_value_type==1 ? Number(adjustment) : -Number(adjustment));
                            SPMA = newSPMA
                            console.log('SPMA-material==3',SPMA);
                            console.log('SPMA-material==3',newSPMA);
                            console.log('SPMA-material==3',adj_value_type);
                            console.log('SPMA-material==3',adjustment);
                          }
                          SPMA = parseFloat(SPMA)?.toFixed(2)

                          // Match ViewQuotation / ViewOfficialRequest losing-money condition.
                          // Invoice cust_product often has catalog p.actual_retail_price / p.formula_cost
                          // from joins — prefer order sold price (product_retail_price / SPMA) and
                          // saved order formula (expected_formula_price), then recipe with-markup fields.
                          const recipeInstallFormula = Number(
                            val?.expected_install_labor_cost_with_markup || 0,
                          )
                          const recipeServiceOnly = Math.max(
                            0,
                            Number(val?.expected_service_cost_with_markup || 0) -
                              recipeInstallFormula,
                          )
                          const materialServiceFormula =
                            Number(val?.expected_material_cost_with_markup || 0) +
                            recipeServiceOnly
                          const savedOrderFormulaEach = Number(val?.expected_formula_price || 0)
                          const productFormulaEach =
                            material === 1
                              ? Number(
                                  val?.product_price ??
                                    val?.price ??
                                    val?.formula_cost ??
                                    0,
                                )
                              : val?.inhouse === 0
                                ? Number(
                                    val?.sub_contract_price ||
                                      savedOrderFormulaEach ||
                                      0,
                                  )
                                : savedOrderFormulaEach > 0
                                  ? savedOrderFormulaEach
                                  : materialServiceFormula > 0
                                    ? materialServiceFormula
                                    : Number(val?.unit_cost || 0)
                          const productRetailEach = Math.max(
                            0,
                            Number(
                              material === 1
                                ? SPMA
                                : (val?.product_retail_price ??
                                  SPMA ??
                                  val?.actual_retail_price ??
                                  0),
                            ),
                          )
                          const isNegativeProductAdjustmentMode =
                            val?.adj_value_type === false ||
                            val?.adj_value_type === 0 ||
                            val?.adj_value_type === '0' ||
                            val?.adj_value_type === 'false'
                          const isProductLosingMoney =
                            isNegativeProductAdjustmentMode &&
                            productRetailEach < productFormulaEach

                          const installFormulaEach = Number(
                            val?.expected_install_labor_cost_with_markup ||
                              val?.install_formula_cost ||
                              0,
                          )
                          const installRetailEach = Math.max(
                            0,
                            Number(val?.install_cost || 0),
                          )
                          const isNegativeInstallAdjustmentMode =
                            val?.install_adj_value_type === false ||
                            val?.install_adj_value_type === 0 ||
                            val?.install_adj_value_type === '0' ||
                            val?.install_adj_value_type === 'false'
                          const isInstallLosingMoney =
                            installRetailEach > 0 &&
                            isNegativeInstallAdjustmentMode &&
                            installRetailEach < installFormulaEach

                          const getViewRequestLosingMoneyRowSx = (isLosingMoney) =>
                            isLosingMoney
                              ? {
                                  '& .MuiTableCell-root, & .MuiTableCell-root .MuiInputBase-input, & .MuiTableCell-root .MuiFormLabel-root':
                                    {
                                      color: `${theme.palette.error.main} !important`,
                                    },
                                }
                              : undefined
                          const productLosingMoneyRowSx =
                            getViewRequestLosingMoneyRowSx(isProductLosingMoney)
                          const installLosingMoneyRowSx =
                            getViewRequestLosingMoneyRowSx(isInstallLosingMoney)
                          const productTextColor = isProductLosingMoney
                            ? `${theme.palette.error.main} !important`
                            : `${facilityColor} !important`
                            
                          return (
                            <React.Fragment key={vid}>
                              {/* Product Row */}
                              <TableRow sx={productLosingMoneyRowSx || installLosingMoneyRowSx}>
                                <TableCell sx={{ color: facilityColor }}>{displaySlNo}</TableCell>
                                    {/* {(() => {
                                  const matchingProductTaxItem = quickbookId
                                    ? taxRateItems.find(item => 
                                        String(item.item_id) === String(quickbookId) || 
                                        (item.item_name && String(item.item_name).toLowerCase() === String(product_name).toLowerCase())
                                      )
                                    : taxRateItems.find(item => 
                                        item.item_name && String(item.item_name).toLowerCase() === String(product_name).toLowerCase()
                                      ) || null;
                                  return (
                                    <TableCell 
                                      align="center" 
                                    >
                                      {(isEstimate ? (taxAmount != 0) : (matchingProductTaxItem && matchingProductTaxItem?.is_taxable && taxAmount != 0))
                                        ? <><span class="tabler--letter-t-small"></span> <br /> <span style={{fontSize:"12px"}}> {getTaxPercent(matchingProductTaxItem)}%</span></> 
                                        : '-'}
                                    </TableCell>
                                  );
                                })()} */}
                                {(details?.is_split_order && details?.project_category != 15) ? (
                                  (facility_id == currentFacilityId && material == 0 && rfp == 0) ? (
                                    <TableCell align="center" sx={{ width: '90px', minWidth: '90px' }}>
                                      {console.log('outside of the split status')}
                                      {(() => {
                                        const statusInfo = getStatusColorAndLabel(
                                          details?.status,
                                          details?.installationStatus,
                                          details?.allInstallationCompleted,
                                          details?.installation_acceptance,
                                          details?.min_payment_status,
                                          details?.job_category_name,
                                          details?.billing_type,
                                          details?.installationCompleteStatus,
                                          details?.noServiceNoTask,
                                          details?.proj_status,
                                          details?.partial_install,
                                          details?.received_status
                                        );
                                        const statusText = statusInfo.label.replace('Status: ', '');
                                        const truncatedText = statusText.length > 10 ? statusText.substring(0, 10) + '...' : statusText;

                                        return (
                                          <Tooltip
                                            title={statusText}
                                            enterDelay={300}
                                            leaveDelay={200}
                                          >
                                            <Box sx={{ cursor: 'pointer', display: 'inline-block' }}>
                                              <Label
                                                variant="filled"
                                                color={statusInfo.color}
                                                sx={{
                                                  fontSize: '0.7rem',
                                                  height: '18px',
                                                  minWidth: 'auto',
                                                  maxWidth: '90px',
                                                  overflow: 'hidden',
                                                  textOverflow: 'ellipsis',
                                                  whiteSpace: 'nowrap',
                                                  cursor: 'pointer'
                                                }}
                                              >
                                                {truncatedText}
                                              </Label>
                                            </Box>
                                          </Tooltip>
                                        );
                                      })()}
                                    </TableCell>
                                  ) : (facility_id !== currentFacilityId && material == 0 && rfp == 0) ? (
                                    <TableCell align="center" sx={{ width: '90px', minWidth: '90px' }}>
                                      {console.log('inside of the split status',received_status)}
                                      {(() => {
                                        if (split_status == 0) return null;
                                        const installationCompleteStatus = received_status != 2 ? null : installation_complete_status;
                                        const installationStatus = received_status != 2 ? null : installation_status;
                                        const allInstallationCompleted = received_status != 2 ? 0 : allInstallation_completed ;
                                        const installationAcceptance = received_status != 2 ? null : installation_acceptance;
                                        const projectStatus = received_status != 2 ? details?.proj_status : project_status;
                                        const fromMirror = true
                                        const statusInfo = getStatusColorAndLabel(
                                          split_status,
                                          installationStatus,
                                          allInstallationCompleted,
                                          installationAcceptance,
                                          minPaymentStatus,
                                          details?.job_category_name,
                                          details?.billing_type,
                                          installationCompleteStatus,
                                          details?.noServiceNoTask,
                                          projectStatus,
                                          details?.partial_install,
                                          received_status,
                                          split_mirror_status,
                                          fromMirror
                                        );
                                        const statusText = statusInfo.label.replace('Status: ', '');
                                        const truncatedText = statusText.length > 10 ? statusText.substring(0, 10) + '...' : statusText;

                                        return (
                                          <Tooltip
                                            title={statusText}
                                            enterDelay={300}
                                            leaveDelay={200}
                                          >
                                            <Box sx={{ cursor: 'pointer', display: 'inline-block' }}>
                                              <Label
                                                variant="filled"
                                                color={statusInfo.color}
                                                sx={{
                                                  fontSize: '0.7rem',
                                                  height: '18px',
                                                  minWidth: 'auto',
                                                  maxWidth: '90px',
                                                  overflow: 'hidden',
                                                  textOverflow: 'ellipsis',
                                                  whiteSpace: 'nowrap',
                                                  cursor: 'pointer'
                                                }}
                                              >
                                                {truncatedText}
                                              </Label>
                                            </Box>
                                          </Tooltip>
                                        );
                                      })()}
                                    </TableCell>
                                  ) : (
                                    <TableCell align="center" sx={{ width: '90px', minWidth: '90px' }}>-</TableCell>
                                  )
                                ) : null}
                                <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                  {material === 1 ? (
                                    // For materials, show material_notes  if exists, otherwise product_name
                                     <Box>
                                      <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', color: productTextColor }}>{product_name}</Typography>

                                   { material_notes ? 
                                      <Typography variant='subtitle2' sx={{ fontWeight: 'bold' , mb: 1,  wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-line', color: 'error.main' }}>Note:{" "}{material_notes}</Typography> 
                                    : 
                                     ""}
                                     </Box>
                                  ) : (
                                       // For products, show product_notes if exists, otherwise product_name
                                   <Box>
                                  
                                     <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', color: productTextColor }}>{product_name} {(installation_status && details?.mixed_installation) ? <> {' '}<Label variant="filled" color="warning">{getInstallationStatusLabel(installation_status)}</Label></> : ''}</Typography>

                                   { product_notes ? 
                                      <Typography variant='subtitle2' sx={{ fontWeight: 'bold' , mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-line', color: 'error.main' }}>Note:{" "}{product_notes}</Typography> 
                                    : ""}
                                   </Box>
                                     
                                  )}

                                  {(material === 1 && rfp === 0 && details?.job_category_name != 'Time & Material') && (
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', color: isProductLosingMoney ? theme.palette.error.main : facilityColor }}>
                                      (Addl. Material{val?.stock_type === 1 
                                        ? ' - Finished' 
                                        : val?.stock_type === 2 
                                          ? ` - Partial (${UNITS?.find(u => u.id === val?.convertion_unit)?.short_name || 'Unit'})` 
                                          : ''})
                                    </Typography>
                                  )}
                                  {(material === 1 && rfp === 1 && details?.job_category_name != 'Time & Material') && (
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', color: isProductLosingMoney ? theme.palette.error.main : facilityColor }}>
                                      (Material)
                                    </Typography>
                                  )}
                                </TableCell>
                                    <TableCell sx={{ color: facilityColor }}>
                                    {canShowProductFormulaIcon(val, currentFacilityId, recipe_id) ? (
                                      <IconButton onClick={() => handleOpenProductFormula(recipe_id)}>
                                      <span class="heroicons-solid--beaker"></span>
                                    </IconButton>
                                    ) : '-'}
                                  </TableCell>
                                <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                     {/* <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', color: facilityColor }}>{product_desc ? product_desc : description ? description : '-'}</Typography> */}
                                  <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', color: productTextColor }}>{product_desc ? product_desc : description ? description : '-'}</Typography>
                                </TableCell>
                                
                                {/* {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell sx={{ color: facilityColor }}>{product_notes ? vpt_number : ''}</TableCell> : ''} */}
                                {/* <TableCell align="center">{material === 1 ? '1' : quantity} ({shortUnitName})</TableCell> */}
                                <TableCell align="center" sx={{ color: facilityColor }}>{vpt_number ? vpt_number : '-'}</TableCell>
                                <TableCell align="center" sx={{ color: facilityColor }}>{locationQuantity}</TableCell>
                            
                                {/* Outgoing Percentage column - only show when isSplitOrder is true */}
                                {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && !details?.real_for_parent_facility && userType != 3 && canViewCosts) ? 
                                <TableCell align="center" sx={{ color: facilityColor }}>
                                  {details?.is_split_order && facility_id != currentFacilityId && wholesale_price ? `$${wholesale_price || 0}` : '-'}
                                </TableCell>
                                :''
                                }
                                {/* Incoming Percentage column - only show when isSplitOrder is true */}
                                {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && !details?.real_for_parent_facility && userType != 3 && canViewCosts) ? 
                                <TableCell align="center" sx={{ color: facilityColor }}>
                                  {details?.is_split_order && facility_id != currentFacilityId && incoming_split_percentage ? `${incoming_split_percentage || 0}%` : '-'}
                                </TableCell>
                                :''
                                }
                                {/* <TableCell>${(SPMA ? SPMA - (labourInitial || 0) : 0)?.toFixed(2)}</TableCell> */}
                                {/* <TableCell>${(Number(SPMA) || 0).toFixed(2)}</TableCell> */}
                                {canViewCosts && (
                                <Tooltip title={
                                  details?.is_split_order && facility_id != currentFacilityId && userType !=3 && !isMirrored
                                    ? `Wholesale price  + (Wholesale price  * split markup (${incoming_split_percentage || 0}) / 100)` 
                                    : ""
                                }>
                                  {/* <TableCell align="center" sx={{ color: facilityColor }}>${(Number(actual_retail_price) || (Number(SPMA) || 0)).toFixed(2)}</TableCell> */}
                                  <TableCell align="center" sx={{ color: facilityColor }}>${(Number(SPMA) || 0).toFixed(2)}</TableCell>
                                </Tooltip>
                                )}
                                {/* <TableCell>{locationQuantity}</TableCell> */}
                                {/* <TableCell align="center">{adjustment ? `${adj_value_type ? `+${adjustment}` : `-${adjustment}`}` : '-'}</TableCell> */}
                                {canViewCosts && (markAdjType==1?
                                  // <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                                  <TableCell sx={{ color: facilityColor }}>${
                                    install_cost ?
                                    ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                                    // (((actual_retail_price * (locationQuantity * quantity)) + (adj_value_type ?  +adjustment : -adjustment)) || 0).toFixed(2) :
                                    material === 1 ?
                                    ((SPMA * locationQuantity ) || 0).toFixed(2) :
                                    ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                                    // (((SPMA * (locationQuantity * quantity)) + (adj_value_type ?  +adjustment : -adjustment)) || 0).toFixed(2)
                                    }</TableCell>
                                :
                                  // <TableCell>${((SPMA * (locationQuantity * quantity)) - labourTotal)?.toFixed(2)}</TableCell>
                                  <TableCell sx={{ color: facilityColor }}>${
                                    install_cost ?
                                    ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                                    // (((actual_retail_price * (locationQuantity * quantity)) + (adj_value_type ?  +adjustment : -adjustment)) || 0).toFixed(2) :
                                    material === 1 ?
                                    ((SPMA * locationQuantity ) || 0).toFixed(2) :
                                    ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                                    // (((SPMA * (locationQuantity * quantity)) + (adj_value_type ?  +adjustment : -adjustment)) || 0).toFixed(2)
                                    }</TableCell>
                                )}
                              </TableRow>
                              {/* Labor Install Row (if exists) */}
                              {/* {labourService && (
                                <TableRow>
                                  <TableCell sx={{ pl: 4 }}>{labourService?.name}</TableCell>
                                  <TableCell align="center">N/A</TableCell>
                                  <TableCell>${labourRate?.toFixed(2)}</TableCell>
                                  <TableCell>{labourQty?.toFixed(2)}</TableCell>
                                  <TableCell>${labourTotal?.toFixed(2)}</TableCell>
                                </TableRow>
                              )} */}
                              {install_cost ? (
                                <TableRow sx={installLosingMoneyRowSx || productLosingMoneyRowSx}>
                                  <TableCell sx={{ color: facilityColor }}></TableCell>
                                     {/* {(() => {
                                    const matchingInstallTaxItem = Array.isArray(taxRateData)
                                      ? taxRateData.find(item => 
                                          item.item_name && String(item.item_name).toLowerCase().includes('install')
                                        )
                                      : null;
                                    return (
                                      <TableCell 
                                        align="center" 
                                        sx={{ 
                                          color: matchingInstallTaxItem?.qb_item_taxable ? 'success.main' : 'error.main' 
                                        }}
                                      >
                                        {(isEstimate ? (taxAmount != 0) : (matchingInstallTaxItem && matchingInstallTaxItem?.is_taxable && taxAmount != 0))
                                          ?<><span class="tabler--letter-t-small"></span><br /> <span style={{fontSize:"12px"}}> {getTaxPercent(matchingInstallTaxItem)}%</span></> : '-'}
                                      </TableCell>
                                    );
                                  })()} */}
                                  {(details?.is_split_order && details?.project_category != 15) ? <TableCell align="center" sx={{ color: facilityColor }}></TableCell> : null}
                                  <TableCell sx={{ pl: 4, color: facilityColor }}>
                                    <Typography
                                      sx={
                                        isInstallLosingMoney
                                          ? { color: `${theme.palette.error.main} !important` }
                                          : undefined
                                      }
                                    >
                                      {canViewCosts ? 'Install Price' : 'Installation'}
                                    </Typography>
                                  {  install_notes?<Typography sx={{color: install_notes ?  'error.main' : 'inherit', whiteSpace: 'pre-wrap' }}> Note : {" "}{install_notes ? install_notes : ``}</Typography>:""}
                                    </TableCell>
                                  <TableCell sx={{ color: facilityColor }}>-</TableCell>
                                  <TableCell align="center" sx={{ color: facilityColor }}>-</TableCell>
                                  <TableCell align="center" sx={{ color: facilityColor }}>-</TableCell>
                                  <TableCell align="center" sx={{ color: facilityColor }}>
                                    {install_qty ?? 1}
                                  </TableCell>
                                  {/* Outgoing Percentage column for Install Price - only show when isSplitOrder is true */}
                                  {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && !details?.real_for_parent_facility && userType != 3 && canViewCosts) ?
                                    <TableCell align="center" sx={{ color: facilityColor }}>
                                      {details?.is_split_order && facility_id != currentFacilityId ? '-' : '-'}
                                    </TableCell>
                                    : ''
                                  }
                                  {/* Incoming Percentage column for Install Price - only show when isSplitOrder is true */}
                                  {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && !details?.real_for_parent_facility && userType != 3 && canViewCosts) ?
                                    <TableCell align="center" sx={{ color: facilityColor }}>
                                      {details?.is_split_order && facility_id != currentFacilityId ? '-' : '-'}
                                    </TableCell>
                                    : ''
                                  }
                                  {/* <TableCell align="center" sx={{ color: facilityColor }}>{install_qty || 1}</TableCell> */}
                                  {canViewCosts && (
                                  <>
                                  <TableCell align="center" sx={{ color: facilityColor }}>${install_cost || 0}</TableCell>
                                  {/* <TableCell align="center">-</TableCell> */}
                                  <TableCell>
                                    {/* ${((install_cost || 0) * (locationQuantity || 1) * (quantity || 1)).toFixed(2)} */}
                                    ${((install_cost || 0) * (install_qty ?? 1)).toFixed(2)}
                                  </TableCell>
                                  </>
                                  )}

                                </TableRow>
                              ):''}
                              <TableRow>
                                <TableCell colSpan={
                                  (invoice?.cust_product?.some(item => item.product_notes) ? 8 : 7) +
                                 (details?.is_split_order && details?.origin_facility_id == currentFacilityId && !details?.real_for_parent_facility && userType != 3 ? 2 : 0) +
                                 (details?.is_split_order && details?.project_category != 15 ? 1 : 0)
                                 - hiddenPriceColumnCount
                                }>
                                  <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          )
                        }
                        )}

                      </TableBody>
                    </Table>
                  </TableContainer>
                  </> : null}

{/*below for labour Install */}
                  {/* <Typography variant='h6' sx={{ mt: 2 }}>{(labourInstallService?.length > 0 ) ? ((details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "Services(Labor Install)" : 'Services(Labor Install)') : ""}</Typography>
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      {(labourInstallService?.length > 0 ) &&
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={2}>NAME</TableCell>
                            <TableCell>COST (HOURLY)</TableCell>
                            <TableCell>HOURS</TableCell>
                            <TableCell>TOTAL COST</TableCell>
                          </TableRow>
                        </TableHead>}
                      <TableBody>
                      
                      {labourInstallService?.map((ser) => {
                          console.log('invoiceSelectedServices--@@ 1', ser);
                          return (
                            <TableRow sx={{
                              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            }}>
                              <TableCell colSpan={2}>{ser?.name}-({ser.productName})</TableCell>
                              <TableCell>{ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>
                              <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                              <TableCell>{ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                            </TableRow>
                          )
                        })}
                        </TableBody>
                        </Table>
                        </TableContainer> */}

{/*above  for labour Install */}


                  {/* <Typography variant='h6' sx={{ mt: 2 }}>{(additionalSelectedServices?.length > 0 || cartService?.length > 0 || invoiceSelectedServices?.length > 0) ? ((details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "Additional Services" : 'Services') : ""}</Typography> */}
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      {(additionalSelectedServices?.length > 0 || cartService?.length > 0 || invoiceSelectedServices?.length > 0) &&
                        <TableHead>
                          <TableRow>
                            <TableCell>Sl No.</TableCell>
                            {/* <TableCell></TableCell> */}
                            <TableCell >{(additionalSelectedServices?.length > 0 || cartService?.length > 0 || invoiceSelectedServices?.length > 0) ? ((details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "ADDITIONAL SERVICES" : 'SERVICES') : ""}</TableCell>
                            <TableCell >DESCRIPTION</TableCell>
                            {
                              details?.is_split_order && details?.project_category != 15 && canViewCosts ?
                              <TableCell>WHOLESALE COST</TableCell>
                              : null
                            }
                            {
                              details?.is_split_order && details?.project_category != 15 && canViewCosts ?
                              <TableCell>SPLIT MARKUP</TableCell>
                              : null
                            }
                            {canViewCosts && <TableCell>COST (HOURLY)</TableCell>}
                            <TableCell>HOURS</TableCell>
                            {canViewCosts && <TableCell width={'15%'}>TOTAL COST</TableCell>}
                          </TableRow>
                        </TableHead>}
                      <TableBody>
                        {invoice?.cust_product?.map((val) => {
                          const { vid, product_name, product_price, product_retail_price,material, install_qty,
                            quantity, product_total, discount, unit, unit_qty,markAdjType,install_total,adjustment,locationQuantity,adj_value_type,recipe_id
                          } = val
                          let unitName = UNITS?.filter((item) => item?.id == unit)
                          unitName = unitName[0]?.name
                          let shortUnitName = ''
                          if (unitName == 'Square feet') {
                            shortUnitName = 'Sq ft'
                          } else if (unitName == 'Lineal feet') {
                            shortUnitName = 'Lin ft'
                          } else if (unitName == 'Square Inches') {
                            shortUnitName = 'Sq Inches'
                          } else if (unitName == 'Unit') {
                            shortUnitName = 'Unit'
                          }

                          let SPMA = 0
                        if(markAdjType==2 || markAdjType==3) {
                          SPMA = (product_retail_price || 0) //+ (adjustment ? Number(adjustment) : 0)
                        }else{
                          SPMA = (product_retail_price || 0) + (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)
                        }
                        if(material==1){
                          let newSPMA = Number(SPMA) + (adj_value_type==1 ? Number(adjustment) : -Number(adjustment));
                          console.log('SPMA-material==2',SPMA);
                          SPMA = newSPMA;
                          // console.log('SPMA-material==2-newSPMA',newSPMA);
                          // console.log('SPMA-material==2-SPMA',SPMA);
                          // console.log('SPMA-material==2-adj_value_type',adj_value_type);
                          // console.log('SPMA-material==2-adjustment',adjustment);
                        }else{
                          // console.log('SPMA-material==2-locationQuantity',locationQuantity);
                          // console.log('SPMA-material==2-quantity',quantity);
                        }
                        SPMA = parseFloat(SPMA)?.toFixed(2)  
                        
                        let theSubTotalAmount =0
                        if(markAdjType==1){
                          theSubTotalAmount = product_total
                        }else{
                          if(material==1){
                            theSubTotalAmount = (SPMA * locationQuantity)
                          }else{
                            theSubTotalAmount = (SPMA * (locationQuantity * quantity))
                          }
                        }
                        console.log('SPMA-material==2-theSubTotalAmount',theSubTotalAmount);
                        console.log('SPMA-material==2-theSubTotalAmount==install_total',install_total);
                        console.log('SPMA-material==2-SPMA',SPMA);
                       
                        subTotal += theSubTotalAmount
                        if(install_total && install_total != 0){
                          subTotal += (install_qty == 0 ? 0 : Number(install_total)||0)
                        }
                        console.log("SPMA-material==2-albiin###############theSubTotalAmount", theSubTotalAmount)
                        console.log("SPMA-material==2-albiin###############theSubTotalAmount", subTotal)
                        // console.log('theSubTotalAmount',theSubTotalAmount);
                        // console.log('SPMA',SPMA);
                          return (
                            null
                          )
                        })}
                        {(() => {
                          let serviceIndex = 1;
                          return (
                            <>
                              {invoiceSelectedServices?.map((ser) => {
                                console.log('invoiceSelectedServices--@@', ser);
                                const facility = FacilityTypes.find(
                                  f => Number(f.id) === Number(ser?.facility_id)
                                );
                                const facilityColor = theme.palette[facility?.color]?.main || 'inherit';
                                return (
                                  <TableRow sx={{
                                    borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                  }}>
                                    <TableCell>{serviceIndex++} </TableCell>
                                    {/* {(() => {
                                      const serviceQuickbookId = ser.quickbookId || ser.quickbook_id;
                                      const serviceName = ser.service_name || ser.name;
                                      const matchingProductTaxItem = Array.isArray(taxRateData) && serviceQuickbookId
                                        ? taxRateData.find(item => 
                                            String(item.item_id) === String(serviceQuickbookId) || 
                                            (item.item_name && String(item.item_name).toLowerCase() === String(serviceName).toLowerCase())
                                          )
                                        : Array.isArray(taxRateData)
                                        ? taxRateData.find(item => 
                                            item.item_name && String(item.item_name).toLowerCase() === String(serviceName).toLowerCase()
                                          )
                                        : null;
                                      return (
                                        <TableCell 
                                          align="center" 
                                          sx={{ 
                                            color: matchingProductTaxItem?.qb_item_taxable ? 'success.main' : 'error.main' 
                                          }}
                                        >
                                          {(isEstimate ? (taxAmount != 0) : (matchingProductTaxItem && matchingProductTaxItem?.is_taxable && taxAmount != 0)) ?  <><span class="tabler--letter-t-small"></span><br />  <span style={{fontSize:"12px"}}> {getTaxPercent(matchingProductTaxItem)}%</span></>  : '-'}
                                        </TableCell>
                                      );
                                    })()}
                                     */}
                                   <TableCell> 
                                     <Box>
                                       <Typography sx={{ color: facilityColor }}>
                                         {(ser?.service_name ||ser?.name )}
                                       </Typography>
                                       
                                       {ser?.service_notes && (
                                         <Stack direction="column">
                                           <Typography
                                             variant="body2"
                                             sx={{
                                               wordBreak: 'break-word',
                                               overflowWrap: 'break-word',
                                               color: 'error.main',
                                               whiteSpace: 'pre-line'
                                             }}
                                           >
                                             Note :{ser.service_notes}
                                           </Typography>
                                         </Stack>
                                       )}
                                     </Box>
                                   </TableCell>
                                   <TableCell>
                                     {ser?.service_desc ? (
                                       <Tooltip title={ser.service_desc || ser.description} arrow>
                                         <Typography
                                           variant='body2'
                                           sx={{
                                             wordBreak: 'break-word',
                                             overflowWrap: 'break-word',
                                             color: facilityColor,
                                             whiteSpace: 'nowrap',
                                             overflow: 'hidden',
                                             textOverflow: 'ellipsis',
                                             width: '150px', // Limit the width to 120px
                                             cursor: 'pointer',
                                           }}
                                         >
                                           {ser.service_desc || ser.description}
                                         </Typography>
                                       </Tooltip>
                                     ) : (
                                       '-'
                                     )}
                                   </TableCell>
                                   {
                                     details?.is_split_order && details?.project_category != 15 && canViewCosts ?
                                       <TableCell>{
                                         ser?.facility_id != currentFacilityId ? ser?.costWithOutgoing || 0 : '-'}</TableCell>
                                       : null
                                   } 
                                   {
                                     details?.is_split_order && details?.project_category != 15 && canViewCosts ?
                                       <TableCell>{
                                         ser?.facility_id != currentFacilityId ? `${ser?.incoming_split_percentage ?? 0}%` : '-'}</TableCell>
                                       : null
                                   } 
                              {canViewCosts && <TableCell>${ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>}
                              <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                              {canViewCosts && <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>}
                            </TableRow>
                          )
                        })}

                        {sortAdditionalServicesByIndex(additionalSelectedServices)
                          ?.filter(servItem=>{
                            // if (details?.job_category_name != 'Time & Material' && servItem.labour_cost_service_id == 10) {
                            //   return false;
                            // }
                            return true;
                          })?.map((ser) => {
                            console.log('additionalSelectedServices--', ser);
                            const facility = FacilityTypes.find(
                              f => Number(f.id) === Number(ser?.facility_id)
                            );
                          const facilityColor = theme.palette[facility?.color]?.main || 'inherit';
                          console.log('facilityColor', facilityColor)  
                          return (
                              <TableRow sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                              }}>
                                <TableCell>{serviceIndex++}</TableCell>
                                    {/* {(() => {
                                      const serviceQuickbookId = ser.quickbookId || ser.quickbook_id;
                                      const serviceName = ser.service_name || ser.name;
                                      const matchingProductTaxItem = Array.isArray(taxRateData) && serviceQuickbookId
                                        ? taxRateData.find(item => 
                                            String(item.item_id) === String(serviceQuickbookId) || 
                                            (item.item_name && String(item.item_name).toLowerCase() === String(serviceName).toLowerCase())
                                          )
                                        : Array.isArray(taxRateData)
                                        ? taxRateData.find(item => 
                                            item.item_name && String(item.item_name).toLowerCase() === String(serviceName).toLowerCase()
                                          )
                                        : null;
                                        console.log('matchingProductTaxItem', matchingProductTaxItem);
                                      return (
                                        <TableCell 
                                          align="center" 
                                        >
                                          {(isEstimate ? (taxAmount != 0) : (matchingProductTaxItem && matchingProductTaxItem?.is_taxable && taxAmount != 0)) ?  <><span class="tabler--letter-t-small"></span><br /> <span style={{fontSize:"12px"}}> {getTaxPercent(matchingProductTaxItem)}%</span></>  : '-'}
                                        </TableCell>
                                      );
                                    })()} */}
                                <TableCell > 
                                    <Box>
                                      <Typography sx={{ color: facilityColor }}>
                                        {(ser?.service_name || ser?.name)}{(ser?.installation_status && details?.mixed_installation) ? <> {' '}<Label variant="filled" color="warning">{getInstallationStatusLabel(ser.installation_status)}</Label></> : ''}
                                      </Typography>
                                      
                                      {ser?.service_notes && (
                                        <Stack direction="column">
                                          <Typography
                                            variant="body2"
                                            sx={{
                                              wordBreak: 'break-word',
                                              overflowWrap: 'break-word',
                                              color: 'error.main',
                                              whiteSpace: 'pre-line'
                                            }}
                                          >
                                            Note :{ser.service_notes}
                                          </Typography>
                                        </Stack>
                                      )}
                                    </Box>
                                  </TableCell>
                               
                                <TableCell>
                                  {ser?.service_desc ? (
                                    <Tooltip title={ser.service_desc || ser.description} arrow>
                                      <Typography
                                        variant='body2'
                                        sx={{
                                          wordBreak: 'break-word',
                                          overflowWrap: 'break-word',
                                          color: facilityColor,
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          width: '150px', // Limit the width to 120px
                                          cursor: 'pointer',
                                        }}
                                      >
                                        {ser.service_desc || ser.description}
                                      </Typography>
                                    </Tooltip>
                                  ) : (
                                    '-'
                                  )}
                                </TableCell>
                                  {
                                    details?.is_split_order && details?.project_category != 15 && canViewCosts ?
                                      <TableCell>{
                                        ser?.facility_id != currentFacilityId ? ser?.costWithOutgoing || 0 : '-'}</TableCell>
                                      : null
                                  } 
                                  {
                                    details?.is_split_order && details?.project_category != 15 && canViewCosts ?
                                      <TableCell>{
                                        ser?.facility_id != currentFacilityId ? `${ser?.incoming_split_percentage ?? 0}%` : '-'}</TableCell>
                                      : null
                                  } 
                                {canViewCosts && (
                                <Tooltip 
                                  title={
                                    (details?.is_split_order && details?.project_category != 15 && 
                                      ser.facility_id != currentFacilityId) 
                                      ? `wholesale cost + (wholesale cost * incoming split markup (${ser?.incoming_split_percentage || incomingSplitMarkup || 0}) / 100)`
                                      : ""
                                  }
                                >
                                <TableCell>
                                  ${ser ? ser?.unit_cost?.toFixed(2) : 0}
                                  </TableCell>
                                  </Tooltip>
                                )}
                                <TableCell>{ser ? parseFloat(ser?.quantity)?.toFixed(2) : 0}</TableCell>
                                {canViewCosts && <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>}
                              </TableRow>
                            )
                          }
                        )}

                        {cartService?.map((ser) => {
                          
                          console.log('cartServicecartService', ser)
                          ser.sellingPrice = details?.project_category == 13 ? ser.unit_cost : ser.sellingPrice || ser.unit_cost
                          ser.originalMarkup = details?.project_category == 13 ? 0 :ser.originalMarkup || ser.product_markup || ser.markup
                          const facility = FacilityTypes.find(
                            f => Number(f.id) === Number(ser?.facility_id)
                          );
                          const facilityColor = theme.palette[facility?.color]?.main || 'inherit';
                          return (
                            <TableRow sx={{
                              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            }}>
                              <TableCell>{serviceIndex++}</TableCell>
                              {/* {(() => {
                                const serviceQuickbookId = ser.quickbookId || ser.quickbook_id;
                                const serviceName = ser.service_name || ser.name;
                                const matchingProductTaxItem = Array.isArray(taxRateData) && serviceQuickbookId
                                  ? taxRateData.find(item => 
                                      String(item.item_id) === String(serviceQuickbookId) || 
                                      (item.item_name && String(item.item_name).toLowerCase() === String(serviceName).toLowerCase())
                                    )
                                  : Array.isArray(taxRateData)
                                  ? taxRateData.find(item => 
                                      item.item_name && String(item.item_name).toLowerCase() === String(serviceName).toLowerCase()
                                    )
                                  : null;
                                return (
                                  <TableCell 
                                    align="center" 
                                  >
                                    {(isEstimate ? (taxAmount != 0) : (matchingProductTaxItem && matchingProductTaxItem?.is_taxable && taxAmount != 0)) ?  <><span class="tabler--letter-t-small"></span><br /> <span style={{fontSize:"12px"}}> {getTaxPercent(matchingProductTaxItem)}%</span> </>  : '-'}
                                  </TableCell>
                                );
                              })()} */}
                               <TableCell> 
                                  <Box>
                                    <Typography sx={{ color: facilityColor }}>
                                      {(ser?.name || ser?.service_name)} 
                                    </Typography>
                                    
                                    {ser?.service_notes && (
                                      <Stack direction="column">
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            wordBreak: 'break-word',
                                            overflowWrap: 'break-word',
                                            color: 'error.main',
                                            whiteSpace: 'pre-line'
                                          }}
                                        >
                                          Note :{ser.service_notes}
                                        </Typography>
                                      </Stack>
                                    )}
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  {ser?.service_desc || ser?.description ? (
                                    <Tooltip title={ser.service_desc || ser.description} arrow>
                                      <Typography
                                        variant='body2'
                                        sx={{
                                          wordBreak: 'break-word',
                                          overflowWrap: 'break-word',
                                          color: facilityColor,
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          width: '150px',
                                          cursor: 'pointer',
                                        }}
                                      >
                                        {ser.service_desc || ser.description}
                                      </Typography>
                                    </Tooltip>
                                  ) : (
                                    '-'
                                  )}
                                </TableCell>
                              {canViewCosts && <TableCell> ${((ser.sellingPrice + (ser.sellingPrice * ser.originalMarkup / 100)))?.toFixed(2)}</TableCell>}
                              <TableCell>{ser ? ser?.qty?.toFixed(2) : 0}</TableCell>
                              {canViewCosts && <TableCell> ${(ser.qty * (ser.sellingPrice + (ser.sellingPrice * ser.originalMarkup / 100)))?.toFixed(2)}</TableCell>}
                            </TableRow>
                          )
                        }
                        )}

                        </>
                          )
                        })()}

                        {canViewCosts && (
                        <RowResultStyle>
                          <TableCell colSpan={summaryColSpan} />
                          <TableCell align="right">
                            {/* {details?.project_category !== 11 && ( */}
                              <Typography variant="overline">Product Total</Typography>
                            {/* // )} */}
                          </TableCell>
                          <TableCell align="left" width={10}>
                            {/* {details?.project_category !== 11 && ( */}
                            <Typography variant="overline">
                              {/* ${invoice?.cust_product?.reduce((sum, val) => {
                                const {
                                  product_retail_price = 0,material = 0, adjustment = 0, markAdjType,adj_value_type,
                                  product_total = 0,actual_retail_price,install_cost, locationQuantity = 1, quantity = 1,
                                  services = []
                                } = val;

                                const labourService = services?.find(s => s.labour_cost_service_id === 10);
                                const labourTotal = (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * locationQuantity;
                                console.log('labourTotal', labourTotal)
                                const basePrice = actual_retail_price !== 0 && actual_retail_price != null
                              ? actual_retail_price
                              : product_retail_price;
                                // let SPMA = (markAdjType === 2 || markAdjType === 3)
                                //   ? product_retail_price + Number(adjustment)
                                //   : product_retail_price + ((product_retail_price * Number(adjustment)) / 100);

                                // const effectiveTotal = markAdjType === 1
                                //   ? product_total
                                //   : (SPMA * (locationQuantity * quantity));
                                let SPMA = (markAdjType === 2 || markAdjType === 3)
                                  ? basePrice //+ Number(adjustment)
                                  : basePrice // + ((basePrice * Number(adjustment)) / 100);
                                  if(material==1){
                                    let newSPMA = Number(SPMA) + (adj_value_type==1 ? Number(adjustment) : -Number(adjustment));
                                    SPMA = newSPMA
                                    // console.log('SPMA-material==1',SPMA);
                                    // console.log('SPMA-material==1',newSPMA);
                                    // console.log('SPMA-material==1',adj_value_type);
                                    // console.log('SPMA-material==1',adjustment);
                                  }
                                const effectiveTotal = markAdjType === 1 && material === 0 
                                  // ? product_total
                                  ? (SPMA * (locationQuantity * quantity)) :
                                  material === 1 ? (SPMA * locationQuantity)
                                  : (SPMA * (locationQuantity * quantity)) //+ (adj_value_type ?  +adjustment : -adjustment);
                               
                                return sum + effectiveTotal;
                              }, 0)?.toFixed(2)} */}
                              ${requestInvoiceProductTotalFromRows.toFixed(2)}
                            </Typography>
                            {/* // )} */}
                          </TableCell>
                        </RowResultStyle>
                        )}

                        {canViewCosts && (
                        <RowResultStyle>
                          <TableCell colSpan={summaryColSpan} />
                          <TableCell align="right">
                            <Typography variant="overline">Install Total</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            {/* <Typography variant="overline">
                                ${invoice?.cust_product?.reduce((sum, val) => {
                                  const labourService = val?.services?.find(s => s.labour_cost_service_id === 10);
                                  return sum + (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * (val?.locationQuantity || 1);
                                }, 0)?.toFixed(2)}
                            </Typography> */}
                            <Typography variant="overline">
                              ${(
                                // (invoice?.cust_product?.reduce((sum, val) => {
                                  //   const labourService = val?.services?.find(
                                  //     s => s.labour_cost_service_id === 10
                                  //   );
                                  //   return (
                                  //     sum +
                                  //     (labourService?.service_original_cost || 0) *
                                  //       (labourService?.prQty || 0) *
                                  //       (val?.locationQuantity || 1)
                                  //   );
                                  // }, 0) || 0) +
                                  // (invoice?.cust_product?.reduce((sum, val) => {
                                  //   const installCost = parseFloat(val?.install_cost || 0);
                                  //   const installQty = parseFloat(
                                  //     val?.install_qty ?? val?.install_quantity ?? 1,
                                  //   );

                                  //   if (installCost) {
                                  //     return sum + installCost * installQty;
                                  //   }
                                  //   return sum;
                                  // }, 0) || 0) +
                                  (requestInvoiceInstallTotalFromRows || 0) +
                                  (additionalSelectedServices?.reduce(
                                    (s, x) =>
                                      x.labour_cost_service_id === 10 ? s + (x.total_cost || 0) : s,
                                    0
                                  ) || 0)
                                ).toFixed(2)}
                            </Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}

                         {canViewCosts && (
                         <RowResultStyle>
                          <TableCell colSpan={summaryColSpan} />
                          <TableCell align="right">
                            {/* <Typography variant="overline">{details?.job_category_name != 'Service only' ? 'Additional Labor Cost' : 'Labor Cost'}</Typography> */}
                            {/* <Typography variant="overline">{(details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? 'Additional Services' : 'Services'}</Typography> */}
                            <Typography variant="overline">{(details?.job_category_name != 'Service only') ? 'Additional Services Total' : 'Services Total'}</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            {/* <Typography variant="overline">${details ? details?.labour_cost?.toFixed(2) : 0.00}</Typography> */}
                            <Typography variant="overline">
                              ${(
                                (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                // (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                (additionalSelectedServices?.reduce(
                                    (s, x) =>
                                      x.labour_cost_service_id === 10       // ⬅ skip labour install rows
                                        ? s
                                        : s + (x.total_cost || 0),
                                    0
                                ) || 0) +
                                (cartService?.reduce((s, x) => {
                                  const sp = x.sellingPrice || x.unit_cost || 0;
                                  const markup = x.originalMarkup || x.product_markup || 0;
                                  const final = sp + (sp * markup / 100);
                                  return s + ((x.qty || 0) * final);
                                }, 0) || 0)
                              )?.toFixed(2)}
                            </Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}

                        {canViewCosts && (details?.job_category_name != 'Service only' || subTotal > 0 || (!treatInvoiceAsTimeMaterial && (requestInvoiceCustProductSubtotalForServices || 0) > 0)) && (
                        <RowResultStyle>
                            <TableCell colSpan={summaryColSpan} />
                            <TableCell align="right">
                            <Typography variant="overline">Subtotal</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">
                              ${fUSPrice(
                                (treatInvoiceAsTimeMaterial ? (subTotal || 0) : (requestInvoiceCustProductSubtotalForServices || 0)) +
                                // (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                (cartService?.reduce((s, x) => {
                                  const sp = x.sellingPrice || x.unit_cost || 0;
                                  const markup = x.originalMarkup || x.product_markup || 0;
                                  const final = sp + (sp * markup / 100);
                                  return s + ((x.qty || 0) * final);
                                }, 0) || 0)
                                // +
                                // (invoice?.cust_product?.reduce((sum, val) => {
                                //     const labourService = val?.services?.find(
                                //       s => s.labour_cost_service_id === 10
                                //     );
                                //     return (
                                //       sum +
                                //       (labourService?.service_original_cost || 0) *
                                //         (labourService?.prQty || 0) *
                                //         (val?.locationQuantity || 1)
                                //     )
                                //   }, 0) || 0)
                              )}
                            </Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}

                        {canViewCosts && invoice?.extra_discount > 0 && (
                        <RowResultStyle>
                            <TableCell colSpan={summaryColSpan} />
                            <TableCell align="right">
                            <Typography variant="overline">Discount</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">${invoice ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}

                        {/* {invoice?.tax_amount > 0 && ( */}
                        {canViewCosts && (
                        <RowResultStyleTax>
                          <TableCell colSpan={summaryColSpan} />
                          <TableCell sx={{display:'flex',justifyContent:'right', alignItems:'flex-end'}}>
                          <Stack direction={'row'} alignItems={'center'} spacing={1}>
                          <Box component={'img'} src={AVALARALOGO} sx={{width: 18, height: 18}}/>
                            <Typography variant="overline">Tax</Typography>
                            </Stack>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">${invoice ? invoice?.tax_amount?.toFixed(2) : 0.00}</Typography>
                          </TableCell>
                        </RowResultStyleTax>
                        )}
                        {/* )} */}

                        {canViewCosts && showRushFee && (
                        <RowResultStyle>
                          <TableCell colSpan={summaryColSpan} />
                          <TableCell align="right">
                            <Typography variant="overline">Rush Fee</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">${Number(rushFeeAmount || 0).toFixed(2)}</Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}

                        {canViewCosts && (
                        <RowResultStyle>
                          <TableCell colSpan={summaryColSpan} />
                          <TableCell align="right">
                            <Typography variant="subtitle1"  sx={{ color: displayInvoiceTotal < 0 ? 'red' : 'inherit' }}>Total</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="subtitle1"  sx={{ color: displayInvoiceTotal < 0 ? 'red' : 'inherit' }}>${fUSPrice(displayInvoiceTotal ?? 0)}</Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}

                        {canViewCosts && invoice?.project_category != 13 ? 
                          <>
                            {(userType !=3 && details?.job_category_name != 'Time & Material' && details?.job_category_name != 'No Charge') ?
                            (details?.billing_type ? (
                            <RowResultStyle>
                              <TableCell colSpan={summaryColSpan} />
                              <TableCell align="right" sx={{display:"flex", alignItems: "center",gap: 1}}>
                                <Typography fontSize={"small"} variant="caption"  sx={{ color:  'inherit' }}> (only viewable for admin)</Typography>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>Billing Type</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>{details?.billing_type ? `${details?.billing_type} %` :"Nil"}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            ) : '') :""}
                          {(invoice?.total && details?.billing_type) ?
                            <RowResultStyle>
                              <TableCell colSpan={summaryColSpan} />
                              <TableCell align="right">
                                <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>Minimum Payable Amount</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>${(displayInvoiceTotal && details?.billing_type)? parseFloat((displayInvoiceTotal *details?.billing_type) / 100).toFixed(2) :0.00}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            :""
                            }
                            {calculatedPaidAmount > 0 && (
                            <RowResultStyle>
                                <TableCell colSpan={summaryColSpan} />
                                <TableCell align="right">
                                <Typography variant="subtitle1"  sx={{ color: calculatedPaidAmount < 0 ? 'red' : 'green' }}>Amount Paid</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color: calculatedPaidAmount < 0 ? 'red' : 'green' }}>${calculatedPaidAmount ? parseFloat(calculatedPaidAmount)?.toFixed(2) : 0.00}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            )}
                            {calculatedPaidAmount > 0 && (
                            <RowResultStyle>
                                <TableCell colSpan={summaryColSpan} />
                                <TableCell align="right">
                                <Typography variant="subtitle1"  sx={{ color: calculatedDueAmount <= 0 ? 'inherit' : 'red' }}>Balance Due</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color: calculatedDueAmount <= 0 ? 'inherit' : 'red' }}>${calculatedDueAmount ? parseFloat(calculatedDueAmount <= 0 ? 0.00 : calculatedDueAmount)?.toFixed(2) : 0.00}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            )}
                          </>
                        : ''}
                        </TableBody>
                    </Table>
                  </TableContainer>
                  {(details?.allInstallationCompleted == 1 && !empty(invoice?.note_data)) ? (
                    <>
                      <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>Installation Notes</Typography>
                      <Stack spacing={2}>
                        {invoice?.note_data?.map((val, index) => {
                          const { id, authorized_by, note, timestamp } = val;
                          return (
                            <Paper
                              key={id}
                              elevation={3}
                              sx={{ padding: 2, borderRadius: 2, backgroundColor: 'rgba(145, 158, 171, 0.16)', color: '#ffffff' }}
                            >
                              <Grid container spacing={2}>
                                <Grid item xs={12} sm={8}>
                                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', whiteSpace: 'pre-wrap' }}>
                                    {note}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                                  {/* <Typography variant="body2" sx={{ color: 'primary.light' }}> */}
                                  <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                    Added By: {authorized_by}
                                  </Typography>
                                  <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                    {moment.unix(timestamp).format('MM-DD-YYYY hh:mm:ss A')}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Paper>
                          );
                        })}
                      </Stack>
                    </>
                  ) : ''}
                  </>
                }
              </Box>
            </Stack>
            )
          })()}
          {/* </Scrollbar> */}
        {/* </Grid> */}
        <Stack
          direction={'row'}
          alignItems={'center'}
          spacing={{ xs: 2, sm: 3 }}
          mb={2}
        >
          {/* {empty(quotation) &&
            details?.job_category_name != 'Service only' &&
            details?.job_category_name != 'Time & Material' && ( */}
            {
              !proposalView &&
              <ListSubheader component="div">Designs / Documents</ListSubheader>
            }
            {/* )} */}
            {
          // empty(quotation) &&
            status !== 6 &&
            !user.isVendor && !proposalView &&
            !project &&
            details?.noServiceNoTask == 0 &&
            !isMirrored && details?.for_parent_facility == 0 &&
            !isGroupedInvoiceCombined &&
            // details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material' &&
            !details?.installationStatus &&(
              <LoadingButton
                variant="outlined"
                size="small"
                sx={{ height: 40 }}
                onClick={() => {
                  let salesOrderPermission = !explodedPermissions?.some((permission) => ['Upload Files Sales Order'].includes(permission))
                  let estimatePermission = !explodedPermissions?.some((permission) => ['Upload Files Estimate'].includes(permission))
                  console.log("permission",estimatePermission,salesOrderPermission)
                  if(!isEstimate && salesOrderPermission &&  user?.added_by_client ==1){
                    return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                    
                  }else if(isEstimate && estimatePermission && user?.added_by_client ==1){
                    return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                  }else{
                    fileInputRef.current.click()
                  }
                  }
                 
                }
                loading={progress}
              >
                Upload Designs / Documents
              </LoadingButton>
            )}
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: 'none' }}
            // accept="image/*,application/pdf"
          />
          {!proposalView && (
            <AttachmentDownloadAllButton
              files={(designsForDisplay?.length ? designsForDisplay : designs || []).filter(
                (item) => selectedDesignsInModal.includes(item.id),
              )}
              allFiles={designsForDisplay?.length ? designsForDisplay : designs || []}
              onToggleSelectAll={(checked) => {
                const list = designsForDisplay?.length ? designsForDisplay : designs || []
                setSelectedDesignsInModal(
                  checked ? list.map((item) => item.id).filter(Boolean) : [],
                )
              }}
              label="Download Selected"
              hidden={!canDownloadFiles}
              size="small"
              sx={{ height: 40 }}
            />
          )}
        </Stack>
        {designs && designs?.length && fromProposal &&!proposalView ? (
          //  style={{ width: project ? '150px' :'240px', height: '240px' }}
          <Box
            sx={{ border: '1px solid', borderColor: borderColor, padding: 2 }}
          >
            <Scrollbar sx={{ width: '100%', height: 450 }}>
              <ImageList
                gap={28}
                cols={xs ? 1 : 4}
                sx={{
                  gridTemplateColumns: {
                    xs: 'repeat(1, minmax(0, 1fr)) !important',
                    sm: 'repeat(2, minmax(0, 1fr)) !important',
                    md: 'repeat(4, minmax(0, 1fr)) !important',
                  },
                }}
              >
                {/* <ImageListItem key="Subheader" cols={2}> */}
                {/* </ImageListItem> */}
                {designs?.map((item) => {
                  const { file_type, name, url } = item
                  const _fileExt3 = (name || '').split('.').pop()?.split('?')[0]?.toLowerCase();
                  const isImage =
                    !['eps','ai','ps','psd'].includes(_fileExt3) &&
                    (file_type?.startsWith('image/') || file_type === 'img' || file_type === 'image') &&
                    !['eps','ai','ps','psd','x-eps','x-ai','postscript'].includes((file_type || '').replace('image/','').toLowerCase())
                  const isActualPdf = file_type === 'pdf' || file_type === 'application/pdf' || (name || '').toLowerCase().split('?')[0].endsWith('.pdf')
                  const isGoogleFormat = ['ai', 'eps', 'ps', 'psd', 'tif', 'tiff', 'indd', 'indt'].includes(_fileExt3) || ['x-eps', 'x-ai', 'postscript'].includes((file_type || '').replace('image/','').toLowerCase())
                  const isPdf = !isImage
                  return (
                    <ImageListItem key={item.name} sx={{ position: 'relative', overflow: 'hidden' }}>
                      <Stack
                        sx={{
                          position: 'absolute',
                          zIndex: 9,
                          top: 8,
                          left: 10,
                        }}
                      >
                        {(item.approved === 1 && isImage) ? (
                          <Label
                            variant={'filled'}
                            color={'success'}
                            style={{ color: 'white', height: 20, width: 100 }}
                          >
                            {'Approved'}
                          </Label>
                        ) : item.product_id !== null ? (
                          ''
                        ) : // <Label
                        //   variant={'filled'}
                        //   color={'info'}
                        //   style={{ color: 'white', height: 20 }}
                        // >
                        //   {`Linked with ${item?.product_name}`}
                        // </Label>
                        item.reason ? (
                          <Label
                            variant={'filled'}
                            color={'error'}
                            style={{ color: 'white', height: 20, width: 100 }}
                          >
                            {'Rejected'}
                          </Label>
                        ) : null}
                      </Stack>
                      <Stack
                        sx={{
                          position: 'absolute',
                          zIndex: 9,
                          top: 110,
                          left: 10,
                        }}
                      >
                        {item.approved === 1 ? (
                          // <Box
                          //   sx={{
                          //     position: 'absolute',
                          //     zIndex: 9,
                          //     bottom: 8,
                          //     left: 100,
                          //   }}
                          // >
                          //     <Typography
                          //       fontSize={'0.7rem'}
                          //       variant={'caption'}
                          //       sx={{ color: 'text.primary' }}
                          //     >
                          //       Approved By: {item.approved_by}
                          //     </Typography>

                          // </Box>

                          <Typography
                            sx={{ position: 'absolute', top: 40, zIndex: 100 }}
                          >
                            <Label
                              variant={
                                theme.palette.mode === 'light'
                                  ? 'ghost'
                                  : 'filled'
                              }
                              color="success"
                            >
                              <Tooltip title={item.approved_by}>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    fontSize: '12px',
                                    cursor: 'pointer',
                                    display: 'inline-block',
                                    maxWidth: 150, // Adjust as necessary
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  <span
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    Approved By: {item.approved_by}
                                  </span>
                                </Typography>
                              </Tooltip>
                            </Label>
                          </Typography>
                        ) : item.reason ? (
                          // <Box
                          //   sx={{
                          //     position: 'absolute',
                          //     zIndex: 9,
                          //     bottom: 8,
                          //     left: 100,
                          //   }}
                          // >
                          //   <Typography
                          //     fontSize={'0.7rem'}
                          //     variant={'caption'}
                          //     sx={{ color: 'text.error' }}
                          //   >
                          //     Rejected Reason: {item.reason}
                          //   </Typography>
                          // </Box>
                          <Typography
                            sx={{ position: 'absolute', top: 40, zIndex: 100 }}
                          >
                            <Label
                              variant={
                                theme.palette.mode === 'light'
                                  ? 'ghost'
                                  : 'filled'
                              }
                              color="error"
                            >
                              <Tooltip title={item.reason}>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    fontSize: '12px',
                                    cursor: 'pointer',
                                    display: 'inline-block',
                                    maxWidth: 150, // Adjust as necessary
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  <span
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    Rejected Reason: {item.reason}
                                  </span>
                                </Typography>
                              </Tooltip>
                            </Label>
                          </Typography>
                        ) : (
                          ''
                        )}
                      </Stack>

                      {canDownloadFiles && (
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            zIndex: 10,
                          }}
                        >
                          <AttachmentDownloadIconButton
                            file={{ url: name || url, name: item.name, file_type }}
                            variant="overlay"
                          />
                        </Box>
                      )}

                      {isImage ? (
                        <img
                          srcSet={`${item.name}?w=240&h=240&fit=crop&auto=format&dpr=2 2x`}
                          src={`${item.name}?w=240&h=240&fit=crop&auto=format`}
                          alt={item.title}
                          loading="lazy"
                          // style={{ width: '240px', height: '240px' }}
                        />
                      ) : (
                        <Box display="flex" alignItems="center">
                          {/* PDF Icon Button */}
                          <Tooltip title={isActualPdf ? "View PDF" : "View File"}>
                            <IconButton
                              onClick={() => {
                                setPdfLoading(true);
                                setSelectedPDF(name);
                                setOpenPDFModal(true);
                                setUseOfficeViewer(true); // Reset to try Office viewer first
                             }}
                              aria-label="open pdf"
                              sx={{
                                position: 'absolute',
                                top: 60,
                                right: '50%',
                                zIndex: 200,
                                color: theme.palette.error.main,
                                backgroundColor: theme.palette.text.primary,
                              }}
                            >
                              {isActualPdf ? <PictureAsPdf style={{ fontSize: 40 }} /> : <Description style={{ fontSize: 40 }} />}
                            </IconButton>
                          </Tooltip>

                          {/* Thumbnail: PDF gets iframe preview, other files get a file icon */}
                          {isActualPdf ? (
                            <iframe
                              src={name}
                              title={name}
                              style={{
                                width: project ? '150px' : '240px',
                                height: '240px',
                              }}
                              frameBorder="0"
                            />
                          ) : isGoogleFormat ? (
                            <iframe
                              src={`https://docs.google.com/gview?url=${encodeURIComponent(name)}&embedded=true&chrome=false`}
                              title={name}
                              style={{
                                width: project ? '150px' : '240px',
                                height: '240px',
                                borderRadius: '10px',
                                border: '1px #2f444b solid',
                              }}
                              frameBorder="0"
                              sandbox="allow-scripts allow-same-origin"
                            />
                          ) : (
                            <Box
                              sx={{
                                width: project ? '150px' : '240px',
                                height: '240px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(255,255,255,0.05)',
                                borderRadius: 1,
                                border: '1px dashed rgba(255,255,255,0.2)',
                                gap: 1,
                              }}
                            >
                              <Description style={{ fontSize: 60, color: theme.palette.text.secondary }} />
                              <Typography variant="caption" sx={{ color: theme.palette.text.secondary, textAlign: 'center', px: 1, wordBreak: 'break-all' }}>
                                {name?.split('/').pop() || 'File'}
                              </Typography>
                            </Box>
                          )}
                          <DialogAnimate open={openPDFModal} onClose={() => setOpenPDFModal(false)}>
                            <Card className={classes.dialogContent}>
                              <div style={{width:'90%', display:'flex',justifyContent:'flex-end', marginBottom: '15px',marginLeft:'25px', gap: '10px' }}>
                                    {canDownloadFiles && (
                                      <Tooltip title="Download File">
                                        <Button
                                          variant="outlined"
                                          color="primary"
                                          onClick={() => handleDownloadFile(selectedPDF)}
                                          disabled={!selectedPDF}
                                          startIcon={<GetAppOutlined />}
                                          sx={{
                                            fontSize:'14px'
                                          }}
                                        >
                                          Download
                                        </Button>
                                      </Tooltip>
                                    )}
                                    <Button
                                      variant="outlined"
                                      color="primary"
                                      onClick={() => {
                                        const fileName = selectedPDF?.split('/').pop()?.split('?')[0] || 'File';
                                        openFileInViewer(selectedPDF, {
                                          isActualPdf: isPdfFile(selectedPDF),
                                          isOfficeFile: isOfficeFile(selectedPDF),
                                          isClient,
                                          hideToolbar: true,
                                          fileName,
                                        });
                                      }}
                                      disabled={!selectedPDF}
                                      startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                                      sx={{
                                        fontSize:'14px'
                                      }}
                                    >
                                      View PDF
                                    </Button>
                                </div>
                              {pdfLoading && (
                                <Skeleton variant="rectangular" width="100%" height={500} />
                              )}

                              {(isClient || userType === 3) && useOfficeViewer ? (
                                <iframe
                                  src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`}
                                  title="Selected PDF"
                                  width="100%"
                                  height="500px"
                                  frameBorder="0"
                                  sandbox="allow-scripts allow-same-origin"
                                  style={{ display: pdfLoading ? 'none' : 'block' }}
                                  onLoad={() => setPdfLoading(false)}
                                  onError={() => {
                                    // If Google Docs viewer fails, fallback to direct iframe
                                    setUseOfficeViewer(false);
                                    setPdfLoading(false);
                                  }}
                                />
                              ) : (
                                <iframe
                                  src={selectedPDF}
                                  title="Selected PDF"
                                  width="100%"
                                  height="500px"
                                  frameBorder="0"
                                  style={{ display: pdfLoading ? 'none' : 'block' }}
                                  onLoad={() => setPdfLoading(false)}
                                />
                              )}
                            </Card>
                          </DialogAnimate>
                        </Box>
                      )}
                      <ImageListItemBar
                        sx={{
                          width: mdd
                            ? '92%'
                            : sm
                            ? '20%'
                            : xld
                            ? '70%'
                            : xs
                            ? '35%'
                            : '64%',
                        }}
                        title={item.updated_by}
                        subtitle={moment
                          .unix(item.timestamp)
                          .format('MM/DD/YYYY')}
                        actionIcon={
                          <>
                            {
                              !user.isVendor && !project && ''
                              // <UserMoreMenu
                              //   common={{
                              //     name: (item?.approved !== 1 && item?.product_id !== null) && 'Approve',
                              //     function:
                              //     (item?.approved !== 1 && item?.product_id !== null) ? () => {
                              //       setItemId(item.id)
                              //       setModalClose(true)
                              //       handleUpdateDesign({
                              //         id: item.id,
                              //         // product_id: product.product_id,
                              //         approved: 1,
                              //         reason:null
                              //       })
                              //       // setOpenProductModel(true)
                              //     } : null ,
                              //     Iccon:
                              //     (item?.approved !== 1 && item?.product_id !== null) && (
                              //         <ThumbUpAltOutlined />
                              //       ),
                              //     modalClose: modalClose,
                              //   }}
                              //   linkImageWithTask={{
                              //     name: item?.product_id == null && 'Link with catalog',
                              //     function:
                              //     item?.product_id == null ? () => {

                              //             setItemId(item.id)
                              //             setModalClose(true)
                              //             setOpenProductModel(true)
                              //           } : null ,
                              //     Iccon: item?.product_id == null && (
                              //         <Link />
                              //       ),
                              //     modalClose: modalClose,
                              //   }}

                              //   common2={{
                              //     name: (item?.approved === 1 || (item?.approved === 0 && item?.reason === null)) && 'Reject',
                              //     function:
                              //     (item?.approved === 1 || (item?.approved === 0 && item?.reason === null)) ? () => {
                              //               setItemId(item.id)
                              //               setOpenReasonModal(true)
                              //           } : null ,
                              //     Iccon:
                              //     (item?.approved === 1 || (item?.approved === 0 && item?.reason === null)) && (
                              //         <ThumbDownOffAltOutlined />
                              //       )
                              //       ,
                              //     modalClose: modalClose,
                              //   }}
                              //   //   onDelete={() => handleUpdateDesign({ id: item.id, status: 0 })}
                              //   {...(item.approved === 1
                              //     ? {}
                              //     : {
                              //         onDelete: () =>
                              //           handleUpdateDesign({
                              //             id: item.id,
                              //             status: 0,
                              //           }),
                              //       })}
                              // />
                            }
                          </>
                        }
                      />
                      {openProductModel && itemId === item.id && (
                        <Card
                          sx={{
                            position: 'absolute',
                            zIndex: 10,
                            bottom: 5,
                            left: 5,
                            p: 2,
                          }}
                        >
                          <Stack
                            direction={'row'}
                            justifyContent={'space-between'}
                          >
                            <Typography marginBottom={2} variant="subtitle2">
                              Choose Products
                            </Typography>
                            <CancelOutlined
                              sx={{ cursor: 'pointer' }}
                              onClick={() => {
                                setModalClose(false)
                                setOpenProductModel(false)
                              }}
                            />
                          </Stack>
                          <Divider sx={{ marginBottom: 2 }} />
                          <Stack spacing={1}>
                            {products
                              ?.filter(
                                (prodItem) =>
                                  prodItem?.material === 0 &&
                                  prodItem?.rfp === 0,
                              )
                              ?.map((product) => (
                                <>
                                  <Typography
                                    sx={{ cursor: 'pointer' }}
                                    variant="caption"
                                    onClick={() =>
                                      handleUpdateDesign({
                                        id: item.id,
                                        product_id: product.product_id,
                                        product_name: product.product_name,
                                        // approved: 1,
                                        reason: null,
                                        num:1
                                      })
                                    }
                                  >
                                    {product.product_name}
                                  </Typography>
                                  <Divider />
                                </>
                              ))}
                          </Stack>
                        </Card>
                      )}

                      <Modal
                        open={openReasonModal && itemId === item.id}
                        handleClose={() => {
                          setOpenReasonModal(false)
                        }}
                        modalTitle={`Reason for Design Rejection`}
                      >
                        <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              label="Reason"
                              value={reasonText}
                              onChange={(e) => setReasonText(e.target.value)}
                            />
                            <Box
                              sx={{
                                mt: 3,
                                display: 'flex',
                                justifyContent: 'center',
                                gap: 1,
                              }}
                            >
                              <LoadingButton
                                type="submit"
                                variant="contained"
                                onClick={() =>
                                  handleUpdateDesign({
                                    id: itemId,
                                    product_id: null,
                                    product_name: null,
                                    reason: reasonText,
                                    approved: 0,
                                    num:2
                                  })
                                }
                                // loading={isSubmitting}
                              >
                                {' Save '}
                              </LoadingButton>
                              <Button
                                variant="outlined"
                                type="submit"
                                onClick={() => {
                                  setOpenReasonModal(false)
                                }}
                              >
                                Cancel
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </Modal>
                    </ImageListItem>
                  )
                })}
              </ImageList>
            </Scrollbar>
          </Box>
        ) : (
          ''
        )}

        {designs && designs?.length && !fromProposal ? (
          <Box
            sx={{
              padding: 3,
              border: '1px solid', // ✅ Green border
              borderColor:borderColor,
              borderRadius: 3,
              // backgroundColor: 'rgba(0, 255, 0, 0.05)', // Light green tint for better visibility
            }}
          >
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 3 }}>
              <Typography
                variant="subtitle1"
                sx={{ color: '#ffffff' }}
              >
                Designs
              </Typography>
              {selectedDesignsInModal.length > 0 && (
                <Tooltip title={`Send ${selectedDesignsInModal.length} design${selectedDesignsInModal.length !== 1 ? 's' : ''} to email`}>
                  <Badge badgeContent={selectedDesignsInModal.length} color="error">
                    <IconButton
                      color="primary"
                      onClick={handleSendSelectedDesignsToEmailModal}
                      sx={{
                        backgroundColor: (theme) => theme.palette.primary.main,
                        color: (theme) => theme.palette.primary.contrastText,
                        '&:hover': {
                          backgroundColor: (theme) => theme.palette.primary.dark,
                        },
                      }}
                    >
                      <Icon icon={emailFillIcon} width={24} height={24} />
                    </IconButton>
                  </Badge>
                </Tooltip>
              )}
            </Stack>
            <Scrollbar sx={{ width: '100%', height: 600 }}>
              {' '}
              {/* ✅ Increased height */}
              <ImageList
                sx={{
                  padding: '10px',
                  display: 'grid',
                  gridTemplateColumns: {
                    xs: 'repeat(1, minmax(0, 1fr)) !important',
                    sm: 'repeat(2, minmax(0, 1fr)) !important',
                    md: 'repeat(4, minmax(0, 1fr)) !important',
                  },
                  gap: 28,
                }}
                cols={xs ? 1 : 4}
              >
                                   {/* Sales order attachments---------- */}
                {designsForDisplay?.map((item,index) => {
                  const { file_type, name, location_ids } = item
                  const displayProductNames = item.displayProductNames || item.productNames || []
                  const isGroupDesignLabel = !!item._groupAttachment
                  let filteredProducts =
                    linkTargetType === 'service'
                      ? linkableItemsForPicker?.filter((prodItem) => {
                          const locId = Number(prodItem.request_location_id)
                          if (isUnlinkMode && itemId === item.id) {
                            const linkedLocationIds = item?.location_ids
                              ? item.location_ids
                                  .split(',')
                                  .map((id) => parseInt(id.trim(), 10))
                                  .filter((n) => !isNaN(n))
                              : []
                            return linkedLocationIds.includes(locId)
                          }
                          if (itemId === item.id) {
                            const validPickerIds = new Set(
                              (servicesWithLocation || []).map((row) =>
                                Number(row.request_location_id),
                              ),
                            )
                            const fromLocationIds = item?.location_ids
                              ? item.location_ids
                                  .split(',')
                                  .map((id) => parseInt(id.trim(), 10))
                                  .filter((n) => !isNaN(n))
                              : []
                            const fromLinkedField = item?.linkedLocationIds
                              ? item.linkedLocationIds
                                  .split(',')
                                  .map((id) => parseInt(id.trim(), 10))
                                  .filter((n) => !isNaN(n))
                              : []
                            const alreadyLinked = new Set(
                              [...fromLocationIds, ...fromLinkedField].filter((id) =>
                                validPickerIds.has(id),
                              ),
                            )
                            return !alreadyLinked.has(locId)
                          }
                          return false
                        })
                      : filterLinkableProductsForDesign(item, isUnlinkMode, itemId)
  
                
                  const _fileExt4 = (name || '').split('.').pop()?.split('?')[0]?.toLowerCase();
                  const isImage = !['eps','ai','ps','psd'].includes(_fileExt4) &&
                    (file_type?.startsWith('image/') || file_type === 'img' || file_type === 'image') &&
                    !['eps','ai','ps','psd','x-eps','x-ai','postscript'].includes((file_type || '').replace('image/','').toLowerCase())
                  const isActualPdf = file_type === 'pdf' || file_type === 'application/pdf' || (name || '').toLowerCase().split('?')[0].endsWith('.pdf')
                  const isPdf = !isImage
                  return (
                    <ImageListItem
                      key={item.id || item.name || index}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        maxWidth: '100%',
                        justifySelf: 'stretch',
                        alignSelf: 'start',
                        minHeight: 250,
                        height: 'auto',
                        backgroundColor: 'rgba(0, 0, 0, 0.05)',
                        borderRadius: 2, // ✅ Softer border radius
                        padding: 2,
                        position: 'relative',
                        overflow: 'hidden',
                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', // ✅ Added shadow for better visibility
                        border: '1px solid',
                        borderColor: ((item.approved === 1 && details?.job_category_name !== 'Service only' && isImage) || 
                          (item.approved === 1 && isPdf && (location_ids !== null && location_ids !== '') && details?.job_category_name !== 'Service only')) ? theme.palette.success.main : item.reason ? theme.palette.error.main : theme.palette.info.main,
                      }}
                    >
                      <Stack
                        sx={{
                          position: 'absolute',
                          zIndex: 9,
                          top: 8,
                          left: 10,
                        }}
                      >
                        {((item.approved === 1 && isImage) || 
                          (item.approved === 1 && isPdf && (location_ids !== null && location_ids !== ''))) ? (
                          (location_ids !== null && location_ids !== '') ? (
                            // <Tooltip title={`Linked with ${item?.product_name}`}>
                            <Tooltip
                              title={`Linked with : ${(() => {
                                const linkType = getAttachmentLinkType(item);
                                if (linkType === 'product' && displayProductNames.length > 0) {
                                  if (isGroupDesignLabel) {
                                    return `Group: ${displayProductNames[0]?.product_name || 'Group'}`
                                  }
                                  return displayProductNames
                                    .map((p, idx) => `(${idx + 1}). ${p?.product_notes || p?.product_name}`)
                                    .join(', ')
                                }
                                if (linkType === 'service' && item?.location_ids) {
                                  const ids = item.location_ids.split(',').map(s => parseInt(s.trim(), 10)).filter(Boolean);
                                  const names = ids
                                    .map((id) => servicesWithLocation?.find(x => Number(x.request_location_id) === Number(id))?.product_notes || servicesWithLocation?.find(x => Number(x.request_location_id) === Number(id))?.product_name)
                                    .filter(Boolean);
                                  return names.map((n, index) => `(${index + 1}). ${n}`).join(', ');
                                }
                                return '';
                              })()}`}
                              // title={`Linked with: ${item?.productNames
                              // .map((p, index) => `(${index + 1}). ${p?.product_name}`) // Add index before each product name
                              // .join(', ')}`} // Join all names into a single string
                              arrow
                            >
                              <span>
                                <Label
                                  variant={'filled'}
                                  color={'success'}
                                  style={{ color: 'white', height: 22, width: 200 }}
                                >
                                  {/* Approved */}
                                  {getAttachmentLinkType(item) === 'service'
                                    ? 'Linked with Service & Approved'
                                    : 'Linked with Catalog & Approved'}
                                </Label>
                              </span>
                            </Tooltip>
                          ) : (
                          <Label
                            variant={'filled'}
                            color={'success'}
                            style={{ color: 'white', height: 22, width: 110 }}
                          >
                            Approved
                          </Label>
                        )) :
                        (item?.location_ids && item?.location_ids.length > 0) || displayProductNames.length > 0 ?(
                        // ( location_ids != null ||  location_ids != '') ? (

                          // <Tooltip title={`Linked with : ${item?.productNames.map(p =>p?.product_name)} `} arrow>
                          <Tooltip
                            // title={`Linked with: ${item?.productNames
                            // .map((p, index) => `(${index + 1}). ${p?.product_name}`) // Add index before each product name
                            // .join(', ')}`} // Join all names into a single string

                            title={
                              isGroupDesignLabel
                                ? `Group: ${displayProductNames[0]?.product_name || 'Group'}`
                                : `Linked with: ${displayProductNames
                                    .map((p, idx) => `(${idx + 1}). ${p?.product_name}`)
                                    .join(', ')}`
                            }
                            arrow
                          >

                            <span>
                              <Label
                                variant={'filled'}
                                color={'info'}
                                style={{ color: 'white', height: 20 }}
                              >
                                  {(() => {
                                    if (isGroupDesignLabel) {
                                      const groupTitle =
                                        displayProductNames[0]?.product_name || 'Group'
                                      const label = `Group: ${groupTitle}`
                                      return label.length > 15
                                        ? label.substring(0, 12) + '...'
                                        : label
                                    }
                                    const fullString = displayProductNames
                                      .map((p) => p?.product_name)
                                      .filter(Boolean)
                                      .join(', ')
                                    const prefix = 'Linked with: '
                                    const text = prefix + fullString
                                    return text.length > 15
                                      ? text.substring(0, 12) + '...'
                                      : text
                                  })()}

                                  {/* {`Linked: ${
                                    item?.product_name.length > 15 // Shorten dynamically
                                      ? item?.product_name.substring(0, 12) + '...' // Show first 12 chars + "..."
                                      : item?.product_name
                                  }`} */}
                              </Label>
                            </span>
                          </Tooltip>
                        ) : item.reason ? (
                          <Tooltip title={`Reason : ${item.reason}`}>
                            <span>
                              <Label
                                variant={'filled'}
                                color={'error'}
                                style={{ color: 'white', height: 22, width: 110 }}
                              >
                                Rejected
                              </Label>
                            </span>
                          </Tooltip>
                        ) : null}
                      </Stack>

                      <Box
                        position="relative"
                        sx={{
                          width: '100%',
                          minHeight: 190,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Checkbox
                        disabled={isMirrored}
                          checked={selectedDesignsInModal?.includes(item.id)}
                          onChange={() => {
                            setSelectedDesignsInModal((prev) =>
                              selectedDesignsInModal?.includes(item.id) 
                                ? prev?.filter((n) => n !== item.id) 
                                : [...prev, item.id],
                            )
                          }}
                          onClick={(e) => e.stopPropagation()}
                          sx={{
                            position: 'absolute',
                            top: 8,
                            left: 8,
                            zIndex: 10,
                            color: 'black',
                            backgroundColor: theme.palette.grey.A700,
                            boxShadow: 1,
                          }}
                        />
                        {canDownloadFiles && (
                          <Box
                            sx={{
                              position: 'absolute',
                              top: 8,
                              right: 8,
                              zIndex: 10,
                            }}
                          >
                            <AttachmentDownloadIconButton
                              file={{ url: name, name: item.name, file_type: item.file_type }}
                              variant="overlay"
                            />
                          </Box>
                        )}
                      {/* Image / PDF Preview */}
                      {isImage ? (
                        <a
                          // href={name}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            e.preventDefault();
                            handleImageClick(imageDesigns.findIndex((img) => img.name === name))
                          }}
                        >
                          <Tooltip title="View Design">
                            <img
                              src={name}
                              alt={name}
                              loading="lazy"
                              style={{
                                width: '100%',
                                height: 'auto',
                                maxHeight: '240px',
                                objectFit: 'contain',
                                borderRadius: 8,
                              }}
                            />
                          </Tooltip>
                        </a>
                      ) : (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            position: 'relative',
                            // justifyContent: 'center',
                            // width: '100%',
                            // height: '100%',
                          }}
                        >
                          <Tooltip title={isActualPdf ? "View PDF" : "View File"}>
                            <IconButton
                              onClick={() => {
                                setPdfSecondLoading(true);
                                setSelectedSecondPDF(name);
                                setSelectedPDFItem(item);
                                setOpenPDFSecondModal(true);
                                setUseOfficeViewerSecond(true); // Reset to try Office viewer first
                              }}
                              aria-label="open pdf"
                                sx={{ position:'absolute', 
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                               zIndex: 200,color:theme.palette.error.main, backgroundColor:theme.palette.text.primary }} 
                            >
                              {isActualPdf ? <PictureAsPdf style={{ fontSize: 50, color: 'red' }} /> : <Description style={{ fontSize: 50, color: 'red' }} />}
                              {' '}
                              {/* ✅ Increased size */}
                            </IconButton>
                          </Tooltip>

                          {/* Thumbnail: PDF gets iframe preview, other files get a file icon */}
                          {isActualPdf ? (
                                <iframe
                                  src={name}
                                  title={name}
                              style={{ width: '100%', height: '240px' }}
                                  frameBorder="0"
                                />
                          ) : (() => {
                            const fileName = name?.split('/').pop()?.split('?')[0] || 'File';
                            const fileExt = fileName.split('.').pop()?.toLowerCase();
                            const isOfficeFile = ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExt);
                            // Formats natively renderable in browser
                            const isBrowserRenderable = ['svg','txt','html','htm'].includes(fileExt);
                            // Formats renderable via Google Docs Viewer (includes eps, ai, psd, tiff, etc.)
                            const googleViewerSupportedExt = ['eps','ai','psd','tif','tiff','bmp','ps'];
                            const canUseGoogleViewer = !isOfficeFile && !isBrowserRenderable && googleViewerSupportedExt.includes(fileExt);
                            const googleViewerThumbSrc = `https://docs.google.com/gview?url=${encodeURIComponent(name)}&embedded=true`;
                            
                            if (isOfficeFile) {
                              return (
                                <iframe
                                  src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(name)}`}
                                  title={fileName}
                                  style={{ width: '100%', height: '240px', borderRadius: '4px' }}
                                  frameBorder="0"
                                />
                              );
                            }

                            if (isBrowserRenderable) {
                              return (
                                <iframe
                                  src={name}
                                  title={fileName}
                                  style={{ width: '100%', height: '240px', borderRadius: '4px', pointerEvents: 'none' }}
                                  frameBorder="0"
                                />
                              );
                            }

                            if (canUseGoogleViewer) {
                              return (
                                <Box sx={{ position: 'relative', width: project ? '150px' : '240px', height: '240px' }}>
                                  <iframe
                                    src={googleViewerThumbSrc}
                                    title={fileName}
                                    style={{ width: '100%', height: '100%', borderRadius: '4px', pointerEvents: 'none', border: 'none' }}
                                    frameBorder="0"
                                   sandbox="allow-scripts allow-same-origin" />
                                  {/* Extension badge overlay */}
                                  <Box sx={{
                                    position: 'absolute', bottom: 6, left: '50%', transform: 'translateX(-50%)',
                                    backgroundColor: 'rgba(0,0,0,0.65)', borderRadius: '4px', px: 1, py: 0.25,
                                    pointerEvents: 'none'
                                  }}>
                                    <Typography variant="caption" sx={{ color: '#fff', fontWeight: 'bold', textTransform: 'uppercase', fontSize: 10 }}>
                                      .{fileExt}
                                    </Typography>
                                  </Box>
                                </Box>
                              );
                            }
                            
                            // Fallback: show styled file icon with extension badge
                            return (
                              <Box
                                sx={{
                                  width: project ? '150px' : '240px',
                                  height: '240px',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  backgroundColor: 'rgba(255,255,255,0.05)',
                                  borderRadius: 1,
                                  border: '1px dashed rgba(255,255,255,0.2)',
                                  gap: 1,
                                }}
                              >
                                <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <Description style={{ fontSize: 70, color: theme.palette.text.secondary }} />
                                  <Box sx={{
                                    position: 'absolute',
                                    bottom: 10,
                                    backgroundColor: theme.palette.primary.main,
                                    borderRadius: '3px',
                                    px: 0.6,
                                    py: 0.1,
                                  }}>
                                    <Typography variant="caption" sx={{ color: '#fff', fontWeight: 'bold', textTransform: 'uppercase', fontSize: 9, lineHeight: 1 }}>
                                      {fileExt || 'file'}
                                    </Typography>
                                  </Box>
                                </Box>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, textAlign: 'center', px: 1, wordBreak: 'break-all' }}>
                                  {fileName}
                                </Typography>
                              </Box>
                            );
                          })()}

                          <DialogAnimate open={openPDFSecondModal} onClose={() => setOpenPDFSecondModal(false)}>
                            <Card className={classes.dialogContent}>
                              <div style={{width:'90%', display:'flex',justifyContent:'space-between', marginBottom: '15px',marginLeft:'25px', gap: '10px' }}>
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      onClick={() => handleSendCurrentItemToEmailModal(selectedPDFItem)}
                                      disabled={!selectedPDFItem}
                                      startIcon={<Icon icon={emailFillIcon} width={20} height={20} />}
                                      sx={{
                                        fontSize:'14px'
                                      }}
                                    >
                                      Send to Email
                                    </Button>
                                    <div style={{display:'flex', gap: '10px'}}>
                                      {canDownloadFiles && (
                                        <Tooltip title="Download File">
                                          <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => handleDownloadFile(selectedSecondPDF)}
                                            disabled={!selectedSecondPDF}
                                            startIcon={<GetAppOutlined />}
                                            sx={{
                                              fontSize:'14px'
                                            }}
                                          >
                                            Download
                                          </Button>
                                        </Tooltip>
                                      )}
                                      <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => {
                                          const fileName = selectedSecondPDF?.split('/').pop()?.split('?')[0] || 'File';
                                          openFileInViewer(selectedSecondPDF, {
                                            isActualPdf: isPdfFile(selectedSecondPDF),
                                            isOfficeFile: isOfficeFile(selectedSecondPDF),
                                            isClient,
                                            hideToolbar: true,
                                            fileName,
                                          });
                                        }}
                                        disabled={!selectedSecondPDF}
                                        startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                                        sx={{
                                          fontSize:'14px'
                                        }}
                                      >
                                        {(() => {
                                          const ft = selectedPDFItem?.file_type;
                                          if (ft === 'pdf' || ft === 'application/pdf') return 'View PDF';
                                          if (ft?.startsWith('image/') || ft === 'img' || ft === 'image') return 'View Image';
                                          return 'Open File';
                                        })()}
                                      </Button>
                                    </div>
                                </div>
                              {pdfSecondLoading && (
                                <Skeleton variant="rectangular" width="100%" height={500} />
                              )}

                              {(() => {
                                const ft = selectedPDFItem?.file_type;
                                // Exclude non-browser-renderable image subtypes (eps, ai, ps, psd, etc.)
                                // These have file_type like 'image/eps' or 'image/x-eps' but browsers cannot render them as <img>
                                const _previewFileExt = (selectedSecondPDF || '').split('/').pop()?.split('?')[0]?.split('.').pop()?.toLowerCase();
                                const NON_RENDERABLE_PREVIEW_SUBTYPES = ['eps', 'ai', 'ps', 'psd', 'x-eps', 'x-ai', 'postscript'];
                                const isNonRenderableImageSubtype =
                                  NON_RENDERABLE_PREVIEW_SUBTYPES.includes(_previewFileExt) ||
                                  NON_RENDERABLE_PREVIEW_SUBTYPES.includes((ft || '').replace('image/', '').toLowerCase());
                                const selectedIsImage = !isNonRenderableImageSubtype && (ft?.startsWith('image/') || ft === 'img' || ft === 'image');
                                const selectedIsPdf = ft === 'pdf' || ft === 'application/pdf';

                                if (selectedIsImage) {
                                  return (
                                    <img
                                      src={selectedSecondPDF}
                                      alt="Selected file"
                                      style={{ maxWidth: '100%', maxHeight: '500px', objectFit: 'contain', display: pdfSecondLoading ? 'none' : 'block' }}
                                      onLoad={() => setPdfSecondLoading(false)}
                                    />
                                  );
                                }

                                if (selectedIsPdf) {
                                  return (isClient || userType === 3) && useOfficeViewerSecond ? (
                                    <iframe
                                      src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedSecondPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`}
                                      title="Selected PDF"
                                      width="100%"
                                      height="500px"
                                      frameBorder="0"
                                      sandbox="allow-scripts allow-same-origin"
                                      style={{ display: pdfSecondLoading ? 'none' : 'block' }}
                                      onLoad={() => setPdfSecondLoading(false)}
                                      onError={() => {
                                        // If Google Docs viewer fails, fallback to direct iframe
                                        setUseOfficeViewerSecond(false);
                                        setPdfSecondLoading(false);
                                      }}
                                    />
                                  ) : (
                                    <iframe
                                      src={selectedSecondPDF}
                                      title="Selected PDF"
                                      width="100%"
                                      height="500px"
                                      frameBorder="0"
                                      style={{ display: pdfSecondLoading ? 'none' : 'block' }}
                                      onLoad={() => setPdfSecondLoading(false)}
                                    />
                                  );
                                }

                                // Other file types — smart multi-strategy viewer
                                const fileName = selectedSecondPDF?.split('/').pop()?.split('?')[0] || 'File';
                                const fileExt = fileName.split('.').pop()?.toLowerCase();
                                const isOfficeFile = ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExt);
                                // Formats that browsers can render natively inside an iframe
                                const isBrowserRenderable = ['svg','txt','html','htm'].includes(fileExt);
                                // Graphic formats best served via Google Docs Viewer
                                const googleViewerFormats = ['eps','ai','psd','tif','tiff','bmp','ps','indd','indt'];
                                const officeViewerSrc = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(selectedSecondPDF)}`;
                                const googleViewerSrc = `https://docs.google.com/gview?url=${encodeURIComponent(selectedSecondPDF)}&embedded=true`;
                                return (
                                  <Box sx={{ width: '100%' }}>
                                    {isOfficeFile ? (
                                      // Microsoft Office Online Viewer — works for xls, doc, ppt, csv etc.
                                      <iframe
                                        src={officeViewerSrc}
                                        title={fileName}
                                        width="100%"
                                        height="500px"
                                        frameBorder="0"
                                        style={{ display: pdfSecondLoading ? 'none' : 'block' }}
                                        onLoad={() => setPdfSecondLoading(false)}
                                        onError={() => setPdfSecondLoading(false)}
                                      />
                                    ) : isBrowserRenderable ? (
                                      // Direct iframe for formats browsers can render natively
                                      <iframe
                                        src={selectedSecondPDF}
                                        title={fileName}
                                        width="100%"
                                        height="500px"
                                        frameBorder="0"
                                        style={{ display: pdfSecondLoading ? 'none' : 'block' }}
                                        onLoad={() => setPdfSecondLoading(false)}
                                        onError={() => setPdfSecondLoading(false)}
                                      />
                                    ) : (isOfficeFile || googleViewerFormats.includes(fileExt) || !isBrowserRenderable) ? (
                                      // Google Docs Viewer — handles .eps, .ai, .psd, .ps and many other graphic/design formats
                                      <Box sx={{ width: '100%', position: 'relative' }}>
                                        <iframe
                                          src={googleViewerSrc}
                                          title={fileName}
                                          width="100%"
                                          height="500px"
                                          frameBorder="0"
                                          style={{ display: pdfSecondLoading ? 'none' : 'block', border: 'none' }}
                                          sandbox="allow-scripts allow-same-origin"
                                          onLoad={() => setPdfSecondLoading(false)}
                                          onError={() => setPdfSecondLoading(false)}
                                        />
                                        {/* Fallback message shown only while loading */}
                                        {pdfSecondLoading && (
                                          <Box sx={{
                                            display: 'flex', flexDirection: 'column', alignItems: 'center',
                                            justifyContent: 'center', height: '500px', gap: 2
                                          }}>
                                            <Description style={{ fontSize: 64, color: '#888' }} />
                                            <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
                                              Loading preview for <strong>.{fileExt}</strong> file…
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: 'text.disabled', textAlign: 'center' }}>
                                              If preview doesn't load, use "Open File" to download and view locally.
                                            </Typography>
                                          </Box>
                                        )}
                                      </Box>
                                    ) : (
                                      // Last-resort fallback
                                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '500px', gap: 2 }}>
                                        <Description style={{ fontSize: 64, color: '#888' }} />
                                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                          Preview not available for <strong>.{fileExt}</strong> files.
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: 'text.disabled' }}>
                                          Use "Open File" button above to download and view this file.
                                        </Typography>
                                      </Box>
                                    )}
                                  </Box>
                                );
                              })()}
                            </Card>
                          </DialogAnimate>
                        </Box>
                      )}

                      {/* File Info Bar */}
                      <ImageListItemBar
                        // title={item.updated_by}
                        subtitle={
                          isPdf && !isMirrored && !details?.installationStatus ? (
                            <Stack direction="column" alignItems="flex-start">
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                justifyContent="space-between"
                                width="100%"
                              >
                                <Typography variant="caption">
                                  {moment.unix(item.timestamp).format('MM/DD/YYYY')}
                                </Typography>
                                {!isClient && !(user.isVendor && project) && (((item?.approved !== 1 && (isImage || isPdf)) || (isPdf && item?.approved === 1 && (location_ids === null || location_ids === '')) || (item?.approved === 1 && (location_ids !== null && location_ids !== '') && (isImage || isPdf)) || (!isImage && !isPdf))|| details?.job_category_name == 'Service only' ) && !details?.installationStatus && !isMirrored && (
                              <UserMoreMenu
                                common={{
                                  name:
                                    item?.approved !== 1 && details?.job_category_name !== 'Service only' &&
                                    (item?.location_ids !== null &&  item?.location_ids !== '') && !isEstimate &&
                                    // item?.product_id !== null &&
                                    'Approve',
                                  function:
                                    item?.approved !== 1 &&
                                    (item?.location_ids !== null &&  item?.location_ids !== '')
                                    // item?.product_id !== null
                                      ? () => {
                                          setItemId(item.id)
                                          setModalClose(true)
                                          handleUpdateDesign({
                                            id: item.id,
                                            // product_id: product.product_id,
                                            approved: 1,
                                            reason: null,
                                            num:3
                                          })
                                          // setOpenProductModel(true)
                                        }
                                      : null,
                                  Iccon: item?.approved !== 1 &&
                                    // item?.product_id !== null && (
                                      (item?.location_ids !== null &&  item?.location_ids !== '') &&(
                                      <ThumbUpAltOutlined />
                                    ),
                                  modalClose: modalClose,
                                }}
                                linkImageWithTask={
                                  productsWithLocation?.length > 0 && item?.product_id === null && !isClient ? {
                                    name:
                                      item?.product_id == null && item.reason==null &&
                                      (item?.location_ids === null || item?.location_ids === '') &&
                                      (isImage || isPdf)
                                      ? 'Link with catalog'
                                      : '',
                                    function:
                                      item?.product_id == null && (item?.location_ids === null || item?.location_ids === '') && (isImage || isPdf)
                                        ? () => {
                                          let estimatePermission = explodedPermissions?.some((permission) => ['Link With Catalog Estimate Designs'].includes(permission))
                                          let salesOrderPermission = explodedPermissions?.some((permission) => ['Link With Catalog Sales Order Designs'].includes(permission))
                                          if(isEstimate && !estimatePermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                          }else if(isRequest && !salesOrderPermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                          }
                                          
                                            setItemId(item.id)
                                            setModalClose(true)
                                            setOpenProductModel(true)
                                            setIsUnlinkMode(false)
                                            setLinkTargetType('product')
                                            initializeSelectedProducts(item);
                                          }
                                        : null,
                                    Iccon: item?.product_id == null && (item?.location_ids === null || item?.location_ids === '') && <Link />,
                                    modalClose: modalClose,
                                  } : null
                                }
                                linkImageWithService={
                                  servicesWithLocation?.length > 0 && item?.product_id === null && !isClient ? {
                                    name:
                                      item?.product_id == null && item.reason==null &&
                                      (item?.location_ids === null || item?.location_ids === '') &&
                                      (isImage || isPdf)
                                      ? 'Link with service'
                                      : '',
                                    function:
                                      item?.product_id == null && (item?.location_ids === null || item?.location_ids === '') && (isImage || isPdf)
                                        ? () => {
                                          let estimatePermission = explodedPermissions?.some((permission) => ['Link With Catalog Estimate Designs'].includes(permission))
                                          let salesOrderPermission = explodedPermissions?.some((permission) => ['Link With Catalog Sales Order Designs'].includes(permission))
                                          if(isEstimate && !estimatePermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                                          }else if(isRequest && !salesOrderPermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                                          }
                                          setItemId(item.id)
                                          setModalClose(true)
                                          setOpenProductModel(true)
                                          setIsUnlinkMode(false)
                                          setLinkTargetType('service')
                                          initializeSelectedProducts(item);
                                        }
                                        : null,
                                    Iccon: item?.product_id == null && (item?.location_ids === null || item?.location_ids === '') && <Link />,
                                    modalClose: modalClose,
                                  } : null
                                }
                                unlinkImageWithTask={
                                  (item?.location_ids !== null && item?.location_ids !== '') && !isClient ? {
                                    name:
                                      (item?.location_ids !== null && item?.location_ids !== '') &&
                                      (isImage || isPdf) && getAttachmentLinkType(item) === 'product'
                                      ? 'Unlink with catalog'
                                      : '',
                                    function:
                                      (item?.location_ids !== null && item?.location_ids !== '') && (isImage || isPdf) && getAttachmentLinkType(item) === 'product'
                                        ? () => {
                                          let estimatePermission = explodedPermissions?.some((permission) => ['Link With Catalog Estimate Designs'].includes(permission))
                                          let salesOrderPermission = explodedPermissions?.some((permission) => ['Link With Catalog Sales Order Designs'].includes(permission))
                                          if(isEstimate && !estimatePermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                          }else if(isRequest && !salesOrderPermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                          }
                                          
                                            setItemId(item.id)
                                            setModalClose(true)
                                            setOpenProductModel(true)
                                            setIsUnlinkMode(true)
                                            setLinkTargetType('product')
                                            initializeSelectedProducts(item);
                                          }
                                        : null,
                                    Iccon: (item?.location_ids !== null && item?.location_ids !== '') && <Link />,
                                    modalClose: modalClose,
                                  } : null
                                }
                                unlinkImageWithService={
                                  (item?.location_ids !== null && item?.location_ids !== '') && !isClient ? {
                                    name:
                                      (item?.location_ids !== null && item?.location_ids !== '') &&
                                      (isImage || isPdf) && getAttachmentLinkType(item) === 'service'
                                      ? 'Unlink with service'
                                      : '',
                                    function:
                                      (item?.location_ids !== null && item?.location_ids !== '') && (isImage || isPdf) && getAttachmentLinkType(item) === 'service'
                                        ? () => {
                                          let estimatePermission = explodedPermissions?.some((permission) => ['Link With Catalog Estimate Designs'].includes(permission))
                                          let salesOrderPermission = explodedPermissions?.some((permission) => ['Link With Catalog Sales Order Designs'].includes(permission))
                                          if(isEstimate && !estimatePermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                                          }else if(isRequest && !salesOrderPermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                                          }
                                          setItemId(item.id)
                                          setModalClose(true)
                                          setOpenProductModel(true)
                                          setIsUnlinkMode(true)
                                          setLinkTargetType('service')
                                          initializeSelectedProducts(item);
                                        }
                                        : null,
                                    Iccon: (item?.location_ids !== null && item?.location_ids !== '') && <Link />,
                                    modalClose: modalClose,
                                  } : null
                                }
                                common2={{
                                  name:
                                    (item?.approved === 1 ||
                                      (item?.approved === 0 &&
                                        item?.reason === null)) &&
                                        details?.job_category_name !== 'Service only' &&
                                        (item?.location_ids === null || item?.location_ids === '') &&
                                        // !isEstimate &&
                                        (isImage || isPdf)
                                      ? 'Reject'
                                      : '',
                                  function:
                                    (item?.approved === 1 ||
                                    (item?.approved === 0 &&
                                      item?.reason === null)) &&
                                      (item?.location_ids === null || item?.location_ids === '') &&
                                      (isImage || isPdf)
                                      ? () => {
                                        let estimatePermission = explodedPermissions?.some((permission) => ['Reject Estimate Designs'].includes(permission))
                                        let salesOrderPermission = explodedPermissions?.some((permission) => ['Reject Sales Order Designs'].includes(permission))
                                     
                                        if(isEstimate && !estimatePermission && !isAdminUser (userType)){
                                          return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                        }else if(isRequest && !salesOrderPermission &&  !isAdminUser (userType)){
                                          return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                        }
                                          setItemId(item.id)
                                          setOpenReasonModal(true)
                                        }
                                      : null,
                                  Iccon: (item?.approved === 1 ||
                                    (item?.approved === 0 &&
                                      item?.reason === null)) &&
                                    (item?.location_ids === null || item?.location_ids === '') && (
                                    <ThumbDownOffAltOutlined />
                                  ),
                                  modalClose: modalClose,
                                }}
                                //   onDelete={() => handleUpdateDesign({ id: item.id, status: 0 })}
                                {...(((item.approved === 1 && isImage && details?.job_category_name !== 'Service only') || 
                                      (item.approved === 1 && isPdf && (location_ids !== null && location_ids !== '') && details?.job_category_name !== 'Service only'))
                                  ? {}
                                  : {
                                      onDelete: () =>{
                                        let estimatePermission = explodedPermissions?.some((permission) => ['Delete Estimate Designs / Documents'].includes(permission))
                                        let salesOrderPermission = explodedPermissions?.some((permission) => ['Delete Sales Order Designs / Documents'].includes(permission))
                                        if(isEstimate && !estimatePermission &&  !isAdminUser (userType)){
                                          return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                        }else if(isRequest && !salesOrderPermission &&  !isAdminUser (userType)){
                                          return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                        }
                                        handleUpdateDesign({
                                          id: item.id,
                                          status: 0,
                                          num:4
                                        })},
                                    })}
                              />
                            )}
                              </Stack>
                              {isActualPdf && (
                              <Accordion
                                    elevation={0}
                                    sx={{
                                      bgcolor: 'transparent',
                                      pr: 1.5,
                                      '&:before': { display: 'none' },
                                      color: 'inherit',
                                      width: '100%',
                                      m: 0,
                                      '&.Mui-expanded': {
                                        m: 0,
                                      },
                                    }}
                                  >
                                    <AccordionSummary
                                      expandIcon={
                                        <ExpandMoreIcon sx={{ fontSize: 18, color: 'inherit' }} />
                                      }
                                      sx={{
                                        minHeight: '18px',
                                        px: 0,
                                        '&.Mui-expanded': {
                                          minHeight: '18px',
                                        },
                                        '& .MuiAccordionSummary-content': {
                                          margin: 0,
                                        },
                                        '& .MuiAccordionSummary-content.Mui-expanded': {
                                          margin: 0,
                                        },
                                      }}
                                    >
                                      {isActualPdf && (
                                        <Typography variant="caption">Edit PDF</Typography>
                                      )}
                                      {!isActualPdf && !isImage && (
                                        <Typography variant="caption">Edit File</Typography>
                                      )}
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ p: 0, pt: 1, pb: 0.5 }}>
                                      <Stack direction="row" width="100%" spacing={1} sx={{ flexDirection: 'row' }}>
                                        <Button
                                          size="small"
                                          variant="contained"
                                          color="primary"
                                          fullWidth
                                          onClick={() => {
                                            setSelectedPDFForEdit({ url: name, item: item });
                                            setOpenPDFEditor(true);
                                          }}
                                          startIcon={<EditIcon sx={{ fontSize: 11 }} />}
                                          sx={{ textTransform: 'none', boxShadow: 'none', fontSize: '11px' }}
                                        >
                                          Edit
                                        </Button>
                                        {/* <Button
                                          size="small"
                                          variant="outlined"
                                          color="inherit"
                                          onClick={() => handleDownloadEditedPdf(item.id)}
                                          sx={{ textTransform: 'none', fontSize: '11px' }}
                                        >
                                          Download Edited PDF
                                        </Button> */}
                                      </Stack>
                                    </AccordionDetails>
                                  </Accordion>
                              )}
                          </Stack>
                          ) : (
                            <Typography variant="caption">
                              {moment.unix(item.timestamp).format('MM/DD/YYYY')}
                            </Typography>
                          )
                        }
                        sx={{
                          backgroundColor: 'rgba(0, 0, 0, 0.6)',
                          fontSize: '14px', // ✅ Slightly increased font size
                          borderRadius: 2,
                          overflow: 'hidden',
                        }}
                        actionIcon={
                          !isPdf && (
                          <>
                            {!isClient && !(user.isVendor && project) && (((item?.approved !== 1 && (isImage || isPdf)) || (isPdf && item?.approved === 1 && (location_ids === null || location_ids === '')) || (item?.approved === 1 && (location_ids !== null && location_ids !== '') && (isImage || isPdf)) || (!isImage && !isPdf))|| details?.job_category_name == 'Service only' ) && !details?.installationStatus && !isMirrored && !splitIntiator && (
                              <UserMoreMenu
                                common={{
                                  name:
                                    item?.approved !== 1 && details?.job_category_name !== 'Service only' &&
                                    (item?.location_ids !== null &&  item?.location_ids !== '') && !isEstimate &&
                                    // item?.product_id !== null &&
                                    'Approve',
                                  function:
                                    item?.approved !== 1 &&
                                    (item?.location_ids !== null &&  item?.location_ids !== '')
                                    // item?.product_id !== null
                                      ? () => {
                                          setItemId(item.id)
                                          setModalClose(true)
                                          handleUpdateDesign({
                                            id: item.id,
                                            // product_id: product.product_id,
                                            approved: 1,
                                            reason: null,
                                            num:3
                                          })
                                          // setOpenProductModel(true)
                                        }
                                      : null,
                                  Iccon: item?.approved !== 1 &&
                                    // item?.product_id !== null && (
                                      (item?.location_ids !== null &&  item?.location_ids !== '') &&(
                                      <ThumbUpAltOutlined />
                                    ),
                                  modalClose: modalClose,
                                }}
                                linkImageWithTask={
                                  productsWithLocation?.length > 0 && item?.product_id === null && !isClient ? {
                                    name:
                                      item?.product_id == null && item.reason==null &&
                                      (item?.location_ids === null || item?.location_ids === '') &&
                                      // !isEstimate &&
                                      (isImage || isPdf)
                                      ? 'Link with catalog'
                                      : '',
                                    function:
                                      item?.product_id == null && (item?.location_ids === null || item?.location_ids === '') && (isImage || isPdf)
                                        ? () => {
                                          let estimatePermission = explodedPermissions?.some((permission) => ['Link With Catalog Estimate Designs'].includes(permission))
                                          let salesOrderPermission = explodedPermissions?.some((permission) => ['Link With Catalog Sales Order Designs'].includes(permission))
                                          if(isEstimate && !estimatePermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                          }else if(isRequest && !salesOrderPermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                          }
                                          
                                            setItemId(item.id)
                                            setModalClose(true)
                                            setOpenProductModel(true)
                                            setIsUnlinkMode(false)
                                            setLinkTargetType('product')
                                            initializeSelectedProducts(item);
                                          }
                                        : null,
                                    Iccon: item?.product_id == null && (item?.location_ids === null || item?.location_ids === '') && <Link />,
                                    modalClose: modalClose,
                                  } : null
                                }
                                linkImageWithService={
                                  servicesWithLocation?.length > 0 && item?.product_id === null && !isClient ? {
                                    name:
                                      item?.product_id == null && item.reason==null &&
                                      (item?.location_ids === null || item?.location_ids === '') &&
                                      (isImage || isPdf)
                                      ? 'Link with service'
                                      : '',
                                    function:
                                      item?.product_id == null && (item?.location_ids === null || item?.location_ids === '') && (isImage || isPdf)
                                        ? () => {
                                          let estimatePermission = explodedPermissions?.some((permission) => ['Link With Catalog Estimate Designs'].includes(permission))
                                          let salesOrderPermission = explodedPermissions?.some((permission) => ['Link With Catalog Sales Order Designs'].includes(permission))
                                          if(isEstimate && !estimatePermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                                          }else if(isRequest && !salesOrderPermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                                          }
                                          setItemId(item.id)
                                          setModalClose(true)
                                          setOpenProductModel(true)
                                          setIsUnlinkMode(false)
                                          setLinkTargetType('service')
                                          initializeSelectedProducts(item);
                                        }
                                        : null,
                                    Iccon: item?.product_id == null && (item?.location_ids === null || item?.location_ids === '') && <Link />,
                                    modalClose: modalClose,
                                  } : null
                                }
                                unlinkImageWithTask={
                                  (item?.location_ids !== null && item?.location_ids !== '') && !isClient ? {
                                    name:
                                      (item?.location_ids !== null && item?.location_ids !== '') &&
                                      (isImage || isPdf) && getAttachmentLinkType(item) === 'product'
                                      ? 'Unlink with catalog'
                                      : '',
                                    function:
                                      (item?.location_ids !== null && item?.location_ids !== '') && (isImage || isPdf) && getAttachmentLinkType(item) === 'product'
                                        ? () => {
                                          let estimatePermission = explodedPermissions?.some((permission) => ['Link With Catalog Estimate Designs'].includes(permission))
                                          let salesOrderPermission = explodedPermissions?.some((permission) => ['Link With Catalog Sales Order Designs'].includes(permission))
                                          if(isEstimate && !estimatePermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                          }else if(isRequest && !salesOrderPermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                          }
                                          
                                            setItemId(item.id)
                                            setModalClose(true)
                                            setOpenProductModel(true)
                                            setIsUnlinkMode(true)
                                            setLinkTargetType('product')
                                            initializeSelectedProducts(item);
                                          }
                                        : null,
                                    Iccon: (item?.location_ids !== null && item?.location_ids !== '') && <Link />,
                                    modalClose: modalClose,
                                  } : null
                                }
                                unlinkImageWithService={
                                  (item?.location_ids !== null && item?.location_ids !== '') && !isClient ? {
                                    name:
                                      (item?.location_ids !== null && item?.location_ids !== '') &&
                                      (isImage || isPdf) && getAttachmentLinkType(item) === 'service'
                                      ? 'Unlink with service'
                                      : '',
                                    function:
                                      (item?.location_ids !== null && item?.location_ids !== '') && (isImage || isPdf) && getAttachmentLinkType(item) === 'service'
                                        ? () => {
                                          let estimatePermission = explodedPermissions?.some((permission) => ['Link With Catalog Estimate Designs'].includes(permission))
                                          let salesOrderPermission = explodedPermissions?.some((permission) => ['Link With Catalog Sales Order Designs'].includes(permission))
                                          if(isEstimate && !estimatePermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                                          }else if(isRequest && !salesOrderPermission &&  !isAdminUser (userType)){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                                          }
                                          setItemId(item.id)
                                          setModalClose(true)
                                          setOpenProductModel(true)
                                          setIsUnlinkMode(true)
                                          setLinkTargetType('service')
                                          initializeSelectedProducts(item);
                                        }
                                        : null,
                                    Iccon: (item?.location_ids !== null && item?.location_ids !== '') && <Link />,
                                    modalClose: modalClose,
                                  } : null
                                }
                                common2={{
                                  name:
                                    (item?.approved === 1 ||
                                      (item?.approved === 0 &&
                                        item?.reason === null)) &&
                                        details?.job_category_name !== 'Service only' &&
                                        (item?.location_ids === null || item?.location_ids === '') &&
                                        // !isEstimate &&
                                        (isImage || isPdf)
                                      ? 'Reject'
                                      : '',
                                  function:
                                    (item?.approved === 1 ||
                                    (item?.approved === 0 &&
                                      item?.reason === null)) &&
                                      (item?.location_ids === null || item?.location_ids === '') &&
                                      (isImage || isPdf)
                                      ? () => {
                                        let estimatePermission = explodedPermissions?.some((permission) => ['Reject Estimate Designs'].includes(permission))
                                        let salesOrderPermission = explodedPermissions?.some((permission) => ['Reject Sales Order Designs'].includes(permission))
                                     
                                        if(isEstimate && !estimatePermission && !isAdminUser (userType)){
                                          return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                        }else if(isRequest && !salesOrderPermission &&  !isAdminUser (userType)){
                                          return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                        }
                                          setItemId(item.id)
                                          setOpenReasonModal(true)
                                        }
                                      : null,
                                  Iccon: (item?.approved === 1 ||
                                    (item?.approved === 0 &&
                                      item?.reason === null)) &&
                                    (item?.location_ids === null || item?.location_ids === '') && (
                                    <ThumbDownOffAltOutlined />
                                  ),
                                  modalClose: modalClose,
                                }}
                                //   onDelete={() => handleUpdateDesign({ id: item.id, status: 0 })}
                                {...(((item.approved === 1 && isImage && details?.job_category_name !== 'Service only') || 
                                      (item.approved === 1 && isPdf && (location_ids !== null && location_ids !== '') && details?.job_category_name !== 'Service only'))
                                  ? {}
                                  : {
                                      onDelete: () =>{
                                        let estimatePermission = explodedPermissions?.some((permission) => ['Delete Estimate Designs / Documents'].includes(permission))
                                        let salesOrderPermission = explodedPermissions?.some((permission) => ['Delete Sales Order Designs / Documents'].includes(permission))
                                        if(isEstimate && !estimatePermission &&  !isAdminUser (userType)){
                                          return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                        }else if(isRequest && !salesOrderPermission &&  !isAdminUser (userType)){
                                          return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                        }
                                        handleUpdateDesign({
                                          id: item.id,
                                          status: 0,
                                          num:4
                                        })},
                                    })}
                              />
                            )}
                          </>
                          )
                        }
                      />
                      {openProductModel && itemId === item.id && (
                        <Card
                          sx={{
                            position: 'absolute',
                            zIndex: 1000,
                            bottom: 5,
                            left: 5,
                            p: 2,
                            top: 20,
                            // minHeight: '550px',
                            maxHeight: '600px',  
                            overflowY: 'auto',
                            width:"250px"
                          }}
                          // sx={{
                          //   position: 'absolute',
                          //   zIndex: 10,
                          //   bottom: 'auto',
                          //   left: 'auto',
                          //   top: 50,       
                          //   boxShadow: 3,
                          //   p: 2,
                          //   borderRadius: 2, 
                          // }}
                        >
                          <Stack
                            direction={'row'}
                            justifyContent={'space-between'}
                            
                          >
                            <Typography  variant="subtitle2">
                              {linkTargetType === 'service'
                                ? (isUnlinkMode ? 'Unlink Service' : 'Choose Service')
                                : (isUnlinkMode ? 'Unlink Product' : 'Choose Product')}
                            </Typography>
                            <CancelOutlined
                              sx={{ cursor: 'pointer' }}
                              onClick={() => {
                                setModalClose(false)
                                setOpenProductModel(false)
                                setSelectedProducts([])
                                setIsUnlinkMode(false)
                              }}
                            />
                          </Stack>

                          {filteredProducts?.length > 0 ? (
      //                     <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
      // <Checkbox
      //   checked={selectedProducts.length === products.length} // If all selected, check "Select All"
      //   indeterminate={selectedProducts.length > 0 && selectedProducts.length < products.length} // Partial selection indicator
      //   onChange={(e) => {
      //     if (e.target.checked) {
      //       // Select all
      //       setSelectedProducts(
      //         products.map((product) => ({
      //           id: item.id,
      //           // product_id: product.product_id,
      //           product_id: product.id,
      //           product_name: product.product_name,
      //           reason: null,
      //           num: 5,
      //         }))
      //       );
      //     } else {
      //       // Deselect all
      //       setSelectedProducts([]);
      //     }
      //   }}
      // />
      // <Typography variant="caption" sx={{ cursor: 'pointer' }} onClick={() => {
      //   // Toggle Select All when clicking text
      //   const allSelected = selectedProducts.length === products.length;
      //   setSelectedProducts(
      //     allSelected
      //       ? []
      //       : products.map((product) => ({
      //           id: item.id,
      //           product_id: product.product_id,
      //           product_name: product.product_name,
      //           reason: null,
      //           num: 5,
      //         }))
      //   );
      // }}>
      //   Select All
      // </Typography>
      //                      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
  <Checkbox
    checked={
      filteredProducts.length > 0 &&
      countSelectedPickerRows(filteredProducts, item) === filteredProducts.length
    }
    indeterminate={
      countSelectedPickerRows(filteredProducts, item) > 0 &&
      countSelectedPickerRows(filteredProducts, item) < filteredProducts.length
    }
    onChange={(e) => {
      if (e.target.checked) {
        setSelectedProducts(flatMapPickerRowsToSelectedEntries(filteredProducts, item))
      } else {
        setSelectedProducts([])
      }
    }}
  />
  <Typography
    variant="caption"
    sx={{ cursor: 'pointer' }}
    onClick={() => {
      const selectedRowCount = countSelectedPickerRows(filteredProducts, item)
      const allSelected =
        filteredProducts.length > 0 && selectedRowCount === filteredProducts.length
      setSelectedProducts(
        allSelected
          ? []
          : flatMapPickerRowsToSelectedEntries(filteredProducts, item),
      )
    }}
  >
    Select All
  </Typography>
</Box>

                          ) : null}
    <Divider sx={{ marginBottom: 2 }} />

    <Stack spacing={1}>
    {filteredProducts.length > 0 ? (
      filteredProducts.map((product) => {
       
        return(
        
        <Box
          key={
            product._isGroupPickerRow
              ? `group-${product._groupId}`
              : product.request_location_id
          }
          sx={{ display: "flex", alignItems: "center" }}
        >
          <Checkbox
            checked={isPickerRowFullySelected(product)}
            indeterminate={
              product._isGroupPickerRow &&
              getPickerRowLocationIds(product).some((locId) =>
                selectedProducts.some((p) => Number(p.product_id) === locId),
              ) &&
              !isPickerRowFullySelected(product)
            }
            onChange={(e) => handleCheckboxChange(product, e.target.checked, item)}
          />
          <Typography 
            sx={{ 
              cursor: 'pointer',
              color: unlinkedLocations.some(loc => loc.id === product.request_location_id) ? 'error.main' : 'inherit'
           , color: product.product_notes ? 'error.main' : 'inherit' }} 
            variant="caption"
          >
            {product.product_notes ? product.product_notes : product.product_name}
          </Typography>
          <Divider />
        </Box>
      )})
    ) : (
      // ✅ Display "No Products Left" message when no products are available
      <Typography variant="body2" sx={{ textAlign: "center", color: "gray", padding: 2 }}>
        {linkTargetType === 'service' ? 'No services left' : 'No products left'}
      </Typography>
    )}
  </Stack>

  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
    <Button
                              onClick={() => {
                                setModalClose(false);
                                setOpenProductModel(false);
                                setSelectedProducts([]);
                                setIsUnlinkMode(false);
                              }}
                              sx={{ color: "red" }}
                            >
                              Close
                            </Button>
                            {filteredProducts?.length > 0 && (
                              <Button 
                                onClick={() => {
                                  if (isUnlinkMode) {
                                    handleUnlinkSubmit(item.id, item);
                                  } else {
                                    handleSubmit(item.id);
                                  }
                                }}
                                disabled={selectedProducts?.length === 0}
                              >
                                {isUnlinkMode ? 'Unlink' : 'Submit'}
                              </Button>
                            )}
  </Box>
                          

                        </Card>
                      )}

                      <Modal
                        open={openReasonModal && itemId === item.id}
                        handleClose={() => {
                          setOpenReasonModal(false)
                        }}
                        modalTitle={`Reason for Design Rejection`}
                      >
                        <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              label="Reason"
                              value={reasonText}
                              onChange={(e) => setReasonText(e.target.value)}
                            />
                            <Box
                              sx={{
                                mt: 3,
                                display: 'flex',
                                justifyContent: 'center',
                                gap: 1,
                              }}
                            >
                              <LoadingButton
                                type="submit"
                                variant="contained"
                                onClick={() =>
                                  handleUpdateDesign({
                                    id: itemId,
                                    product_id: null,
                                    product_name: null,
                                    reason: reasonText,
                                    approved: 0,
                                    num:6
                                  })
                                }
                                // loading={isSubmitting}
                              >
                                {' Save '}
                              </LoadingButton>
                              <Button
                                variant="outlined"
                                type="submit"
                                onClick={() => {
                                  setOpenReasonModal(false)
                                }}
                              >
                                Cancel
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </Modal>
                      </Box>
                    </ImageListItem>
                  )
                })}


              </ImageList>
            </Scrollbar>
          </Box>
        ) : (
          ''
        )}
        <Modal width={1000}
              open={openImageModal}
              handleClose={() => {
                setOpenImageModal(false);
              }}
              modalTitle={'Designs'}
              >
            <Stack spacing={2}>
              <Box display="flex" justifyContent="flex-end" mb={1} gap={1}>
                {canDownloadFiles && (
                  <Tooltip title="Download">
                    <IconButton
                      onClick={() => handleDownloadImage(imageDesigns[currentImageIndex]?.name)}
                      disabled={!imageDesigns || imageDesigns.length === 0 || currentImageIndex === null}
                      color="primary"
                    >
                      <GetAppOutlined />
                    </IconButton>
                  </Tooltip>
                )}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleSendCurrentItemToEmailModal(imageDesigns[currentImageIndex])}
                  disabled={!imageDesigns || imageDesigns.length === 0 || currentImageIndex === null || isMirrored}
                  startIcon={<Icon icon="eva:email-fill" width={20} height={20} />}
                >
                  Send to Email
                </Button>
              </Box>
              <div
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                display: 'flex',
                gap:'1rem',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
            <IconButton
              onClick={handlePrevious}
              disabled={currentImageIndex === 0}
              sx={{
                opacity: currentImageIndex === 0 ? 0.3 : 1,
                pointerEvents: currentImageIndex === 0 ? 'none' : 'auto',
              }}
            >
              <Icon
                icon={arrowLeftOutlined}
                width={24}
                height={24}
                color="#006097"
              />
            </IconButton>

            <Box
            component={'div'} 
              style={{
                width: '500px',
                height: '500px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 8,
                overflow:'hidden'
              }}
            >
              <img
                src={imageDesigns[currentImageIndex]?.name}
                alt={`Image ${currentImageIndex + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 8,
                }}
              />
            </Box>
            <IconButton
              onClick={handleNext}
              disabled={currentImageIndex === imageDesigns.length - 1}
              sx={{
                opacity: currentImageIndex === imageDesigns.length - 1 ? 0.3 : 1,
                pointerEvents: currentImageIndex === imageDesigns.length - 1 ? 'none' : 'auto',
              }}
            >
              <Icon
                icon={arrowRightOutlined}
                width={24}
                height={24}
                color="#006097"
              />
            </IconButton>
          </div>
            </Stack>
        </Modal>
        
        {/* previos code */}
        {/* {designs?.length && !fromProposal ? (
          <Box>
            <Scrollbar sx={{ width: '100%', height: 550 }}>
              <ImageList
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  paddingLeft: '2px',
                  paddingRight: '2px',
                }}
                gap={mdd ? 8 : xld ? 12 : 8}
                cols={mdd ? 3 : xld ? 3 : xs ? 1 : 3}
              >
                {designs?.map((item) => {
                  const { file_type, name, url } = item
                  const _fileExt5 = (name || '').split('.').pop()?.split('?')[0]?.toLowerCase();
                  const isImage =
                    !['eps','ai','ps','psd'].includes(_fileExt5) &&
                    (file_type?.startsWith('image/') || file_type === 'img')
                  const isActualPdf = file_type === 'pdf' || file_type === 'application/pdf'
                  const isPdf = !isImage
                  return (
                    <ImageListItem key={item.name}>
                      <Stack
                        sx={{
                          position: 'absolute',
                          zIndex: 9,
                          top: 8,
                          left: 10,
                        }}
                      >
                        {item.approved === 1 ? (
                          <Label
                            variant={'filled'}
                            color={'success'}
                            style={{ color: 'white', height: 20, width: 100 }}
                          >
                            {'Approved'}
                          </Label>
                        ) : item.product_id !== null ? (
                          ''
                        ) : item.reason ? (
                          <Label
                            variant={'filled'}
                            color={'error'}
                            style={{ color: 'white', height: 20, width: 100 }}
                          >
                            {'Rejected'}
                          </Label>
                        ) : null}
                      </Stack>
                      <Stack
                        sx={{
                          position: 'absolute',
                          zIndex: 9,
                          top: 110,
                          left: 10,
                        }}
                      >
                        {item.approved === 1 ? (
                          <Typography
                            sx={{ position: 'absolute', top: 40, zIndex: 100 }}
                          >
                            <Label
                              variant={
                                theme.palette.mode === 'light'
                                  ? 'ghost'
                                  : 'filled'
                              }
                              color="success"
                            >
                              <Tooltip title={item.approved_by}>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    fontSize: '12px',
                                    cursor: 'pointer',
                                    display: 'inline-block',
                                    maxWidth: 150, // Adjust as necessary
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  <span
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    Approved By: {item.approved_by}
                                  </span>
                                </Typography>
                              </Tooltip>
                            </Label>
                          </Typography>
                        ) : item.reason ? (
                          <Typography
                            sx={{ position: 'absolute', top: 40, zIndex: 100 }}
                          >
                            <Label
                              variant={
                                theme.palette.mode === 'light'
                                  ? 'ghost'
                                  : 'filled'
                              }
                              color="error"
                            >
                              <Tooltip title={item.reason}>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    fontSize: '12px',
                                    cursor: 'pointer',
                                    display: 'inline-block',
                                    maxWidth: 150,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  <span
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    Rejected Reason: {item.reason}
                                  </span>
                                </Typography>
                              </Tooltip>
                            </Label>
                          </Typography>
                        ) : (
                          ''
                        )}
                      </Stack>

                      {isImage ? (
                        <img
                          srcSet={`${item.name}?w=240&h=240&fit=crop&auto=format&dpr=2 2x`}
                          src={`${item.name}?w=240&h=240&fit=crop&auto=format`}
                          alt={item.title}
                          loading="lazy"
                        />
                      ) : (
                        <Box display="flex" alignItems="center">
                          <iframe
                            src={isActualPdf ? name : `https://docs.google.com/gview?url=${encodeURIComponent(name)}&embedded=true`}
                            type={isActualPdf ? "application/pdf" : undefined}
                            width="100%"
                            height="400px"
                            style={{
                              borderRadius: '10px',
                              border: '1px #2f444b solid',
                            }}
                           sandbox="allow-scripts allow-same-origin" />
                        </Box>
                      )}

                      {openProductModel && itemId === item.id && (
                        <Card
                          sx={{
                            position: 'absolute',
                            zIndex: 10,
                            bottom: 5,
                            left: 5,
                            p: 2,
                          }}
                        >
                          <Stack
                            direction={'row'}
                            justifyContent={'space-between'}
                          >
                            <Typography marginBottom={2} variant="subtitle2">
                              Choose Product
                            </Typography>
                            <CancelOutlined
                              sx={{ cursor: 'pointer' }}
                              onClick={() => {
                                setModalClose(false)
                                setOpenProductModel(false)
                              }}
                            />
                          </Stack>
                          <Divider sx={{ marginBottom: 2 }} />
                          <Stack spacing={1}>
                            {products
                              ?.filter(
                                (prodItem) =>
                                  prodItem?.material === 0 &&
                                  prodItem?.rfp === 0,
                              )
                              ?.map((product) => (
                                <>
                                  <Typography
                                    sx={{ cursor: 'pointer' }}
                                    variant="caption"
                                    onClick={() =>
                                      handleUpdateDesign({
                                        id: item.id,
                                        product_id: product.product_id,
                                        product_name: product.product_name,
                                        // approved: 1,
                                        reason: null,
                                      })
                                    }
                                  >
                                    {product.product_name}
                                  </Typography>
                                  <Divider />
                                </>
                              ))}
                          </Stack>
                        </Card>
                      )}

                      <Modal
                        open={openReasonModal && itemId === item.id}
                        handleClose={() => {
                          setOpenReasonModal(false)
                        }}
                        modalTitle={`Reason for Design Rejection`}
                      >
                        <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              label="Reason"
                              value={reasonText}
                              onChange={(e) => setReasonText(e.target.value)}
                            />
                            <Box
                              sx={{
                                mt: 3,
                                display: 'flex',
                                justifyContent: 'center',
                                gap: 1,
                              }}
                            >
                              <LoadingButton
                                type="submit"
                                variant="contained"
                                onClick={() =>
                                  handleUpdateDesign({
                                    id: itemId,
                                    reason: reasonText,
                                    approved: 0,
                                  })
                                }
                                // loading={isSubmitting}
                              >
                                {' Save '}
                              </LoadingButton>
                              <Button
                                variant="outlined"
                                type="submit"
                                onClick={() => {
                                  setOpenReasonModal(false)
                                }}
                              >
                                Cancel
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </Modal>
                    </ImageListItem>
                  )
                })}
              </ImageList>
            </Scrollbar>
          </Box>
        ) : (
          ''
        )} */}
      </Stack>

      {/* {(user.isVendor === null || user.isVendor === 0) &&(
      <AccountNotifications
                  isRequest={true}
                  requestId={requestId}
                 signAgreements={signAgreements}
                 customTemplate={customTemplate}
                 questionnaireTemplate={questionnaireTemplate}
                 allDataEmpty={allDataEmpty}
                 portfolio={portfolio}
                 updatingFunction={fetchRequestDetails}/>
                 )} */}

      {/* 🚀 PROGRESS TRACKING: Socket progress modal */}
      {/* <RequestProgressModal
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        requestData={progressRequestData}
        onSocketReady={setSocketReady}
        heading={progressHeading}
      /> */}
            <ViewProductFormulaModal
        open={openProductFormulaModal}
        onClose={() => setOpenProductFormulaModal(false)}
        formulaId={selectedProductFormulaId}
        user={user}
        explodedPermissions={explodedPermissions}
        hideEdit={true}
      />
      <RequestProgressModal
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        requestData={progressRequestData}
        heading={progressHeading}
        message="We're processing your request. Please wait..."
      />
      <SendDesignsEmailModal
        open={openEmailModal}
        onClose={() => setOpenEmailModal(false)}
        selectedDesigns={emailModalDesigns}
        requestId={requestId}
        onSuccess={handleEmailSent}
        pageType="request"
      />
      {selectedPDFForEdit && (
        <PDFEditor
          open={openPDFEditor}
          onClose={() => {
            setOpenPDFEditor(false);
            setSelectedPDFForEdit(null);
          }}
          pdfUrl={selectedPDFForEdit.url}
          attachmentId={selectedPDFForEdit.item?.id}
          requestId={requestId || details?.id}
          documentSource="request"
          onSaveSuccess={fetchRequestDetails}
        />
      )}
    </Card>
  )
}